export const deparments = [
  {
    codigo: 15,
    nombre: 'LIMA',
    provincias: [
      {
        codigo: 1502,
        nombre: 'BARRANCA',
        distritos: [
          {
            codigo: 150201,
            nombre: 'BARRANCA',
            ubigeo: 150201
          },
          {
            codigo: 150202,
            nombre: 'PARAMONGA',
            ubigeo: 150202
          },
          {
            codigo: 150203,
            nombre: 'PATIVILCA',
            ubigeo: 150203
          },
          {
            codigo: 150204,
            nombre: 'SUPE',
            ubigeo: 150204
          },
          {
            codigo: 150205,
            nombre: 'SUPE PUERTO',
            ubigeo: 150205
          }
        ]
      },
      {
        codigo: 1503,
        nombre: 'CAJATAMBO',
        distritos: [
          {
            codigo: 150301,
            nombre: 'CAJATAMBO',
            ubigeo: 150301
          },
          {
            codigo: 150302,
            nombre: 'COPA',
            ubigeo: 150302
          },
          {
            codigo: 150303,
            nombre: 'GORGOR',
            ubigeo: 150303
          },
          {
            codigo: 150304,
            nombre: 'HUANCAPON',
            ubigeo: 150304
          },
          {
            codigo: 150305,
            nombre: 'MANAS',
            ubigeo: 150305
          }
        ]
      },
      {
        codigo: 1504,
        nombre: 'CANTA',
        distritos: [
          {
            codigo: 150402,
            nombre: 'ARAHUAY',
            ubigeo: 150402
          },
          {
            codigo: 150401,
            nombre: 'CANTA',
            ubigeo: 150401
          },
          {
            codigo: 150403,
            nombre: 'HUAMANTANGA',
            ubigeo: 150403
          },
          {
            codigo: 150404,
            nombre: 'HUAROS',
            ubigeo: 150404
          },
          {
            codigo: 150405,
            nombre: 'LACHAQUI',
            ubigeo: 150405
          },
          {
            codigo: 150406,
            nombre: 'SAN BUENAVENTUR',
            ubigeo: 150406
          },
          {
            codigo: 150407,
            nombre: 'SANTA ROSA DE Q',
            ubigeo: 150407
          }
        ]
      },
      {
        codigo: 1505,
        nombre: 'CAÑETE',
        distritos: [
          {
            codigo: 150502,
            nombre: 'ASIA',
            ubigeo: 150502
          },
          {
            codigo: 150503,
            nombre: 'CALANGO',
            ubigeo: 150503
          },
          {
            codigo: 150504,
            nombre: 'CERRO AZUL',
            ubigeo: 150504
          },
          {
            codigo: 150505,
            nombre: 'CHILCA',
            ubigeo: 150505
          },
          {
            codigo: 150506,
            nombre: 'COAYLLO',
            ubigeo: 150506
          },
          {
            codigo: 150507,
            nombre: 'IMPERIAL',
            ubigeo: 150507
          },
          {
            codigo: 150508,
            nombre: 'LUNAHUANA',
            ubigeo: 150508
          },
          {
            codigo: 150509,
            nombre: 'MALA',
            ubigeo: 150509
          },
          {
            codigo: 150510,
            nombre: 'NUEVO IMPERIAL',
            ubigeo: 150510
          },
          {
            codigo: 150511,
            nombre: 'PACARAN',
            ubigeo: 150511
          },
          {
            codigo: 150512,
            nombre: 'QUILMANA',
            ubigeo: 150512
          },
          {
            codigo: 150513,
            nombre: 'SAN ANTONIO',
            ubigeo: 150513
          },
          {
            codigo: 150514,
            nombre: 'SAN LUIS',
            ubigeo: 150514
          },
          {
            codigo: 150501,
            nombre: 'SAN VICENTE DE',
            ubigeo: 150501
          },
          {
            codigo: 150515,
            nombre: 'SANTA CRUZ DE F',
            ubigeo: 150515
          },
          {
            codigo: 150516,
            nombre: 'ZUÑIGA',
            ubigeo: 150516
          }
        ]
      },
      {
        codigo: 1506,
        nombre: 'HUARAL',
        distritos: [
          {
            codigo: 150602,
            nombre: 'ATAVILLOS ALTO',
            ubigeo: 150602
          },
          {
            codigo: 150603,
            nombre: 'ATAVILLOS BAJO',
            ubigeo: 150603
          },
          {
            codigo: 150604,
            nombre: 'AUCALLAMA',
            ubigeo: 150604
          },
          {
            codigo: 150605,
            nombre: 'CHANCAY',
            ubigeo: 150605
          },
          {
            codigo: 150601,
            nombre: 'HUARAL',
            ubigeo: 150601
          },
          {
            codigo: 150606,
            nombre: 'IHUARI',
            ubigeo: 150606
          },
          {
            codigo: 150607,
            nombre: 'LAMPIAN',
            ubigeo: 150607
          },
          {
            codigo: 150608,
            nombre: 'PACARAOS',
            ubigeo: 150608
          },
          {
            codigo: 150609,
            nombre: 'SAN MIGUEL DE A',
            ubigeo: 150609
          },
          {
            codigo: 150610,
            nombre: 'SANTA CRUZ DE A',
            ubigeo: 150610
          },
          {
            codigo: 150611,
            nombre: 'SUMBILCA',
            ubigeo: 150611
          },
          {
            codigo: 150612,
            nombre: 'VEINTISIETE DE',
            ubigeo: 150612
          }
        ]
      },
      {
        codigo: 1507,
        nombre: 'HUAROCHIRI',
        distritos: [
          {
            codigo: 150702,
            nombre: 'ANTIOQUIA',
            ubigeo: 150702
          },
          {
            codigo: 150703,
            nombre: 'CALLAHUANCA',
            ubigeo: 150703
          },
          {
            codigo: 150704,
            nombre: 'CARAMPOMA',
            ubigeo: 150704
          },
          {
            codigo: 150705,
            nombre: 'CHICLA',
            ubigeo: 150705
          },
          {
            codigo: 150706,
            nombre: 'CUENCA',
            ubigeo: 150706
          },
          {
            codigo: 150707,
            nombre: 'HUACHUPAMPA',
            ubigeo: 150707
          },
          {
            codigo: 150708,
            nombre: 'HUANZA',
            ubigeo: 150708
          },
          {
            codigo: 150709,
            nombre: 'HUAROCHIRI',
            ubigeo: 150709
          },
          {
            codigo: 150710,
            nombre: 'LAHUAYTAMBO',
            ubigeo: 150710
          },
          {
            codigo: 150711,
            nombre: 'LANGA',
            ubigeo: 150711
          },
          {
            codigo: 150712,
            nombre: 'LARAOS',
            ubigeo: 150712
          },
          {
            codigo: 150713,
            nombre: 'MARIATANA',
            ubigeo: 150713
          },
          {
            codigo: 150701,
            nombre: 'MATUCANA',
            ubigeo: 150701
          },
          {
            codigo: 150714,
            nombre: 'RICARDO PALMA',
            ubigeo: 150714
          },
          {
            codigo: 150715,
            nombre: 'SAN ANDRES DE T',
            ubigeo: 150715
          },
          {
            codigo: 150716,
            nombre: 'SAN ANTONIO',
            ubigeo: 150716
          },
          {
            codigo: 150717,
            nombre: 'SAN BARTOLOME',
            ubigeo: 150717
          },
          {
            codigo: 150718,
            nombre: 'SAN DAMIAN',
            ubigeo: 150718
          },
          {
            codigo: 150719,
            nombre: 'SAN JUAN DE IRI',
            ubigeo: 150719
          },
          {
            codigo: 150720,
            nombre: 'SAN JUAN DE TAN',
            ubigeo: 150720
          },
          {
            codigo: 150721,
            nombre: 'SAN LORENZO DE',
            ubigeo: 150721
          },
          {
            codigo: 150722,
            nombre: 'SAN MATEO',
            ubigeo: 150722
          },
          {
            codigo: 150723,
            nombre: 'SAN MATEO DE OT',
            ubigeo: 150723
          },
          {
            codigo: 150724,
            nombre: 'SAN PEDRO DE CA',
            ubigeo: 150724
          },
          {
            codigo: 150725,
            nombre: 'SAN PEDRO DE HU',
            ubigeo: 150725
          },
          {
            codigo: 150726,
            nombre: 'SANGALLAYA',
            ubigeo: 150726
          },
          {
            codigo: 150727,
            nombre: 'SANTA CRUZ DE C',
            ubigeo: 150727
          },
          {
            codigo: 150728,
            nombre: 'SANTA EULALIA',
            ubigeo: 150728
          },
          {
            codigo: 150729,
            nombre: 'SANTIAGO DE ANC',
            ubigeo: 150729
          },
          {
            codigo: 150730,
            nombre: 'SANTIAGO DE TUN',
            ubigeo: 150730
          },
          {
            codigo: 150731,
            nombre: 'SANTO DOMINGO D',
            ubigeo: 150731
          },
          {
            codigo: 150732,
            nombre: 'SURCO',
            ubigeo: 150732
          }
        ]
      },
      {
        codigo: 1508,
        nombre: 'HUAURA',
        distritos: [
          {
            codigo: 150802,
            nombre: 'AMBAR',
            ubigeo: 150802
          },
          {
            codigo: 150803,
            nombre: 'CALETA DE CARQU',
            ubigeo: 150803
          },
          {
            codigo: 150804,
            nombre: 'CHECRAS',
            ubigeo: 150804
          },
          {
            codigo: 150801,
            nombre: 'HUACHO',
            ubigeo: 150801
          },
          {
            codigo: 150805,
            nombre: 'HUALMAY',
            ubigeo: 150805
          },
          {
            codigo: 150806,
            nombre: 'HUAURA',
            ubigeo: 150806
          },
          {
            codigo: 150807,
            nombre: 'LEONCIO PRADO',
            ubigeo: 150807
          },
          {
            codigo: 150808,
            nombre: 'PACCHO',
            ubigeo: 150808
          },
          {
            codigo: 150809,
            nombre: 'SANTA LEONOR',
            ubigeo: 150809
          },
          {
            codigo: 150810,
            nombre: 'SANTA MARIA',
            ubigeo: 150810
          },
          {
            codigo: 150811,
            nombre: 'SAYAN',
            ubigeo: 150811
          },
          {
            codigo: 150812,
            nombre: 'VEGUETA',
            ubigeo: 150812
          }
        ]
      },
      {
        codigo: 1501,
        nombre: 'LIMA',
        distritos: [
          {
            codigo: 150102,
            nombre: 'ANCON',
            ubigeo: 150102
          },
          {
            codigo: 150103,
            nombre: 'ATE',
            ubigeo: 150103
          },
          {
            codigo: 150104,
            nombre: 'BARRANCO',
            ubigeo: 150104
          },
          {
            codigo: 150105,
            nombre: 'BRENA',
            ubigeo: 150105
          },
          {
            codigo: 150106,
            nombre: 'CARABAYLLO',
            ubigeo: 150106
          },
          {
            codigo: 150101,
            nombre: 'CERCADO',
            ubigeo: 150101
          },
          {
            codigo: 150108,
            nombre: 'CHACLACAYO',
            ubigeo: 150107
          },
          {
            codigo: 150109,
            nombre: 'CHORRILLOS',
            ubigeo: 150108
          },
          {
            codigo: 150140,
            nombre: 'CIENEGUILLA',
            ubigeo: 150109
          },
          {
            codigo: 150107,
            nombre: 'COMAS',
            ubigeo: 150110
          },
          {
            codigo: 150110,
            nombre: 'EL AGUSTINO',
            ubigeo: 150111
          },
          {
            codigo: 150128,
            nombre: 'INDEPENDENCIA',
            ubigeo: 150112
          },
          {
            codigo: 150111,
            nombre: 'JESUS MARIA',
            ubigeo: 150113
          },
          {
            codigo: 150112,
            nombre: 'LA MOLINA',
            ubigeo: 150114
          },
          {
            codigo: 150113,
            nombre: 'LA VICTORIA',
            ubigeo: 150115
          },
          {
            codigo: 150114,
            nombre: 'LINCE',
            ubigeo: 150116
          },
          {
            codigo: 150139,
            nombre: 'LOS OLIVOS',
            ubigeo: 150117
          },
          {
            codigo: 150115,
            nombre: 'LURIGANCHO',
            ubigeo: 150118
          },
          {
            codigo: 150116,
            nombre: 'LURIN',
            ubigeo: 150119
          },
          {
            codigo: 150117,
            nombre: 'MAGDALENA',
            ubigeo: 150120
          },
          {
            codigo: 150118,
            nombre: 'MIRAFLORES',
            ubigeo: 150122
          },
          {
            codigo: 150119,
            nombre: 'PACHACAMAC',
            ubigeo: 150123
          },
          {
            codigo: 150120,
            nombre: 'PUCUSANA',
            ubigeo: 150124
          },
          {
            codigo: 150121,
            nombre: 'PUEBLO LIBRE',
            ubigeo: 150121
          },
          {
            codigo: 150122,
            nombre: 'PUENTE PIEDRA',
            ubigeo: 150125
          },
          {
            codigo: 150124,
            nombre: 'PUNTA HERMOSA',
            ubigeo: 150126
          },
          {
            codigo: 150123,
            nombre: 'PUNTA NEGRA',
            ubigeo: 150127
          },
          {
            codigo: 150125,
            nombre: 'RIMAC',
            ubigeo: 150128
          },
          {
            codigo: 150126,
            nombre: 'SAN BARTOLO',
            ubigeo: 150129
          },
          {
            codigo: 150141,
            nombre: 'SAN BORJA',
            ubigeo: 150130
          },
          {
            codigo: 150127,
            nombre: 'SAN ISIDRO',
            ubigeo: 150131
          },
          {
            codigo: 150136,
            nombre: 'SAN JUAN DE LURIGANCHO',
            ubigeo: 150132
          },
          {
            codigo: 150129,
            nombre: 'SAN JUAN DE MIRAFLORES',
            ubigeo: 150133
          },
          {
            codigo: 150130,
            nombre: 'SAN LUIS',
            ubigeo: 150134
          },
          {
            codigo: 150131,
            nombre: 'SAN MARTIN DE PORRES',
            ubigeo: 150135
          },
          {
            codigo: 150132,
            nombre: 'SAN MIGUEL',
            ubigeo: 150136
          },
          {
            codigo: 150143,
            nombre: 'SANTA ANITA',
            ubigeo: 150137
          },
          {
            codigo: 150137,
            nombre: 'SANTA MARIA',
            ubigeo: 150138
          },
          {
            codigo: 150138,
            nombre: 'SANTA ROSA',
            ubigeo: 150139
          },
          {
            codigo: 150133,
            nombre: 'SURCO',
            ubigeo: 150140
          },
          {
            codigo: 150134,
            nombre: 'SURQUILLO',
            ubigeo: 150141
          },
          {
            codigo: 150142,
            nombre: 'VILLA EL SALVADOR',
            ubigeo: 150142
          },
          {
            codigo: 150135,
            nombre: 'VILLA MARIA DEL TRIUNFO',
            ubigeo: 150143
          }
        ]
      },
      {
        codigo: 1509,
        nombre: 'OYON',
        distritos: [
          {
            codigo: 150902,
            nombre: 'ANDAJES',
            ubigeo: 150902
          },
          {
            codigo: 150903,
            nombre: 'CAUJUL',
            ubigeo: 150903
          },
          {
            codigo: 150904,
            nombre: 'COCHAMARCA',
            ubigeo: 150904
          },
          {
            codigo: 150905,
            nombre: 'NAVAN',
            ubigeo: 150905
          },
          {
            codigo: 150901,
            nombre: 'OYON',
            ubigeo: 150901
          },
          {
            codigo: 150906,
            nombre: 'PACHANGARA',
            ubigeo: 150906
          }
        ]
      },
      {
        codigo: 1510,
        nombre: 'YAUYOS',
        distritos: [
          {
            codigo: 151002,
            nombre: 'ALIS',
            ubigeo: 151002
          },
          {
            codigo: 151003,
            nombre: 'AYAUCA',
            ubigeo: 151003
          },
          {
            codigo: 151004,
            nombre: 'AYAVIRI',
            ubigeo: 151004
          },
          {
            codigo: 151005,
            nombre: 'AZANGARO',
            ubigeo: 151005
          },
          {
            codigo: 151006,
            nombre: 'CACRA',
            ubigeo: 151006
          },
          {
            codigo: 151007,
            nombre: 'CARANIA',
            ubigeo: 151007
          },
          {
            codigo: 151008,
            nombre: 'CATAHUASI',
            ubigeo: 151008
          },
          {
            codigo: 151009,
            nombre: 'CHOCOS',
            ubigeo: 151009
          },
          {
            codigo: 151010,
            nombre: 'COCHAS',
            ubigeo: 151010
          },
          {
            codigo: 151011,
            nombre: 'COLONIA',
            ubigeo: 151011
          },
          {
            codigo: 151012,
            nombre: 'HONGOS',
            ubigeo: 151012
          },
          {
            codigo: 151013,
            nombre: 'HUAMPARA',
            ubigeo: 151013
          },
          {
            codigo: 151014,
            nombre: 'HUANCAYA',
            ubigeo: 151014
          },
          {
            codigo: 151015,
            nombre: 'HUANGASCAR',
            ubigeo: 151015
          },
          {
            codigo: 151016,
            nombre: 'HUANTAN',
            ubigeo: 151016
          },
          {
            codigo: 151017,
            nombre: 'HUAÑEC',
            ubigeo: 151017
          },
          {
            codigo: 151018,
            nombre: 'LARAOS',
            ubigeo: 151018
          },
          {
            codigo: 151019,
            nombre: 'LINCHA',
            ubigeo: 151019
          },
          {
            codigo: 151020,
            nombre: 'MADEAN',
            ubigeo: 151020
          },
          {
            codigo: 151021,
            nombre: 'MIRAFLORES',
            ubigeo: 151021
          },
          {
            codigo: 151022,
            nombre: 'OMAS',
            ubigeo: 151022
          },
          {
            codigo: 151023,
            nombre: 'PUTINZA',
            ubigeo: 151023
          },
          {
            codigo: 151024,
            nombre: 'QUINCHES',
            ubigeo: 151024
          },
          {
            codigo: 151025,
            nombre: 'QUINOCAY',
            ubigeo: 151025
          },
          {
            codigo: 151026,
            nombre: 'SAN JOAQUIN',
            ubigeo: 151026
          },
          {
            codigo: 151027,
            nombre: 'SAN PEDRO DE PI',
            ubigeo: 151027
          },
          {
            codigo: 151028,
            nombre: 'TANTA',
            ubigeo: 151028
          },
          {
            codigo: 151029,
            nombre: 'TAURIPAMPA',
            ubigeo: 151029
          },
          {
            codigo: 151030,
            nombre: 'TOMAS',
            ubigeo: 151030
          },
          {
            codigo: 151031,
            nombre: 'TUPE',
            ubigeo: 151031
          },
          {
            codigo: 151033,
            nombre: 'VITIS',
            ubigeo: 151033
          },
          {
            codigo: 151032,
            nombre: 'VIÑAC',
            ubigeo: 151032
          },
          {
            codigo: 151001,
            nombre: 'YAUYOS',
            ubigeo: 151001
          }
        ]
      }
    ]
  },
  {
    nombre: '--'
  },
  {
    codigo: 1,
    nombre: 'AMAZONAS',
    provincias: [
      {
        codigo: 102,
        nombre: 'BAGUA',
        distritos: [
          {
            codigo: 10202,
            nombre: 'ARAMANGO',
            ubigeo: '010202'
          },
          {
            codigo: 10206,
            nombre: 'BAGUA',
            ubigeo: '010206'
          },
          {
            codigo: 10203,
            nombre: 'COPALLIN',
            ubigeo: '010203'
          },
          {
            codigo: 10204,
            nombre: 'EL PARCO',
            ubigeo: '010204'
          },
          {
            codigo: 10205,
            nombre: 'IMAZA',
            ubigeo: '010205'
          },
          {
            codigo: 10201,
            nombre: 'LA PECA',
            ubigeo: '010201'
          }
        ]
      },
      {
        codigo: 103,
        nombre: 'BONGARA',
        distritos: [
          {
            codigo: 10302,
            nombre: 'CHISQUILLA',
            ubigeo: '010302'
          },
          {
            codigo: 10303,
            nombre: 'CHURUJA',
            ubigeo: '010303'
          },
          {
            codigo: 10304,
            nombre: 'COROSHA',
            ubigeo: '010304'
          },
          {
            codigo: 10305,
            nombre: 'CUISPES',
            ubigeo: '010305'
          },
          {
            codigo: 10306,
            nombre: 'FLORIDA',
            ubigeo: '010306'
          },
          {
            codigo: 10307,
            nombre: 'JAZAN',
            ubigeo: '010307'
          },
          {
            codigo: 10301,
            nombre: 'JUMBILLA',
            ubigeo: '010301'
          },
          {
            codigo: 10308,
            nombre: 'RECTA',
            ubigeo: '010308'
          },
          {
            codigo: 10309,
            nombre: 'SAN CARLOS',
            ubigeo: '010309'
          },
          {
            codigo: 10310,
            nombre: 'SHIPASBAMBA',
            ubigeo: '010310'
          },
          {
            codigo: 10311,
            nombre: 'VALERA',
            ubigeo: '010311'
          },
          {
            codigo: 10312,
            nombre: 'YAMBRASBAMBA',
            ubigeo: '010312'
          }
        ]
      },
      {
        codigo: 101,
        nombre: 'CHACHAPOYAS',
        distritos: [
          {
            codigo: 10102,
            nombre: 'ASUNCION',
            ubigeo: '010102'
          },
          {
            codigo: 10103,
            nombre: 'BALSAS',
            ubigeo: '010103'
          },
          {
            codigo: 10101,
            nombre: 'CHACHAPOYAS',
            ubigeo: '010101'
          },
          {
            codigo: 10104,
            nombre: 'CHETO',
            ubigeo: '010104'
          },
          {
            codigo: 10105,
            nombre: 'CHILIQUIN',
            ubigeo: '010105'
          },
          {
            codigo: 10106,
            nombre: 'CHUQUIBAMBA',
            ubigeo: '010106'
          },
          {
            codigo: 10107,
            nombre: 'GRANADA',
            ubigeo: '010107'
          },
          {
            codigo: 10108,
            nombre: 'HUANCAS',
            ubigeo: '010108'
          },
          {
            codigo: 10109,
            nombre: 'LA JALCA',
            ubigeo: '010109'
          },
          {
            codigo: 10110,
            nombre: 'LEIMEBAMBA',
            ubigeo: '010110'
          },
          {
            codigo: 10111,
            nombre: 'LEVANTO',
            ubigeo: '010111'
          },
          {
            codigo: 10112,
            nombre: 'MAGDALENA',
            ubigeo: '010112'
          },
          {
            codigo: 10113,
            nombre: 'MARISCAL CASTIL',
            ubigeo: '010113'
          },
          {
            codigo: 10114,
            nombre: 'MOLINOPAMPA',
            ubigeo: '010114'
          },
          {
            codigo: 10115,
            nombre: 'MONTEVIDEO',
            ubigeo: '010115'
          },
          {
            codigo: 10116,
            nombre: 'OLLEROS',
            ubigeo: '010116'
          },
          {
            codigo: 10117,
            nombre: 'QUINJALCA',
            ubigeo: '010117'
          },
          {
            codigo: 10118,
            nombre: 'SAN FRANCISCO D',
            ubigeo: '010118'
          },
          {
            codigo: 10119,
            nombre: 'SAN ISIDRO DE M',
            ubigeo: '010119'
          },
          {
            codigo: 10120,
            nombre: 'SOLOCO',
            ubigeo: '010120'
          },
          {
            codigo: 10121,
            nombre: 'SONCHE',
            ubigeo: '010121'
          }
        ]
      },
      {
        codigo: 104,
        nombre: 'CONDORCANQUI',
        distritos: [
          {
            codigo: 10402,
            nombre: 'EL CENEPA',
            ubigeo: '010402'
          },
          {
            codigo: 10401,
            nombre: 'NIEVA',
            ubigeo: '010401'
          },
          {
            codigo: 10403,
            nombre: 'RIO SANTIAGO',
            ubigeo: '010403'
          }
        ]
      },
      {
        codigo: 105,
        nombre: 'LUYA',
        distritos: [
          {
            codigo: 10502,
            nombre: 'CAMPORREDONDO',
            ubigeo: '010502'
          },
          {
            codigo: 10503,
            nombre: 'COCABAMBA',
            ubigeo: '010503'
          },
          {
            codigo: 10504,
            nombre: 'COLCAMAR',
            ubigeo: '010504'
          },
          {
            codigo: 10505,
            nombre: 'CONILA',
            ubigeo: '010505'
          },
          {
            codigo: 10506,
            nombre: 'INGUILPATA',
            ubigeo: '010506'
          },
          {
            codigo: 10501,
            nombre: 'LAMUD',
            ubigeo: '010501'
          },
          {
            codigo: 10507,
            nombre: 'LONGUITA',
            ubigeo: '010507'
          },
          {
            codigo: 10508,
            nombre: 'LONYA CHICO',
            ubigeo: '010508'
          },
          {
            codigo: 10509,
            nombre: 'LUYA',
            ubigeo: '010509'
          },
          {
            codigo: 10510,
            nombre: 'LUYA VIEJO',
            ubigeo: '010510'
          },
          {
            codigo: 10511,
            nombre: 'MARIA',
            ubigeo: '010511'
          },
          {
            codigo: 10512,
            nombre: 'OCALLI',
            ubigeo: '010512'
          },
          {
            codigo: 10513,
            nombre: 'OCUMAL',
            ubigeo: '010513'
          },
          {
            codigo: 10514,
            nombre: 'PISUQUIA',
            ubigeo: '010514'
          },
          {
            codigo: 10515,
            nombre: 'PROVIDENCIA',
            ubigeo: '010515'
          },
          {
            codigo: 10516,
            nombre: 'SAN CRISTOBAL',
            ubigeo: '010516'
          },
          {
            codigo: 10517,
            nombre: 'SAN FRANCISCO D',
            ubigeo: '010517'
          },
          {
            codigo: 10518,
            nombre: 'SAN JERONIMO',
            ubigeo: '010518'
          },
          {
            codigo: 10519,
            nombre: 'SAN JUAN DE LOP',
            ubigeo: '010519'
          },
          {
            codigo: 10520,
            nombre: 'SANTA CATALINA',
            ubigeo: '010520'
          },
          {
            codigo: 10521,
            nombre: 'SANTO TOMAS',
            ubigeo: '010521'
          },
          {
            codigo: 10522,
            nombre: 'TINGO',
            ubigeo: '010522'
          },
          {
            codigo: 10523,
            nombre: 'TRITA',
            ubigeo: '010523'
          }
        ]
      },
      {
        codigo: 106,
        nombre: 'RODRIGUEZ DE ME',
        distritos: [
          {
            codigo: 10602,
            nombre: 'CHIRIMOTO',
            ubigeo: '010602'
          },
          {
            codigo: 10603,
            nombre: 'COCHAMAL',
            ubigeo: '010603'
          },
          {
            codigo: 10604,
            nombre: 'HUAMBO',
            ubigeo: '010604'
          },
          {
            codigo: 10605,
            nombre: 'LIMABAMBA',
            ubigeo: '010605'
          },
          {
            codigo: 10606,
            nombre: 'LONGAR',
            ubigeo: '010606'
          },
          {
            codigo: 10607,
            nombre: 'MARISCAL BENAVI',
            ubigeo: '010607'
          },
          {
            codigo: 10608,
            nombre: 'MILPUC',
            ubigeo: '010608'
          },
          {
            codigo: 10609,
            nombre: 'OMIA',
            ubigeo: '010609'
          },
          {
            codigo: 10601,
            nombre: 'SAN NICOLAS',
            ubigeo: '010601'
          },
          {
            codigo: 10610,
            nombre: 'SANTA ROSA',
            ubigeo: '010610'
          },
          {
            codigo: 10611,
            nombre: 'TOTORA',
            ubigeo: '010611'
          },
          {
            codigo: 10612,
            nombre: 'VISTA ALEGRE',
            ubigeo: '010612'
          }
        ]
      },
      {
        codigo: 107,
        nombre: 'UTCUBAMBA',
        distritos: [
          {
            codigo: 10701,
            nombre: 'BAGUA GRANDE',
            ubigeo: '010701'
          },
          {
            codigo: 10702,
            nombre: 'CAJARURO',
            ubigeo: '010702'
          },
          {
            codigo: 10703,
            nombre: 'CUMBA',
            ubigeo: '010703'
          },
          {
            codigo: 10704,
            nombre: 'EL MILAGRO',
            ubigeo: '010704'
          },
          {
            codigo: 10705,
            nombre: 'JAMALCA',
            ubigeo: '010705'
          },
          {
            codigo: 10706,
            nombre: 'LONYA GRANDE',
            ubigeo: '010706'
          },
          {
            codigo: 10707,
            nombre: 'YAMON',
            ubigeo: '010707'
          }
        ]
      }
    ]
  },
  {
    codigo: 2,
    nombre: 'ANCASH',
    provincias: [
      {
        codigo: 202,
        nombre: 'AIJA',
        distritos: [
          {
            codigo: 20201,
            nombre: 'AIJA',
            ubigeo: '020201'
          },
          {
            codigo: 20202,
            nombre: 'CORIS',
            ubigeo: '020202'
          },
          {
            codigo: 20203,
            nombre: 'HUACLLAN',
            ubigeo: '020203'
          },
          {
            codigo: 20204,
            nombre: 'LA MERCED',
            ubigeo: '020204'
          },
          {
            codigo: 20205,
            nombre: 'SUCCHA',
            ubigeo: '020205'
          }
        ]
      },
      {
        codigo: 203,
        nombre: 'ANTONIO RAYMOND',
        distritos: [
          {
            codigo: 20302,
            nombre: 'ACZO',
            ubigeo: '020302'
          },
          {
            codigo: 20303,
            nombre: 'CHACCHO',
            ubigeo: '020303'
          },
          {
            codigo: 20304,
            nombre: 'CHINGAS',
            ubigeo: '020304'
          },
          {
            codigo: 20102,
            nombre: 'COCHABAMBA',
            ubigeo: '020102'
          },
          {
            codigo: 20301,
            nombre: 'LLAMELLIN',
            ubigeo: '020301'
          },
          {
            codigo: 20305,
            nombre: 'MIRGAS',
            ubigeo: '020305'
          },
          {
            codigo: 20306,
            nombre: 'SAN JUAN DE RON',
            ubigeo: '020306'
          }
        ]
      },
      {
        codigo: 204,
        nombre: 'ASUNCION',
        distritos: [
          {
            codigo: 20402,
            nombre: 'ACOCHACA',
            ubigeo: '020402'
          },
          {
            codigo: 20401,
            nombre: 'CHACAS',
            ubigeo: '020401'
          }
        ]
      },
      {
        codigo: 205,
        nombre: 'BOLOGNESI',
        distritos: [
          {
            codigo: 20502,
            nombre: 'ABELARDO PARDO',
            ubigeo: '020502'
          },
          {
            codigo: 20503,
            nombre: 'ANTONIO RAYMOND',
            ubigeo: '020503'
          },
          {
            codigo: 20504,
            nombre: 'AQUIA',
            ubigeo: '020504'
          },
          {
            codigo: 20505,
            nombre: 'CAJACAY',
            ubigeo: '020505'
          },
          {
            codigo: 20506,
            nombre: 'CANIS',
            ubigeo: '020506'
          },
          {
            codigo: 20501,
            nombre: 'CHIQUIAN',
            ubigeo: '020501'
          },
          {
            codigo: 20507,
            nombre: 'COLQUIOC',
            ubigeo: '020507'
          },
          {
            codigo: 20508,
            nombre: 'HUALLANCA',
            ubigeo: '020508'
          },
          {
            codigo: 20509,
            nombre: 'HUASTA',
            ubigeo: '020509'
          },
          {
            codigo: 20510,
            nombre: 'HUAYLLACAYAN',
            ubigeo: '020510'
          },
          {
            codigo: 20511,
            nombre: 'LA PRIMAVERA',
            ubigeo: '020511'
          },
          {
            codigo: 20512,
            nombre: 'MANGAS',
            ubigeo: '020512'
          },
          {
            codigo: 20513,
            nombre: 'PACLLON',
            ubigeo: '020513'
          },
          {
            codigo: 20514,
            nombre: 'SAN MIGUEL DE C',
            ubigeo: '020514'
          },
          {
            codigo: 20515,
            nombre: 'TICLLOS',
            ubigeo: '020515'
          }
        ]
      },
      {
        codigo: 206,
        nombre: 'CARHUAZ',
        distritos: [
          {
            codigo: 20602,
            nombre: 'ACOPAMPA',
            ubigeo: '020602'
          },
          {
            codigo: 20603,
            nombre: 'AMASHCA',
            ubigeo: '020603'
          },
          {
            codigo: 20604,
            nombre: 'ANTA',
            ubigeo: '020604'
          },
          {
            codigo: 20605,
            nombre: 'ATAQUERO',
            ubigeo: '020605'
          },
          {
            codigo: 20601,
            nombre: 'CARHUAZ',
            ubigeo: '020601'
          },
          {
            codigo: 20606,
            nombre: 'MARCARA',
            ubigeo: '020606'
          },
          {
            codigo: 20607,
            nombre: 'PARIAHUANCA',
            ubigeo: '020607'
          },
          {
            codigo: 20608,
            nombre: 'SAN MIGUEL DE A',
            ubigeo: '020608'
          },
          {
            codigo: 20609,
            nombre: 'SHILLA',
            ubigeo: '020609'
          },
          {
            codigo: 20610,
            nombre: 'TINCO',
            ubigeo: '020610'
          },
          {
            codigo: 20611,
            nombre: 'YUNGAR',
            ubigeo: '020611'
          }
        ]
      },
      {
        codigo: 207,
        nombre: 'CARLOS F. FITZC',
        distritos: [
          {
            codigo: 20701,
            nombre: 'SAN LUIS',
            ubigeo: '020701'
          },
          {
            codigo: 20702,
            nombre: 'SAN NICOLAS',
            ubigeo: '020702'
          },
          {
            codigo: 20703,
            nombre: 'YAUYA',
            ubigeo: '020703'
          }
        ]
      },
      {
        codigo: 208,
        nombre: 'CASMA',
        distritos: [
          {
            codigo: 20802,
            nombre: 'BUENA VISTA ALT',
            ubigeo: '020802'
          },
          {
            codigo: 20801,
            nombre: 'CASMA',
            ubigeo: '020801'
          },
          {
            codigo: 20803,
            nombre: 'COMANDANTE NOEL',
            ubigeo: '020803'
          },
          {
            codigo: 20804,
            nombre: 'YAUTAN',
            ubigeo: '020804'
          }
        ]
      },
      {
        codigo: 209,
        nombre: 'CORONGO',
        distritos: [
          {
            codigo: 20902,
            nombre: 'ACO',
            ubigeo: '020902'
          },
          {
            codigo: 20903,
            nombre: 'BAMBAS',
            ubigeo: '020903'
          },
          {
            codigo: 20901,
            nombre: 'CORONGO',
            ubigeo: '020901'
          },
          {
            codigo: 20904,
            nombre: 'CUSCA',
            ubigeo: '020904'
          },
          {
            codigo: 20905,
            nombre: 'LA PAMPA',
            ubigeo: '020905'
          },
          {
            codigo: 20906,
            nombre: 'YANAC',
            ubigeo: '020906'
          },
          {
            codigo: 20907,
            nombre: 'YUPAN',
            ubigeo: '020907'
          }
        ]
      },
      {
        codigo: 201,
        nombre: 'HUARAZ',
        distritos: [
          {
            codigo: 20103,
            nombre: 'COLCABAMBA',
            ubigeo: '020103'
          },
          {
            codigo: 20104,
            nombre: 'HUANCHAY',
            ubigeo: '020104'
          },
          {
            codigo: 20101,
            nombre: 'HUARAZ',
            ubigeo: '020101'
          },
          {
            codigo: 20105,
            nombre: 'INDEPENDENCIA',
            ubigeo: '020105'
          },
          {
            codigo: 20106,
            nombre: 'JANGAS',
            ubigeo: '020106'
          },
          {
            codigo: 20107,
            nombre: 'LA LIBERTAD',
            ubigeo: '020107'
          },
          {
            codigo: 20108,
            nombre: 'OLLEROS',
            ubigeo: '020108'
          },
          {
            codigo: 20109,
            nombre: 'PAMPAS',
            ubigeo: '020109'
          },
          {
            codigo: 20110,
            nombre: 'PARIACOTO',
            ubigeo: '020110'
          },
          {
            codigo: 20111,
            nombre: 'PIRA',
            ubigeo: '020111'
          },
          {
            codigo: 20112,
            nombre: 'TARICA',
            ubigeo: '020112'
          }
        ]
      },
      {
        codigo: 210,
        nombre: 'HUARI',
        distritos: [
          {
            codigo: 21002,
            nombre: 'ANRA',
            ubigeo: '021002'
          },
          {
            codigo: 21003,
            nombre: 'CAJAY',
            ubigeo: '021003'
          },
          {
            codigo: 21004,
            nombre: 'CHAVIN DE HUANT',
            ubigeo: '021004'
          },
          {
            codigo: 21005,
            nombre: 'HUACACHI',
            ubigeo: '021005'
          },
          {
            codigo: 21006,
            nombre: 'HUACCHIS',
            ubigeo: '021006'
          },
          {
            codigo: 21007,
            nombre: 'HUACHIS',
            ubigeo: '021007'
          },
          {
            codigo: 21008,
            nombre: 'HUANTAR',
            ubigeo: '021008'
          },
          {
            codigo: 21001,
            nombre: 'HUARI',
            ubigeo: '021001'
          },
          {
            codigo: 21009,
            nombre: 'MASIN',
            ubigeo: '021009'
          },
          {
            codigo: 21010,
            nombre: 'PAUCAS',
            ubigeo: '021010'
          },
          {
            codigo: 21011,
            nombre: 'PONTO',
            ubigeo: '021011'
          },
          {
            codigo: 21012,
            nombre: 'RAHUAPAMPA',
            ubigeo: '021012'
          },
          {
            codigo: 21013,
            nombre: 'RAPAYAN',
            ubigeo: '021013'
          },
          {
            codigo: 21014,
            nombre: 'SAN MARCOS',
            ubigeo: '021014'
          },
          {
            codigo: 21015,
            nombre: 'SAN PEDRO DE CH',
            ubigeo: '021015'
          },
          {
            codigo: 21016,
            nombre: 'UCO',
            ubigeo: '021016'
          }
        ]
      },
      {
        codigo: 211,
        nombre: 'HUARMEY',
        distritos: [
          {
            codigo: 21102,
            nombre: 'COCHAPETI',
            ubigeo: '021102'
          },
          {
            codigo: 21103,
            nombre: 'CULEBRAS',
            ubigeo: '021103'
          },
          {
            codigo: 21101,
            nombre: 'HUARMEY',
            ubigeo: '021101'
          },
          {
            codigo: 21104,
            nombre: 'HUAYAN',
            ubigeo: '021104'
          },
          {
            codigo: 21105,
            nombre: 'MALVAS',
            ubigeo: '021105'
          }
        ]
      },
      {
        codigo: 212,
        nombre: 'HUAYLAS',
        distritos: [
          {
            codigo: 21201,
            nombre: 'CARAZ',
            ubigeo: '021201'
          },
          {
            codigo: 21202,
            nombre: 'HUALLANCA',
            ubigeo: '021202'
          },
          {
            codigo: 21203,
            nombre: 'HUATA',
            ubigeo: '021203'
          },
          {
            codigo: 21204,
            nombre: 'HUAYLAS',
            ubigeo: '021204'
          },
          {
            codigo: 21205,
            nombre: 'MATO',
            ubigeo: '021205'
          },
          {
            codigo: 21206,
            nombre: 'PAMPAROMAS',
            ubigeo: '021206'
          },
          {
            codigo: 21207,
            nombre: 'PUEBLO LIBRE',
            ubigeo: '021207'
          },
          {
            codigo: 21208,
            nombre: 'SANTA CRUZ',
            ubigeo: '021208'
          },
          {
            codigo: 21209,
            nombre: 'SANTO TORIBIO',
            ubigeo: '021209'
          },
          {
            codigo: 21210,
            nombre: 'YURACMARCA',
            ubigeo: '021210'
          }
        ]
      },
      {
        codigo: 213,
        nombre: 'MARISCAL LUZURI',
        distritos: [
          {
            codigo: 21302,
            nombre: 'CASCA',
            ubigeo: '021302'
          },
          {
            codigo: 21303,
            nombre: 'ELEAZAR GUZMAN',
            ubigeo: '021303'
          },
          {
            codigo: 21304,
            nombre: 'FIDEL OLIVAS ES',
            ubigeo: '021304'
          },
          {
            codigo: 21305,
            nombre: 'LLAMA',
            ubigeo: '021305'
          },
          {
            codigo: 21306,
            nombre: 'LLUMPA',
            ubigeo: '021306'
          },
          {
            codigo: 21307,
            nombre: 'LUCMA',
            ubigeo: '021307'
          },
          {
            codigo: 21308,
            nombre: 'MUSGA',
            ubigeo: '021308'
          },
          {
            codigo: 21301,
            nombre: 'PISCOBAMBA',
            ubigeo: '021301'
          }
        ]
      },
      {
        codigo: 214,
        nombre: 'OCROS',
        distritos: [
          {
            codigo: 21402,
            nombre: 'ACAS',
            ubigeo: '021402'
          },
          {
            codigo: 21403,
            nombre: 'CAJAMARQUILLA',
            ubigeo: '021403'
          },
          {
            codigo: 21404,
            nombre: 'CARHUAPAMPA',
            ubigeo: '021404'
          },
          {
            codigo: 21405,
            nombre: 'COCHAS',
            ubigeo: '021405'
          },
          {
            codigo: 21406,
            nombre: 'CONGAS',
            ubigeo: '021406'
          },
          {
            codigo: 21407,
            nombre: 'LLIPA',
            ubigeo: '021407'
          },
          {
            codigo: 21401,
            nombre: 'OCROS',
            ubigeo: '021401'
          },
          {
            codigo: 21408,
            nombre: 'SAN CRISTOBAL D',
            ubigeo: '021408'
          },
          {
            codigo: 21409,
            nombre: 'SAN PEDRO',
            ubigeo: '021409'
          },
          {
            codigo: 21410,
            nombre: 'SANTIAGO DE CHI',
            ubigeo: '021410'
          }
        ]
      },
      {
        codigo: 215,
        nombre: 'PALLASCA',
        distritos: [
          {
            codigo: 21502,
            nombre: 'BOLOGNESI',
            ubigeo: '021502'
          },
          {
            codigo: 21501,
            nombre: 'CABANA',
            ubigeo: '021501'
          },
          {
            codigo: 21503,
            nombre: 'CONCHUCOS',
            ubigeo: '021503'
          },
          {
            codigo: 21504,
            nombre: 'HUACASCHUQUE',
            ubigeo: '021504'
          },
          {
            codigo: 21505,
            nombre: 'HUANDOVAL',
            ubigeo: '021505'
          },
          {
            codigo: 21506,
            nombre: 'LACABAMBA',
            ubigeo: '021506'
          },
          {
            codigo: 21507,
            nombre: 'LLAPO',
            ubigeo: '021507'
          },
          {
            codigo: 21508,
            nombre: 'PALLASCA',
            ubigeo: '021508'
          },
          {
            codigo: 21509,
            nombre: 'PAMPAS',
            ubigeo: '021509'
          },
          {
            codigo: 21510,
            nombre: 'SANTA ROSA',
            ubigeo: '021510'
          },
          {
            codigo: 21511,
            nombre: 'TAUCA',
            ubigeo: '021511'
          }
        ]
      },
      {
        codigo: 216,
        nombre: 'POMABAMBA',
        distritos: [
          {
            codigo: 21602,
            nombre: 'HUAYLLAN',
            ubigeo: '021602'
          },
          {
            codigo: 21603,
            nombre: 'PAROBAMBA',
            ubigeo: '021603'
          },
          {
            codigo: 21601,
            nombre: 'POMABAMBA',
            ubigeo: '021601'
          },
          {
            codigo: 21604,
            nombre: 'QUINUABAMBA',
            ubigeo: '021604'
          }
        ]
      },
      {
        codigo: 217,
        nombre: 'RECUAY',
        distritos: [
          {
            codigo: 21702,
            nombre: 'CATAC',
            ubigeo: '021702'
          },
          {
            codigo: 21703,
            nombre: 'COTAPARACO',
            ubigeo: '021703'
          },
          {
            codigo: 21704,
            nombre: 'HUAYLLAPAMPA',
            ubigeo: '021704'
          },
          {
            codigo: 21705,
            nombre: 'LLACLLIN',
            ubigeo: '021705'
          },
          {
            codigo: 21706,
            nombre: 'MARCA',
            ubigeo: '021706'
          },
          {
            codigo: 21707,
            nombre: 'PAMPAS CHICO',
            ubigeo: '021707'
          },
          {
            codigo: 21708,
            nombre: 'PARARIN',
            ubigeo: '021708'
          },
          {
            codigo: 21701,
            nombre: 'RECUAY',
            ubigeo: '021701'
          },
          {
            codigo: 21709,
            nombre: 'TAPACOCHA',
            ubigeo: '021709'
          },
          {
            codigo: 21710,
            nombre: 'TICAPAMPA',
            ubigeo: '021710'
          }
        ]
      },
      {
        codigo: 218,
        nombre: 'SANTA',
        distritos: [
          {
            codigo: 21802,
            nombre: 'CACERES DEL PER',
            ubigeo: '021802'
          },
          {
            codigo: 21801,
            nombre: 'CHIMBOTE',
            ubigeo: '021801'
          },
          {
            codigo: 21803,
            nombre: 'COISHCO',
            ubigeo: '021803'
          },
          {
            codigo: 21804,
            nombre: 'MACATE',
            ubigeo: '021804'
          },
          {
            codigo: 21805,
            nombre: 'MORO',
            ubigeo: '021805'
          },
          {
            codigo: 21806,
            nombre: 'NEPEÑA',
            ubigeo: '021806'
          },
          {
            codigo: 21809,
            nombre: 'NUEVO CHIMBOTE',
            ubigeo: '021809'
          },
          {
            codigo: 21807,
            nombre: 'SAMANCO',
            ubigeo: '021807'
          },
          {
            codigo: 21808,
            nombre: 'SANTA',
            ubigeo: '021808'
          }
        ]
      },
      {
        codigo: 219,
        nombre: 'SIHUAS',
        distritos: [
          {
            codigo: 21902,
            nombre: 'ACOBAMBA',
            ubigeo: '021902'
          },
          {
            codigo: 21903,
            nombre: 'ALFONSO UGARTE',
            ubigeo: '021903'
          },
          {
            codigo: 21904,
            nombre: 'CASHAPAMPA',
            ubigeo: '021904'
          },
          {
            codigo: 21905,
            nombre: 'CHINGALPO',
            ubigeo: '021905'
          },
          {
            codigo: 21906,
            nombre: 'HUAYLLABAMBA',
            ubigeo: '021906'
          },
          {
            codigo: 21907,
            nombre: 'QUICHES',
            ubigeo: '021907'
          },
          {
            codigo: 21908,
            nombre: 'RAGASH',
            ubigeo: '021908'
          },
          {
            codigo: 21909,
            nombre: 'SAN JUAN',
            ubigeo: '021909'
          },
          {
            codigo: 21910,
            nombre: 'SICSIBAMBA',
            ubigeo: '021910'
          },
          {
            codigo: 21901,
            nombre: 'SIHUAS',
            ubigeo: '021901'
          }
        ]
      },
      {
        codigo: 220,
        nombre: 'YUNGAY',
        distritos: [
          {
            codigo: 22002,
            nombre: 'CASCAPARA',
            ubigeo: '022002'
          },
          {
            codigo: 22003,
            nombre: 'MANCOS',
            ubigeo: '022003'
          },
          {
            codigo: 22004,
            nombre: 'MATACOTO',
            ubigeo: '022004'
          },
          {
            codigo: 22005,
            nombre: 'QUILLO',
            ubigeo: '022005'
          },
          {
            codigo: 22006,
            nombre: 'RANRAHIRCA',
            ubigeo: '022006'
          },
          {
            codigo: 22007,
            nombre: 'SHUPLUY',
            ubigeo: '022007'
          },
          {
            codigo: 22008,
            nombre: 'YANAMA',
            ubigeo: '022008'
          },
          {
            codigo: 22001,
            nombre: 'YUNGAY',
            ubigeo: '022001'
          }
        ]
      }
    ]
  },
  {
    codigo: 3,
    nombre: 'APURIMAC',
    provincias: [
      {
        codigo: 301,
        nombre: 'ABANCAY',
        distritos: [
          {
            codigo: 30101,
            nombre: 'ABANCAY',
            ubigeo: '030101'
          },
          {
            codigo: 30102,
            nombre: 'CHACOCHE',
            ubigeo: '030102'
          },
          {
            codigo: 30103,
            nombre: 'CIRCA',
            ubigeo: '030103'
          },
          {
            codigo: 30104,
            nombre: 'CURAHUASI',
            ubigeo: '030104'
          },
          {
            codigo: 30105,
            nombre: 'HUANIPACA',
            ubigeo: '030105'
          },
          {
            codigo: 30106,
            nombre: 'LAMBRAMA',
            ubigeo: '030106'
          },
          {
            codigo: 30107,
            nombre: 'PICHIRHUA',
            ubigeo: '030107'
          },
          {
            codigo: 30108,
            nombre: 'SAN PEDRO DE CA',
            ubigeo: '030108'
          },
          {
            codigo: 30109,
            nombre: 'TAMBURCO',
            ubigeo: '030109'
          }
        ]
      },
      {
        codigo: 302,
        nombre: 'ANDAHUAYLAS',
        distritos: [
          {
            codigo: 30201,
            nombre: 'ANDAHUAYLAS',
            ubigeo: '030201'
          },
          {
            codigo: 30202,
            nombre: 'ANDARAPA',
            ubigeo: '030202'
          },
          {
            codigo: 30203,
            nombre: 'CHIARA',
            ubigeo: '030203'
          },
          {
            codigo: 30204,
            nombre: 'HUANCARAMA',
            ubigeo: '030204'
          },
          {
            codigo: 30205,
            nombre: 'HUANCARAY',
            ubigeo: '030205'
          },
          {
            codigo: 30206,
            nombre: 'HUAYANA',
            ubigeo: '030206'
          },
          {
            codigo: 30219,
            nombre: 'KAQUIABAMBA',
            ubigeo: '030219'
          },
          {
            codigo: 30207,
            nombre: 'KISHUARA',
            ubigeo: '030207'
          },
          {
            codigo: 30208,
            nombre: 'PACOBAMBA',
            ubigeo: '030208'
          },
          {
            codigo: 30209,
            nombre: 'PACUCHA',
            ubigeo: '030209'
          },
          {
            codigo: 30210,
            nombre: 'PAMPACHIRI',
            ubigeo: '030210'
          },
          {
            codigo: 30211,
            nombre: 'POMACOCHA',
            ubigeo: '030211'
          },
          {
            codigo: 30212,
            nombre: 'SAN ANTONIO DE',
            ubigeo: '030212'
          },
          {
            codigo: 30213,
            nombre: 'SAN JERONIMO',
            ubigeo: '030213'
          },
          {
            codigo: 30214,
            nombre: 'SAN MIGUEL DE C',
            ubigeo: '030214'
          },
          {
            codigo: 30215,
            nombre: 'SANTA MARIA DE',
            ubigeo: '030215'
          },
          {
            codigo: 30216,
            nombre: 'TALAVERA',
            ubigeo: '030216'
          },
          {
            codigo: 30217,
            nombre: 'TUMAY HUARACA',
            ubigeo: '030217'
          },
          {
            codigo: 30218,
            nombre: 'TURPO',
            ubigeo: '030218'
          }
        ]
      },
      {
        codigo: 303,
        nombre: 'ANTABAMBA',
        distritos: [
          {
            codigo: 30301,
            nombre: 'ANTABAMBA',
            ubigeo: '030301'
          },
          {
            codigo: 30302,
            nombre: 'EL ORO',
            ubigeo: '030302'
          },
          {
            codigo: 30303,
            nombre: 'HUAQUIRCA',
            ubigeo: '030303'
          },
          {
            codigo: 30304,
            nombre: 'JUAN ESPINOZA M',
            ubigeo: '030304'
          },
          {
            codigo: 30305,
            nombre: 'OROPESA',
            ubigeo: '030305'
          },
          {
            codigo: 30306,
            nombre: 'PACHACONAS',
            ubigeo: '030306'
          },
          {
            codigo: 30307,
            nombre: 'SABAINO',
            ubigeo: '030307'
          }
        ]
      },
      {
        codigo: 304,
        nombre: 'AYMARAES',
        distritos: [
          {
            codigo: 30402,
            nombre: 'CAPAYA',
            ubigeo: '030402'
          },
          {
            codigo: 30403,
            nombre: 'CARAYBAMBA',
            ubigeo: '030403'
          },
          {
            codigo: 30401,
            nombre: 'CHALHUANCA',
            ubigeo: '030401'
          },
          {
            codigo: 30404,
            nombre: 'CHAPIMARCA',
            ubigeo: '030404'
          },
          {
            codigo: 30405,
            nombre: 'COLCABAMBA',
            ubigeo: '030405'
          },
          {
            codigo: 30406,
            nombre: 'COTARUSE',
            ubigeo: '030406'
          },
          {
            codigo: 30407,
            nombre: 'HUAYLLO',
            ubigeo: '030407'
          },
          {
            codigo: 30408,
            nombre: 'JUSTO APU SAHUA',
            ubigeo: '030408'
          },
          {
            codigo: 30409,
            nombre: 'LUCRE',
            ubigeo: '030409'
          },
          {
            codigo: 30410,
            nombre: 'POCOHUANCA',
            ubigeo: '030410'
          },
          {
            codigo: 30411,
            nombre: 'SAN JUAN DE CHA',
            ubigeo: '030411'
          },
          {
            codigo: 30412,
            nombre: 'SAÑAYCA',
            ubigeo: '030412'
          },
          {
            codigo: 30413,
            nombre: 'SORAYA',
            ubigeo: '030413'
          },
          {
            codigo: 30414,
            nombre: 'TAPAIRIHUA',
            ubigeo: '030414'
          },
          {
            codigo: 30415,
            nombre: 'TINTAY',
            ubigeo: '030415'
          },
          {
            codigo: 30416,
            nombre: 'TORAYA',
            ubigeo: '030416'
          },
          {
            codigo: 30417,
            nombre: 'YANACA',
            ubigeo: '030417'
          }
        ]
      },
      {
        codigo: 306,
        nombre: 'CHINCHEROS',
        distritos: [
          {
            codigo: 30602,
            nombre: 'ANCO-HUALLO',
            ubigeo: '030602'
          },
          {
            codigo: 30601,
            nombre: 'CHINCHEROS',
            ubigeo: '030601'
          },
          {
            codigo: 30603,
            nombre: 'COCHARCAS',
            ubigeo: '030603'
          },
          {
            codigo: 30604,
            nombre: 'HUACCANA',
            ubigeo: '030604'
          },
          {
            codigo: 30605,
            nombre: 'OCOBAMBA',
            ubigeo: '030605'
          },
          {
            codigo: 30606,
            nombre: 'ONGOY',
            ubigeo: '030606'
          },
          {
            codigo: 30608,
            nombre: 'RANRACANCHA',
            ubigeo: '030608'
          },
          {
            codigo: 30607,
            nombre: 'URANMARCA',
            ubigeo: '030607'
          }
        ]
      },
      {
        codigo: 305,
        nombre: 'COTABAMBAS',
        distritos: [
          {
            codigo: 30506,
            nombre: 'CHALLHUAHUACHO',
            ubigeo: '030506'
          },
          {
            codigo: 30502,
            nombre: 'COTABAMBAS',
            ubigeo: '030502'
          },
          {
            codigo: 30503,
            nombre: 'COYLLURQUI',
            ubigeo: '030503'
          },
          {
            codigo: 30504,
            nombre: 'HAQUIRA',
            ubigeo: '030504'
          },
          {
            codigo: 30505,
            nombre: 'MARA',
            ubigeo: '030505'
          },
          {
            codigo: 30501,
            nombre: 'TAMBOBAMBA',
            ubigeo: '030501'
          }
        ]
      },
      {
        codigo: 307,
        nombre: 'GRAU',
        distritos: [
          {
            codigo: 30701,
            nombre: 'CHUQUIBAMBILLA',
            ubigeo: '030701'
          },
          {
            codigo: 30714,
            nombre: 'CURASCO',
            ubigeo: '030714'
          },
          {
            codigo: 30702,
            nombre: 'CURPAHUASI',
            ubigeo: '030702'
          },
          {
            codigo: 30703,
            nombre: 'GAMARRA',
            ubigeo: '030703'
          },
          {
            codigo: 30704,
            nombre: 'HUAYLLATI',
            ubigeo: '030704'
          },
          {
            codigo: 30705,
            nombre: 'MAMARA',
            ubigeo: '030705'
          },
          {
            codigo: 30706,
            nombre: 'MICAELA BASTIDA',
            ubigeo: '030706'
          },
          {
            codigo: 30707,
            nombre: 'PATAYPAMPA',
            ubigeo: '030707'
          },
          {
            codigo: 30708,
            nombre: 'PROGRESO',
            ubigeo: '030708'
          },
          {
            codigo: 30709,
            nombre: 'SAN ANTONIO',
            ubigeo: '030709'
          },
          {
            codigo: 30710,
            nombre: 'SANTA ROSA',
            ubigeo: '030710'
          },
          {
            codigo: 30711,
            nombre: 'TURPAY',
            ubigeo: '030711'
          },
          {
            codigo: 30712,
            nombre: 'VILCABAMBA',
            ubigeo: '030712'
          },
          {
            codigo: 30713,
            nombre: 'VIRUNDO',
            ubigeo: '030713'
          }
        ]
      }
    ]
  },
  {
    codigo: 4,
    nombre: 'AREQUIPA',
    provincias: [
      {
        codigo: 401,
        nombre: 'AREQUIPA',
        distritos: [
          {
            codigo: 40102,
            nombre: 'ALTO SELVA ALEGRE',
            ubigeo: '040102'
          },
          {
            codigo: 40101,
            nombre: 'AREQUIPA',
            ubigeo: '040101'
          },
          {
            codigo: 40103,
            nombre: 'CAYMA',
            ubigeo: '040103'
          },
          {
            codigo: 40104,
            nombre: 'CERRO COLORADO',
            ubigeo: '040104'
          },
          {
            codigo: 40105,
            nombre: 'CHARACATO',
            ubigeo: '040105'
          },
          {
            codigo: 40106,
            nombre: 'CHIGUATA',
            ubigeo: '040106'
          },
          {
            codigo: 40129,
            nombre: 'J.L.BUSTAM&RIVERO',
            ubigeo: '040129'
          },
          {
            codigo: 40107,
            nombre: 'JACOBO HUNTER',
            ubigeo: '040107'
          },
          {
            codigo: 40108,
            nombre: 'LA JOYA',
            ubigeo: '040108'
          },
          {
            codigo: 40109,
            nombre: 'MARIANO MELGAR',
            ubigeo: '040109'
          },
          {
            codigo: 40110,
            nombre: 'MIRAFLORES',
            ubigeo: '040110'
          },
          {
            codigo: 40111,
            nombre: 'MOLLEBAYA',
            ubigeo: '040111'
          },
          {
            codigo: 40112,
            nombre: 'PAUCARPATA',
            ubigeo: '040112'
          },
          {
            codigo: 40113,
            nombre: 'POCSI',
            ubigeo: '040113'
          },
          {
            codigo: 40114,
            nombre: 'POLOBAYA',
            ubigeo: '040114'
          },
          {
            codigo: 40115,
            nombre: 'QUEQUEÑA',
            ubigeo: '040115'
          },
          {
            codigo: 40119,
            nombre: 'S.JUAN DE TARUCAN',
            ubigeo: '040119'
          },
          {
            codigo: 40116,
            nombre: 'SABANDIA',
            ubigeo: '040116'
          },
          {
            codigo: 40117,
            nombre: 'SACHACA',
            ubigeo: '040117'
          },
          {
            codigo: 40118,
            nombre: 'SAN JUAN DE SIGUA',
            ubigeo: '040118'
          },
          {
            codigo: 40122,
            nombre: 'SOCABAYA',
            ubigeo: '040122'
          },
          {
            codigo: 40120,
            nombre: 'STA.ISABEL SIGUAS',
            ubigeo: '040120'
          },
          {
            codigo: 40121,
            nombre: 'STA.RITA DE SIGUA',
            ubigeo: '040121'
          },
          {
            codigo: 40123,
            nombre: 'TIABAYA',
            ubigeo: '040123'
          },
          {
            codigo: 40124,
            nombre: 'UCHUMAYO',
            ubigeo: '040124'
          },
          {
            codigo: 40125,
            nombre: 'VITOR',
            ubigeo: '040125'
          },
          {
            codigo: 40126,
            nombre: 'YANAHUARA',
            ubigeo: '040126'
          },
          {
            codigo: 40127,
            nombre: 'YARABAMBA',
            ubigeo: '040127'
          },
          {
            codigo: 40128,
            nombre: 'YURA',
            ubigeo: '040128'
          }
        ]
      },
      {
        codigo: 402,
        nombre: 'CAMANA',
        distritos: [
          {
            codigo: 40201,
            nombre: 'CAMANA',
            ubigeo: '040201'
          },
          {
            codigo: 40202,
            nombre: 'J.MARIA QUIMPER',
            ubigeo: '040202'
          },
          {
            codigo: 40203,
            nombre: 'M.NICOLAS VALCARC',
            ubigeo: '040203'
          },
          {
            codigo: 40204,
            nombre: 'MARISCAL CACERES',
            ubigeo: '040204'
          },
          {
            codigo: 40205,
            nombre: 'NICOLAS DE PIEROL',
            ubigeo: '040205'
          },
          {
            codigo: 40206,
            nombre: 'OCOÑA',
            ubigeo: '040206'
          },
          {
            codigo: 40207,
            nombre: 'QUILCA',
            ubigeo: '040207'
          },
          {
            codigo: 40208,
            nombre: 'SAMUEL PASTOR',
            ubigeo: '040208'
          }
        ]
      },
      {
        codigo: 403,
        nombre: 'CARAVELI',
        distritos: [
          {
            codigo: 40302,
            nombre: 'ACARI',
            ubigeo: '040302'
          },
          {
            codigo: 40303,
            nombre: 'ATICO',
            ubigeo: '040303'
          },
          {
            codigo: 40304,
            nombre: 'ATIQUIPA',
            ubigeo: '040304'
          },
          {
            codigo: 40305,
            nombre: 'BELLA UNION',
            ubigeo: '040305'
          },
          {
            codigo: 40306,
            nombre: 'CAHUACHO',
            ubigeo: '040306'
          },
          {
            codigo: 40301,
            nombre: 'CARAVELI',
            ubigeo: '040301'
          },
          {
            codigo: 40307,
            nombre: 'CHALA',
            ubigeo: '040307'
          },
          {
            codigo: 40308,
            nombre: 'CHAPARRA',
            ubigeo: '040308'
          },
          {
            codigo: 40309,
            nombre: 'HUANUHUANU',
            ubigeo: '040309'
          },
          {
            codigo: 40310,
            nombre: 'JAQUI',
            ubigeo: '040310'
          },
          {
            codigo: 40311,
            nombre: 'LOMAS',
            ubigeo: '040311'
          },
          {
            codigo: 40312,
            nombre: 'QUICACHA',
            ubigeo: '040312'
          },
          {
            codigo: 40313,
            nombre: 'YAUCA',
            ubigeo: '040313'
          }
        ]
      },
      {
        codigo: 404,
        nombre: 'CASTILLA',
        distritos: [
          {
            codigo: 40402,
            nombre: 'ANDAGUA',
            ubigeo: '040402'
          },
          {
            codigo: 40401,
            nombre: 'APLAO',
            ubigeo: '040401'
          },
          {
            codigo: 40403,
            nombre: 'AYO',
            ubigeo: '040403'
          },
          {
            codigo: 40404,
            nombre: 'CHACHAS',
            ubigeo: '040404'
          },
          {
            codigo: 40405,
            nombre: 'CHILCAYMARCA',
            ubigeo: '040405'
          },
          {
            codigo: 40406,
            nombre: 'CHOCO',
            ubigeo: '040406'
          },
          {
            codigo: 40407,
            nombre: 'HUANCARQUI',
            ubigeo: '040407'
          },
          {
            codigo: 40408,
            nombre: 'MACHAGUAY',
            ubigeo: '040408'
          },
          {
            codigo: 40409,
            nombre: 'ORCOPAMPA',
            ubigeo: '040409'
          },
          {
            codigo: 40410,
            nombre: 'PAMPACOLCA',
            ubigeo: '040410'
          },
          {
            codigo: 40411,
            nombre: 'TIPAN',
            ubigeo: '040411'
          },
          {
            codigo: 40413,
            nombre: 'URACA',
            ubigeo: '040413'
          },
          {
            codigo: 40412,
            nombre: 'UÑON',
            ubigeo: '040412'
          },
          {
            codigo: 40414,
            nombre: 'VIRACO',
            ubigeo: '040414'
          }
        ]
      },
      {
        codigo: 405,
        nombre: 'CAYLLOMA',
        distritos: [
          {
            codigo: 40502,
            nombre: 'ACHOMA',
            ubigeo: '040502'
          },
          {
            codigo: 40503,
            nombre: 'CABANACONDE',
            ubigeo: '040503'
          },
          {
            codigo: 40504,
            nombre: 'CALLALLI',
            ubigeo: '040504'
          },
          {
            codigo: 40505,
            nombre: 'CAYLLOMA',
            ubigeo: '040505'
          },
          {
            codigo: 40501,
            nombre: 'CHIVAY',
            ubigeo: '040501'
          },
          {
            codigo: 40506,
            nombre: 'COPORAQUE',
            ubigeo: '040506'
          },
          {
            codigo: 40507,
            nombre: 'HUAMBO',
            ubigeo: '040507'
          },
          {
            codigo: 40508,
            nombre: 'HUANCA',
            ubigeo: '040508'
          },
          {
            codigo: 40509,
            nombre: 'ICHUPAMPA',
            ubigeo: '040509'
          },
          {
            codigo: 40510,
            nombre: 'LARI',
            ubigeo: '040510'
          },
          {
            codigo: 40511,
            nombre: 'LLUTA',
            ubigeo: '040511'
          },
          {
            codigo: 40512,
            nombre: 'MACA',
            ubigeo: '040512'
          },
          {
            codigo: 40513,
            nombre: 'MADRIGAL',
            ubigeo: '040513'
          },
          {
            codigo: 40520,
            nombre: 'MAJES',
            ubigeo: '040520'
          },
          {
            codigo: 40514,
            nombre: 'S.ANTONIO D.CHUCA',
            ubigeo: '040514'
          },
          {
            codigo: 40515,
            nombre: 'SIBAYO',
            ubigeo: '040515'
          },
          {
            codigo: 40516,
            nombre: 'TAPAY',
            ubigeo: '040516'
          },
          {
            codigo: 40517,
            nombre: 'TISCO',
            ubigeo: '040517'
          },
          {
            codigo: 40518,
            nombre: 'TUTI',
            ubigeo: '040518'
          },
          {
            codigo: 40519,
            nombre: 'YANQUE',
            ubigeo: '040519'
          }
        ]
      },
      {
        codigo: 406,
        nombre: 'CONDESUYOS',
        distritos: [
          {
            codigo: 40602,
            nombre: 'ANDARAY',
            ubigeo: '040602'
          },
          {
            codigo: 40603,
            nombre: 'CAYARANI',
            ubigeo: '040603'
          },
          {
            codigo: 40604,
            nombre: 'CHICHAS',
            ubigeo: '040604'
          },
          {
            codigo: 40601,
            nombre: 'CHUQUIBAMBA',
            ubigeo: '040601'
          },
          {
            codigo: 40605,
            nombre: 'IRAY',
            ubigeo: '040605'
          },
          {
            codigo: 40606,
            nombre: 'RIO GRANDE',
            ubigeo: '040606'
          },
          {
            codigo: 40607,
            nombre: 'SALAMANCA',
            ubigeo: '040607'
          },
          {
            codigo: 40608,
            nombre: 'YANAQUIHUA',
            ubigeo: '040608'
          }
        ]
      },
      {
        codigo: 407,
        nombre: 'ISLAY',
        distritos: [
          {
            codigo: 40702,
            nombre: 'COCACHACRA',
            ubigeo: '040702'
          },
          {
            codigo: 40703,
            nombre: 'DEAN VALDIVIA',
            ubigeo: '040703'
          },
          {
            codigo: 40704,
            nombre: 'ISLAY',
            ubigeo: '040704'
          },
          {
            codigo: 40705,
            nombre: 'MEJIA',
            ubigeo: '040705'
          },
          {
            codigo: 40701,
            nombre: 'MOLLENDO',
            ubigeo: '040701'
          },
          {
            codigo: 40706,
            nombre: 'PUNTA DE BOMBON',
            ubigeo: '040706'
          }
        ]
      },
      {
        codigo: 408,
        nombre: 'LA UNION',
        distritos: [
          {
            codigo: 40802,
            nombre: 'ALCA',
            ubigeo: '040802'
          },
          {
            codigo: 40803,
            nombre: 'CHARCANA',
            ubigeo: '040803'
          },
          {
            codigo: 40801,
            nombre: 'COTAHUASI',
            ubigeo: '040801'
          },
          {
            codigo: 40804,
            nombre: 'HUAYNACOTAS',
            ubigeo: '040804'
          },
          {
            codigo: 40805,
            nombre: 'PAMPAMARCA',
            ubigeo: '040805'
          },
          {
            codigo: 40806,
            nombre: 'PUYCA',
            ubigeo: '040806'
          },
          {
            codigo: 40807,
            nombre: 'QUECHUALLA',
            ubigeo: '040807'
          },
          {
            codigo: 40808,
            nombre: 'SAYLA',
            ubigeo: '040808'
          },
          {
            codigo: 40809,
            nombre: 'TAURIA',
            ubigeo: '040809'
          },
          {
            codigo: 40810,
            nombre: 'TOMEPAMPA',
            ubigeo: '040810'
          },
          {
            codigo: 40811,
            nombre: 'TORO',
            ubigeo: '040811'
          }
        ]
      }
    ]
  },
  {
    codigo: 5,
    nombre: 'AYACUCHO',
    provincias: [
      {
        codigo: 502,
        nombre: 'CANGALLO',
        distritos: [
          {
            codigo: 50201,
            nombre: 'CANGALLO',
            ubigeo: '050201'
          },
          {
            codigo: 50202,
            nombre: 'CHUSCHI',
            ubigeo: '050202'
          },
          {
            codigo: 50203,
            nombre: 'LOS MOROCHUCOS',
            ubigeo: '050203'
          },
          {
            codigo: 50204,
            nombre: 'MARIA PARADO DE',
            ubigeo: '050204'
          },
          {
            codigo: 50205,
            nombre: 'PARAS',
            ubigeo: '050205'
          },
          {
            codigo: 50206,
            nombre: 'TOTOS',
            ubigeo: '050206'
          }
        ]
      },
      {
        codigo: 501,
        nombre: 'HUAMANGA',
        distritos: [
          {
            codigo: 50102,
            nombre: 'ACOCRO',
            ubigeo: '050102'
          },
          {
            codigo: 50103,
            nombre: 'ACOS VINCHOS',
            ubigeo: '050103'
          },
          {
            codigo: 50101,
            nombre: 'AYACUCHO',
            ubigeo: '050101'
          },
          {
            codigo: 50104,
            nombre: 'CARMEN ALTO',
            ubigeo: '050104'
          },
          {
            codigo: 50105,
            nombre: 'CHIARA',
            ubigeo: '050105'
          },
          {
            codigo: 50115,
            nombre: 'JESUS NAZARENO',
            ubigeo: '050115'
          },
          {
            codigo: 50106,
            nombre: 'OCROS',
            ubigeo: '050106'
          },
          {
            codigo: 50107,
            nombre: 'PACAYCASA',
            ubigeo: '050107'
          },
          {
            codigo: 50108,
            nombre: 'QUINUA',
            ubigeo: '050108'
          },
          {
            codigo: 50109,
            nombre: 'SAN JOSE DE TIC',
            ubigeo: '050109'
          },
          {
            codigo: 50110,
            nombre: 'SAN JUAN BAUTIS',
            ubigeo: '050110'
          },
          {
            codigo: 50111,
            nombre: 'SANTIAGO DE PIS',
            ubigeo: '050111'
          },
          {
            codigo: 50112,
            nombre: 'SOCOS',
            ubigeo: '050112'
          },
          {
            codigo: 50113,
            nombre: 'TAMBILLO',
            ubigeo: '050113'
          },
          {
            codigo: 50114,
            nombre: 'VINCHOS',
            ubigeo: '050114'
          }
        ]
      },
      {
        codigo: 503,
        nombre: 'HUANCA SANCOS',
        distritos: [
          {
            codigo: 50302,
            nombre: 'CARAPO',
            ubigeo: '050302'
          },
          {
            codigo: 50303,
            nombre: 'SACSAMARCA',
            ubigeo: '050303'
          },
          {
            codigo: 50301,
            nombre: 'SANCOS',
            ubigeo: '050301'
          },
          {
            codigo: 50304,
            nombre: 'SANTIAGO DE LUC',
            ubigeo: '050304'
          }
        ]
      },
      {
        codigo: 504,
        nombre: 'HUANTA',
        distritos: [
          {
            codigo: 50402,
            nombre: 'AYAHUANCO',
            ubigeo: '050402'
          },
          {
            codigo: 50403,
            nombre: 'HUAMANGUILLA',
            ubigeo: '050403'
          },
          {
            codigo: 50401,
            nombre: 'HUANTA',
            ubigeo: '050401'
          },
          {
            codigo: 50404,
            nombre: 'IGUAIN',
            ubigeo: '050404'
          },
          {
            codigo: 50408,
            nombre: 'LLOCHEGUA',
            ubigeo: '050408'
          },
          {
            codigo: 50405,
            nombre: 'LURICOCHA',
            ubigeo: '050405'
          },
          {
            codigo: 50406,
            nombre: 'SANTILLANA',
            ubigeo: '050406'
          },
          {
            codigo: 50407,
            nombre: 'SIVIA',
            ubigeo: '050407'
          }
        ]
      },
      {
        codigo: 505,
        nombre: 'LA MAR',
        distritos: [
          {
            codigo: 50502,
            nombre: 'ANCO',
            ubigeo: '050502'
          },
          {
            codigo: 50503,
            nombre: 'AYNA',
            ubigeo: '050503'
          },
          {
            codigo: 50504,
            nombre: 'CHILCAS',
            ubigeo: '050504'
          },
          {
            codigo: 50505,
            nombre: 'CHUNGUI',
            ubigeo: '050505'
          },
          {
            codigo: 50506,
            nombre: 'LUIS CARRANZA',
            ubigeo: '050506'
          },
          {
            codigo: 50501,
            nombre: 'SAN MIGUEL',
            ubigeo: '050501'
          },
          {
            codigo: 50507,
            nombre: 'SANTA ROSA',
            ubigeo: '050507'
          },
          {
            codigo: 50508,
            nombre: 'TAMBO',
            ubigeo: '050508'
          }
        ]
      },
      {
        codigo: 506,
        nombre: 'LUCANAS',
        distritos: [
          {
            codigo: 50602,
            nombre: 'AUCARA',
            ubigeo: '050602'
          },
          {
            codigo: 50603,
            nombre: 'CABANA',
            ubigeo: '050603'
          },
          {
            codigo: 50604,
            nombre: 'CARMEN SALCEDO',
            ubigeo: '050604'
          },
          {
            codigo: 50605,
            nombre: 'CHAVIÑA',
            ubigeo: '050605'
          },
          {
            codigo: 50606,
            nombre: 'CHIPAO',
            ubigeo: '050606'
          },
          {
            codigo: 50607,
            nombre: 'HUAC-HUAS',
            ubigeo: '050607'
          },
          {
            codigo: 50608,
            nombre: 'LARAMATE',
            ubigeo: '050608'
          },
          {
            codigo: 50609,
            nombre: 'LEONCIO PRADO',
            ubigeo: '050609'
          },
          {
            codigo: 50610,
            nombre: 'LLAUTA',
            ubigeo: '050610'
          },
          {
            codigo: 50611,
            nombre: 'LUCANAS',
            ubigeo: '050611'
          },
          {
            codigo: 50612,
            nombre: 'OCAÑA',
            ubigeo: '050612'
          },
          {
            codigo: 50613,
            nombre: 'OTOCA',
            ubigeo: '050613'
          },
          {
            codigo: 50601,
            nombre: 'PUQUIO',
            ubigeo: '050601'
          },
          {
            codigo: 50614,
            nombre: 'SAISA',
            ubigeo: '050614'
          },
          {
            codigo: 50615,
            nombre: 'SAN CRISTOBAL',
            ubigeo: '050615'
          },
          {
            codigo: 50616,
            nombre: 'SAN JUAN',
            ubigeo: '050616'
          },
          {
            codigo: 50617,
            nombre: 'SAN PEDRO',
            ubigeo: '050617'
          },
          {
            codigo: 50618,
            nombre: 'SAN PEDRO DE PA',
            ubigeo: '050618'
          },
          {
            codigo: 50619,
            nombre: 'SANCOS',
            ubigeo: '050619'
          },
          {
            codigo: 50620,
            nombre: 'SANTA ANA DE HU',
            ubigeo: '050620'
          },
          {
            codigo: 50621,
            nombre: 'SANTA LUCIA',
            ubigeo: '050621'
          }
        ]
      },
      {
        codigo: 507,
        nombre: 'PARINACOCHAS',
        distritos: [
          {
            codigo: 50702,
            nombre: 'CHUMPI',
            ubigeo: '050702'
          },
          {
            codigo: 50701,
            nombre: 'CORACORA',
            ubigeo: '050701'
          },
          {
            codigo: 50703,
            nombre: 'CORONEL CASTAÑE',
            ubigeo: '050703'
          },
          {
            codigo: 50704,
            nombre: 'PACAPAUSA',
            ubigeo: '050704'
          },
          {
            codigo: 50705,
            nombre: 'PULLO',
            ubigeo: '050705'
          },
          {
            codigo: 50706,
            nombre: 'PUYUSCA',
            ubigeo: '050706'
          },
          {
            codigo: 50707,
            nombre: 'SAN FRANCISCO D',
            ubigeo: '050707'
          },
          {
            codigo: 50708,
            nombre: 'UPAHUACHO',
            ubigeo: '050708'
          }
        ]
      },
      {
        codigo: 508,
        nombre: 'PAUCAR DEL SARA',
        distritos: [
          {
            codigo: 50802,
            nombre: 'COLTA',
            ubigeo: '050802'
          },
          {
            codigo: 50803,
            nombre: 'CORCULLA',
            ubigeo: '050803'
          },
          {
            codigo: 50804,
            nombre: 'LAMPA',
            ubigeo: '050804'
          },
          {
            codigo: 50805,
            nombre: 'MARCABAMBA',
            ubigeo: '050805'
          },
          {
            codigo: 50806,
            nombre: 'OYOLO',
            ubigeo: '050806'
          },
          {
            codigo: 50807,
            nombre: 'PARARCA',
            ubigeo: '050807'
          },
          {
            codigo: 50801,
            nombre: 'PAUSA',
            ubigeo: '050801'
          },
          {
            codigo: 50808,
            nombre: 'SAN JAVIER DE A',
            ubigeo: '050808'
          },
          {
            codigo: 50809,
            nombre: 'SAN JOSE DE USH',
            ubigeo: '050809'
          },
          {
            codigo: 50810,
            nombre: 'SARA SARA',
            ubigeo: '050810'
          }
        ]
      },
      {
        codigo: 509,
        nombre: 'SUCRE',
        distritos: [
          {
            codigo: 50902,
            nombre: 'BELEN',
            ubigeo: '050902'
          },
          {
            codigo: 50903,
            nombre: 'CHALCOS',
            ubigeo: '050903'
          },
          {
            codigo: 50904,
            nombre: 'CHILCAYOC',
            ubigeo: '050904'
          },
          {
            codigo: 50905,
            nombre: 'HUACAÑA',
            ubigeo: '050905'
          },
          {
            codigo: 50906,
            nombre: 'MORCOLLA',
            ubigeo: '050906'
          },
          {
            codigo: 50907,
            nombre: 'PAICO',
            ubigeo: '050907'
          },
          {
            codigo: 50901,
            nombre: 'QUEROBAMBA',
            ubigeo: '050901'
          },
          {
            codigo: 50908,
            nombre: 'SAN PEDRO DE LA',
            ubigeo: '050908'
          },
          {
            codigo: 50909,
            nombre: 'SAN SALVADOR DE',
            ubigeo: '050909'
          },
          {
            codigo: 50910,
            nombre: 'SANTIAGO DE PAU',
            ubigeo: '050910'
          },
          {
            codigo: 50911,
            nombre: 'SORAS',
            ubigeo: '050911'
          }
        ]
      },
      {
        codigo: 510,
        nombre: 'VICTOR FAJARDO',
        distritos: [
          {
            codigo: 51002,
            nombre: 'ALCAMENCA',
            ubigeo: '051002'
          },
          {
            codigo: 51003,
            nombre: 'APONGO',
            ubigeo: '051003'
          },
          {
            codigo: 51004,
            nombre: 'ASQUIPATA',
            ubigeo: '051004'
          },
          {
            codigo: 51005,
            nombre: 'CANARIA',
            ubigeo: '051005'
          },
          {
            codigo: 51006,
            nombre: 'CAYARA',
            ubigeo: '051006'
          },
          {
            codigo: 51007,
            nombre: 'COLCA',
            ubigeo: '051007'
          },
          {
            codigo: 51008,
            nombre: 'HUAMANQUIQUIA',
            ubigeo: '051008'
          },
          {
            codigo: 51001,
            nombre: 'HUANCAPI',
            ubigeo: '051001'
          },
          {
            codigo: 51009,
            nombre: 'HUANCARAYLLA',
            ubigeo: '051009'
          },
          {
            codigo: 51010,
            nombre: 'HUAYA',
            ubigeo: '051010'
          },
          {
            codigo: 51011,
            nombre: 'SARHUA',
            ubigeo: '051011'
          },
          {
            codigo: 51012,
            nombre: 'VILCANCHOS',
            ubigeo: '051012'
          }
        ]
      },
      {
        codigo: 511,
        nombre: 'VILCAS HUAMAN',
        distritos: [
          {
            codigo: 51102,
            nombre: 'ACCOMARCA',
            ubigeo: '051102'
          },
          {
            codigo: 51103,
            nombre: 'CARHUANCA',
            ubigeo: '051103'
          },
          {
            codigo: 51104,
            nombre: 'CONCEPCION',
            ubigeo: '051104'
          },
          {
            codigo: 51105,
            nombre: 'HUAMBALPA',
            ubigeo: '051105'
          },
          {
            codigo: 51106,
            nombre: 'INDEPENDENCIA',
            ubigeo: '051106'
          },
          {
            codigo: 51107,
            nombre: 'SAURAMA',
            ubigeo: '051107'
          },
          {
            codigo: 51101,
            nombre: 'VILCAS HUAMAN',
            ubigeo: '051101'
          },
          {
            codigo: 51108,
            nombre: 'VISCHONGO',
            ubigeo: '051108'
          }
        ]
      }
    ]
  },
  {
    codigo: 6,
    nombre: 'CAJAMARCA',
    provincias: [
      {
        codigo: 602,
        nombre: 'CAJABAMBA',
        distritos: [
          {
            codigo: 60202,
            nombre: 'CACHACHI',
            ubigeo: '060202'
          },
          {
            codigo: 60201,
            nombre: 'CAJABAMBA',
            ubigeo: '060201'
          },
          {
            codigo: 60203,
            nombre: 'CONDEBAMBA',
            ubigeo: '060203'
          },
          {
            codigo: 60204,
            nombre: 'SITACOCHA',
            ubigeo: '060204'
          }
        ]
      },
      {
        codigo: 601,
        nombre: 'CAJAMARCA',
        distritos: [
          {
            codigo: 60102,
            nombre: 'ASUNCION',
            ubigeo: '060102'
          },
          {
            codigo: 60101,
            nombre: 'CAJAMARCA',
            ubigeo: '060101'
          },
          {
            codigo: 60103,
            nombre: 'CHETILLA',
            ubigeo: '060103'
          },
          {
            codigo: 60104,
            nombre: 'COSPAN',
            ubigeo: '060104'
          },
          {
            codigo: 60105,
            nombre: 'ENCAÑADA',
            ubigeo: '060105'
          },
          {
            codigo: 60106,
            nombre: 'JESUS',
            ubigeo: '060106'
          },
          {
            codigo: 60107,
            nombre: 'LLACANORA',
            ubigeo: '060107'
          },
          {
            codigo: 60108,
            nombre: 'LOS BAÑOS DEL I',
            ubigeo: '060108'
          },
          {
            codigo: 60109,
            nombre: 'MAGDALENA',
            ubigeo: '060109'
          },
          {
            codigo: 60110,
            nombre: 'MATARA',
            ubigeo: '060110'
          },
          {
            codigo: 60111,
            nombre: 'NAMORA',
            ubigeo: '060111'
          },
          {
            codigo: 60112,
            nombre: 'SAN JUAN',
            ubigeo: '060112'
          }
        ]
      },
      {
        codigo: 603,
        nombre: 'CELENDIN',
        distritos: [
          {
            codigo: 60301,
            nombre: 'CELENDIN',
            ubigeo: '060301'
          },
          {
            codigo: 60302,
            nombre: 'CHUMUCH',
            ubigeo: '060302'
          },
          {
            codigo: 60303,
            nombre: 'CORTEGANA',
            ubigeo: '060303'
          },
          {
            codigo: 60304,
            nombre: 'HUASMIN',
            ubigeo: '060304'
          },
          {
            codigo: 60305,
            nombre: 'JORGE CHAVEZ',
            ubigeo: '060305'
          },
          {
            codigo: 60306,
            nombre: 'JOSE GALVEZ',
            ubigeo: '060306'
          },
          {
            codigo: 60312,
            nombre: 'LA LIBERTAD DE',
            ubigeo: '060312'
          },
          {
            codigo: 60307,
            nombre: 'MIGUEL IGLESIAS',
            ubigeo: '060307'
          },
          {
            codigo: 60308,
            nombre: 'OXAMARCA',
            ubigeo: '060308'
          },
          {
            codigo: 60309,
            nombre: 'SOROCHUCO',
            ubigeo: '060309'
          },
          {
            codigo: 60310,
            nombre: 'SUCRE',
            ubigeo: '060310'
          },
          {
            codigo: 60311,
            nombre: 'UTCO',
            ubigeo: '060311'
          }
        ]
      },
      {
        codigo: 604,
        nombre: 'CHOTA',
        distritos: [
          {
            codigo: 60402,
            nombre: 'ANGUIA',
            ubigeo: '060402'
          },
          {
            codigo: 60403,
            nombre: 'CHADIN',
            ubigeo: '060403'
          },
          {
            codigo: 60419,
            nombre: 'CHALAMARCA',
            ubigeo: '060419'
          },
          {
            codigo: 60404,
            nombre: 'CHIGUIRIP',
            ubigeo: '060404'
          },
          {
            codigo: 60405,
            nombre: 'CHIMBAN',
            ubigeo: '060405'
          },
          {
            codigo: 60406,
            nombre: 'CHOROPAMPA',
            ubigeo: '060406'
          },
          {
            codigo: 60401,
            nombre: 'CHOTA',
            ubigeo: '060401'
          },
          {
            codigo: 60407,
            nombre: 'COCHABAMBA',
            ubigeo: '060407'
          },
          {
            codigo: 60408,
            nombre: 'CONCHAN',
            ubigeo: '060408'
          },
          {
            codigo: 60409,
            nombre: 'HUAMBOS',
            ubigeo: '060409'
          },
          {
            codigo: 60410,
            nombre: 'LAJAS',
            ubigeo: '060410'
          },
          {
            codigo: 60411,
            nombre: 'LLAMA',
            ubigeo: '060411'
          },
          {
            codigo: 60412,
            nombre: 'MIRACOSTA',
            ubigeo: '060412'
          },
          {
            codigo: 60413,
            nombre: 'PACCHA',
            ubigeo: '060413'
          },
          {
            codigo: 60414,
            nombre: 'PION',
            ubigeo: '060414'
          },
          {
            codigo: 60415,
            nombre: 'QUEROCOTO',
            ubigeo: '060415'
          },
          {
            codigo: 60416,
            nombre: 'SAN JUAN DE LIC',
            ubigeo: '060416'
          },
          {
            codigo: 60417,
            nombre: 'TACABAMBA',
            ubigeo: '060417'
          },
          {
            codigo: 60418,
            nombre: 'TOCMOCHE',
            ubigeo: '060418'
          }
        ]
      },
      {
        codigo: 605,
        nombre: 'CONTUMAZA',
        distritos: [
          {
            codigo: 60502,
            nombre: 'CHILETE',
            ubigeo: '060502'
          },
          {
            codigo: 60501,
            nombre: 'CONTUMAZA',
            ubigeo: '060501'
          },
          {
            codigo: 60503,
            nombre: 'CUPISNIQUE',
            ubigeo: '060503'
          },
          {
            codigo: 60504,
            nombre: 'GUZMANGO',
            ubigeo: '060504'
          },
          {
            codigo: 60505,
            nombre: 'SAN BENITO',
            ubigeo: '060505'
          },
          {
            codigo: 60506,
            nombre: 'SANTA CRUZ DE T',
            ubigeo: '060506'
          },
          {
            codigo: 60507,
            nombre: 'TANTARICA',
            ubigeo: '060507'
          },
          {
            codigo: 60508,
            nombre: 'YONAN',
            ubigeo: '060508'
          }
        ]
      },
      {
        codigo: 606,
        nombre: 'CUTERVO',
        distritos: [
          {
            codigo: 60602,
            nombre: 'CALLAYUC',
            ubigeo: '060602'
          },
          {
            codigo: 60603,
            nombre: 'CHOROS',
            ubigeo: '060603'
          },
          {
            codigo: 60604,
            nombre: 'CUJILLO',
            ubigeo: '060604'
          },
          {
            codigo: 60601,
            nombre: 'CUTERVO',
            ubigeo: '060601'
          },
          {
            codigo: 60605,
            nombre: 'LA RAMADA',
            ubigeo: '060605'
          },
          {
            codigo: 60606,
            nombre: 'PIMPINGOS',
            ubigeo: '060606'
          },
          {
            codigo: 60607,
            nombre: 'QUEROCOTILLO',
            ubigeo: '060607'
          },
          {
            codigo: 60608,
            nombre: 'SAN ANDRES DE C',
            ubigeo: '060608'
          },
          {
            codigo: 60609,
            nombre: 'SAN JUAN DE CUT',
            ubigeo: '060609'
          },
          {
            codigo: 60610,
            nombre: 'SAN LUIS DE LUC',
            ubigeo: '060610'
          },
          {
            codigo: 60611,
            nombre: 'SANTA CRUZ',
            ubigeo: '060611'
          },
          {
            codigo: 60612,
            nombre: 'SANTO DOMINGO D',
            ubigeo: '060612'
          },
          {
            codigo: 60613,
            nombre: 'SANTO TOMAS',
            ubigeo: '060613'
          },
          {
            codigo: 60614,
            nombre: 'SOCOTA',
            ubigeo: '060614'
          },
          {
            codigo: 60615,
            nombre: 'TORIBIO CASANOV',
            ubigeo: '060615'
          }
        ]
      },
      {
        codigo: 607,
        nombre: 'HUALGAYOC',
        distritos: [
          {
            codigo: 60701,
            nombre: 'BAMBAMARCA',
            ubigeo: '060701'
          },
          {
            codigo: 60702,
            nombre: 'CHUGUR',
            ubigeo: '060702'
          },
          {
            codigo: 60703,
            nombre: 'HUALGAYOC',
            ubigeo: '060703'
          }
        ]
      },
      {
        codigo: 608,
        nombre: 'JAEN',
        distritos: [
          {
            codigo: 60802,
            nombre: 'BELLAVISTA',
            ubigeo: '060802'
          },
          {
            codigo: 60803,
            nombre: 'CHONTALI',
            ubigeo: '060803'
          },
          {
            codigo: 60804,
            nombre: 'COLASAY',
            ubigeo: '060804'
          },
          {
            codigo: 60805,
            nombre: 'HUABAL',
            ubigeo: '060805'
          },
          {
            codigo: 60801,
            nombre: 'JAEN',
            ubigeo: '060801'
          },
          {
            codigo: 60806,
            nombre: 'LAS PIRIAS',
            ubigeo: '060806'
          },
          {
            codigo: 60807,
            nombre: 'POMAHUACA',
            ubigeo: '060807'
          },
          {
            codigo: 60808,
            nombre: 'PUCARA',
            ubigeo: '060808'
          },
          {
            codigo: 60809,
            nombre: 'SALLIQUE',
            ubigeo: '060809'
          },
          {
            codigo: 60810,
            nombre: 'SAN FELIPE',
            ubigeo: '060810'
          },
          {
            codigo: 60811,
            nombre: 'SAN JOSE DEL AL',
            ubigeo: '060811'
          },
          {
            codigo: 60812,
            nombre: 'SANTA ROSA',
            ubigeo: '060812'
          }
        ]
      },
      {
        codigo: 609,
        nombre: 'SAN IGNACIO',
        distritos: [
          {
            codigo: 60902,
            nombre: 'CHIRINOS',
            ubigeo: '060902'
          },
          {
            codigo: 60903,
            nombre: 'HUARANGO',
            ubigeo: '060903'
          },
          {
            codigo: 60904,
            nombre: 'LA COIPA',
            ubigeo: '060904'
          },
          {
            codigo: 60905,
            nombre: 'NAMBALLE',
            ubigeo: '060905'
          },
          {
            codigo: 60901,
            nombre: 'SAN IGNACIO',
            ubigeo: '060901'
          },
          {
            codigo: 60906,
            nombre: 'SAN JOSE DE LOU',
            ubigeo: '060906'
          },
          {
            codigo: 60907,
            nombre: 'TABACONAS',
            ubigeo: '060907'
          }
        ]
      },
      {
        codigo: 610,
        nombre: 'SAN MARCOS',
        distritos: [
          {
            codigo: 61002,
            nombre: 'CHANCAY',
            ubigeo: '061002'
          },
          {
            codigo: 61003,
            nombre: 'EDUARDO VILLANU',
            ubigeo: '061003'
          },
          {
            codigo: 61004,
            nombre: 'GREGORIO PITA',
            ubigeo: '061004'
          },
          {
            codigo: 61005,
            nombre: 'ICHOCAN',
            ubigeo: '061005'
          },
          {
            codigo: 61006,
            nombre: 'JOSE MANUEL QUI',
            ubigeo: '061006'
          },
          {
            codigo: 61007,
            nombre: 'JOSE SABOGAL',
            ubigeo: '061007'
          },
          {
            codigo: 61001,
            nombre: 'PEDRO GALVEZ',
            ubigeo: '061001'
          }
        ]
      },
      {
        codigo: 611,
        nombre: 'SAN MIGUEL',
        distritos: [
          {
            codigo: 61102,
            nombre: 'BOLIVAR',
            ubigeo: '061102'
          },
          {
            codigo: 61103,
            nombre: 'CALQUIS',
            ubigeo: '061103'
          },
          {
            codigo: 61104,
            nombre: 'CATILLUC',
            ubigeo: '061104'
          },
          {
            codigo: 61105,
            nombre: 'EL PRADO',
            ubigeo: '061105'
          },
          {
            codigo: 61106,
            nombre: 'LA FLORIDA',
            ubigeo: '061106'
          },
          {
            codigo: 61107,
            nombre: 'LLAPA',
            ubigeo: '061107'
          },
          {
            codigo: 61108,
            nombre: 'NANCHOC',
            ubigeo: '061108'
          },
          {
            codigo: 61109,
            nombre: 'NIEPOS',
            ubigeo: '061109'
          },
          {
            codigo: 61110,
            nombre: 'SAN GREGORIO',
            ubigeo: '061110'
          },
          {
            codigo: 61101,
            nombre: 'SAN MIGUEL',
            ubigeo: '061101'
          },
          {
            codigo: 61111,
            nombre: 'SAN SILVESTRE D',
            ubigeo: '061111'
          },
          {
            codigo: 61112,
            nombre: 'TONGOD',
            ubigeo: '061112'
          },
          {
            codigo: 61113,
            nombre: 'UNION AGUA BLAN',
            ubigeo: '061113'
          }
        ]
      },
      {
        codigo: 612,
        nombre: 'SAN PABLO',
        distritos: [
          {
            codigo: 61202,
            nombre: 'SAN BERNARDINO',
            ubigeo: '061202'
          },
          {
            codigo: 61203,
            nombre: 'SAN LUIS',
            ubigeo: '061203'
          },
          {
            codigo: 61201,
            nombre: 'SAN PABLO',
            ubigeo: '061201'
          },
          {
            codigo: 61204,
            nombre: 'TUMBADEN',
            ubigeo: '061204'
          }
        ]
      },
      {
        codigo: 613,
        nombre: 'SANTA CRUZ',
        distritos: [
          {
            codigo: 61302,
            nombre: 'ANDABAMBA',
            ubigeo: '061302'
          },
          {
            codigo: 61303,
            nombre: 'CATACHE',
            ubigeo: '061303'
          },
          {
            codigo: 61304,
            nombre: 'CHANCAYBAÑOS',
            ubigeo: '061304'
          },
          {
            codigo: 61305,
            nombre: 'LA ESPERANZA',
            ubigeo: '061305'
          },
          {
            codigo: 61306,
            nombre: 'NINABAMBA',
            ubigeo: '061306'
          },
          {
            codigo: 61307,
            nombre: 'PULAN',
            ubigeo: '061307'
          },
          {
            codigo: 61301,
            nombre: 'SANTA CRUZ',
            ubigeo: '061301'
          },
          {
            codigo: 61308,
            nombre: 'SAUCEPAMPA',
            ubigeo: '061308'
          },
          {
            codigo: 61309,
            nombre: 'SEXI',
            ubigeo: '061309'
          },
          {
            codigo: 61310,
            nombre: 'UTICYACU',
            ubigeo: '061310'
          },
          {
            codigo: 61311,
            nombre: 'YAUYUCAN',
            ubigeo: '061311'
          }
        ]
      }
    ]
  },
  {
    codigo: 7,
    nombre: 'CALLAO',
    provincias: [
      {
        codigo: 700,
        nombre: 'CALLAO',
        distritos: [
          {
            codigo: 70002,
            nombre: 'BELLAVISTA',
            ubigeo: '070102'
          },
          {
            codigo: 70001,
            nombre: 'CALLAO',
            ubigeo: '070101'
          },
          {
            codigo: 70003,
            nombre: 'CARMEN DE LA LEGUA',
            ubigeo: '070103'
          },
          {
            codigo: 70004,
            nombre: 'LA PERLA',
            ubigeo: '070104'
          },
          {
            codigo: 70005,
            nombre: 'LA PUNTA',
            ubigeo: '070105'
          },
          {
            codigo: 70006,
            nombre: 'VENTANILLA',
            ubigeo: '070106'
          }
        ]
      }
    ]
  },
  {
    codigo: 8,
    nombre: 'CUSCO',
    provincias: [
      {
        codigo: 802,
        nombre: 'ACOMAYO',
        distritos: [
          {
            codigo: 80201,
            nombre: 'ACOMAYO',
            ubigeo: '080201'
          },
          {
            codigo: 80202,
            nombre: 'ACOPIA',
            ubigeo: '080202'
          },
          {
            codigo: 80203,
            nombre: 'ACOS',
            ubigeo: '080203'
          },
          {
            codigo: 80204,
            nombre: 'MOSOC LLACTA',
            ubigeo: '080204'
          },
          {
            codigo: 80205,
            nombre: 'POMACANCHI',
            ubigeo: '080205'
          },
          {
            codigo: 80206,
            nombre: 'RONDOCAN',
            ubigeo: '080206'
          },
          {
            codigo: 80207,
            nombre: 'SANGARARA',
            ubigeo: '080207'
          }
        ]
      },
      {
        codigo: 803,
        nombre: 'ANTA',
        distritos: [
          {
            codigo: 80302,
            nombre: 'ANCAHUASI',
            ubigeo: '080302'
          },
          {
            codigo: 80301,
            nombre: 'ANTA',
            ubigeo: '080301'
          },
          {
            codigo: 80303,
            nombre: 'CACHIMAYO',
            ubigeo: '080303'
          },
          {
            codigo: 80304,
            nombre: 'CHINCHAYPUJIO',
            ubigeo: '080304'
          },
          {
            codigo: 80305,
            nombre: 'HUAROCONDO',
            ubigeo: '080305'
          },
          {
            codigo: 80306,
            nombre: 'LIMATAMBO',
            ubigeo: '080306'
          },
          {
            codigo: 80307,
            nombre: 'MOLLEPATA',
            ubigeo: '080307'
          },
          {
            codigo: 80308,
            nombre: 'PUCYURA',
            ubigeo: '080308'
          },
          {
            codigo: 80309,
            nombre: 'ZURITE',
            ubigeo: '080309'
          }
        ]
      },
      {
        codigo: 804,
        nombre: 'CALCA',
        distritos: [
          {
            codigo: 80401,
            nombre: 'CALCA',
            ubigeo: '080401'
          },
          {
            codigo: 80402,
            nombre: 'COYA',
            ubigeo: '080402'
          },
          {
            codigo: 80403,
            nombre: 'LAMAY',
            ubigeo: '080403'
          },
          {
            codigo: 80404,
            nombre: 'LARES',
            ubigeo: '080404'
          },
          {
            codigo: 80405,
            nombre: 'PISAC',
            ubigeo: '080405'
          },
          {
            codigo: 80406,
            nombre: 'SAN SALVADOR',
            ubigeo: '080406'
          },
          {
            codigo: 80407,
            nombre: 'TARAY',
            ubigeo: '080407'
          },
          {
            codigo: 80408,
            nombre: 'YANATILE',
            ubigeo: '080408'
          }
        ]
      },
      {
        codigo: 805,
        nombre: 'CANAS',
        distritos: [
          {
            codigo: 80502,
            nombre: 'CHECCA',
            ubigeo: '080502'
          },
          {
            codigo: 80503,
            nombre: 'KUNTURKANKI',
            ubigeo: '080503'
          },
          {
            codigo: 80504,
            nombre: 'LANGUI',
            ubigeo: '080504'
          },
          {
            codigo: 80505,
            nombre: 'LAYO',
            ubigeo: '080505'
          },
          {
            codigo: 80506,
            nombre: 'PAMPAMARCA',
            ubigeo: '080506'
          },
          {
            codigo: 80507,
            nombre: 'QUEHUE',
            ubigeo: '080507'
          },
          {
            codigo: 80508,
            nombre: 'TUPAC AMARU',
            ubigeo: '080508'
          },
          {
            codigo: 80501,
            nombre: 'YANAOCA',
            ubigeo: '080501'
          }
        ]
      },
      {
        codigo: 806,
        nombre: 'CANCHIS',
        distritos: [
          {
            codigo: 80602,
            nombre: 'CHECACUPE',
            ubigeo: '080602'
          },
          {
            codigo: 80603,
            nombre: 'COMBAPATA',
            ubigeo: '080603'
          },
          {
            codigo: 80604,
            nombre: 'MARANGANI',
            ubigeo: '080604'
          },
          {
            codigo: 80605,
            nombre: 'PITUMARCA',
            ubigeo: '080605'
          },
          {
            codigo: 80606,
            nombre: 'SAN PABLO',
            ubigeo: '080606'
          },
          {
            codigo: 80607,
            nombre: 'SAN PEDRO',
            ubigeo: '080607'
          },
          {
            codigo: 80601,
            nombre: 'SICUANI',
            ubigeo: '080601'
          },
          {
            codigo: 80608,
            nombre: 'TINTA',
            ubigeo: '080608'
          }
        ]
      },
      {
        codigo: 807,
        nombre: 'CHUMBIVILCAS',
        distritos: [
          {
            codigo: 80702,
            nombre: 'CAPACMARCA',
            ubigeo: '080702'
          },
          {
            codigo: 80703,
            nombre: 'CHAMACA',
            ubigeo: '080703'
          },
          {
            codigo: 80704,
            nombre: 'COLQUEMARCA',
            ubigeo: '080704'
          },
          {
            codigo: 80705,
            nombre: 'LIVITACA',
            ubigeo: '080705'
          },
          {
            codigo: 80706,
            nombre: 'LLUSCO',
            ubigeo: '080706'
          },
          {
            codigo: 80707,
            nombre: 'QUIÑOTA',
            ubigeo: '080707'
          },
          {
            codigo: 80701,
            nombre: 'SANTO TOMAS',
            ubigeo: '080701'
          },
          {
            codigo: 80708,
            nombre: 'VELILLE',
            ubigeo: '080708'
          }
        ]
      },
      {
        codigo: 801,
        nombre: 'CUSCO',
        distritos: [
          {
            codigo: 80102,
            nombre: 'CCORCA',
            ubigeo: '080102'
          },
          {
            codigo: 80101,
            nombre: 'CUSCO',
            ubigeo: '080101'
          },
          {
            codigo: 80103,
            nombre: 'POROY',
            ubigeo: '080103'
          },
          {
            codigo: 80104,
            nombre: 'SAN JERONIMO',
            ubigeo: '080104'
          },
          {
            codigo: 80105,
            nombre: 'SAN SEBASTIAN',
            ubigeo: '080105'
          },
          {
            codigo: 80106,
            nombre: 'SANTIAGO',
            ubigeo: '080106'
          },
          {
            codigo: 80107,
            nombre: 'SAYLLA',
            ubigeo: '080107'
          },
          {
            codigo: 80108,
            nombre: 'WANCHAQ',
            ubigeo: '080108'
          }
        ]
      },
      {
        codigo: 808,
        nombre: 'ESPINAR',
        distritos: [
          {
            codigo: 80808,
            nombre: 'ALTO PICHIGUA',
            ubigeo: '080808'
          },
          {
            codigo: 80802,
            nombre: 'CONDOROMA',
            ubigeo: '080802'
          },
          {
            codigo: 80803,
            nombre: 'COPORAQUE',
            ubigeo: '080803'
          },
          {
            codigo: 80801,
            nombre: 'ESPINAR',
            ubigeo: '080801'
          },
          {
            codigo: 80804,
            nombre: 'OCORURO',
            ubigeo: '080804'
          },
          {
            codigo: 80805,
            nombre: 'PALLPATA',
            ubigeo: '080805'
          },
          {
            codigo: 80806,
            nombre: 'PICHIGUA',
            ubigeo: '080806'
          },
          {
            codigo: 80807,
            nombre: 'SUYCKUTAMBO',
            ubigeo: '080807'
          }
        ]
      },
      {
        codigo: 809,
        nombre: 'LA CONVENCION',
        distritos: [
          {
            codigo: 80902,
            nombre: 'ECHARATE',
            ubigeo: '080902'
          },
          {
            codigo: 80903,
            nombre: 'HUAYOPATA',
            ubigeo: '080903'
          },
          {
            codigo: 80907,
            nombre: 'KIMBIRI',
            ubigeo: '080907'
          },
          {
            codigo: 80904,
            nombre: 'MARANURA',
            ubigeo: '080904'
          },
          {
            codigo: 80905,
            nombre: 'OCOBAMBA',
            ubigeo: '080905'
          },
          {
            codigo: 80910,
            nombre: 'PICHARI',
            ubigeo: '080910'
          },
          {
            codigo: 80906,
            nombre: 'QUELLOUNO',
            ubigeo: '080906'
          },
          {
            codigo: 80901,
            nombre: 'SANTA ANA',
            ubigeo: '080901'
          },
          {
            codigo: 80908,
            nombre: 'SANTA TERESA',
            ubigeo: '080908'
          },
          {
            codigo: 80909,
            nombre: 'VILCABAMBA',
            ubigeo: '080909'
          }
        ]
      },
      {
        codigo: 810,
        nombre: 'PARURO',
        distritos: [
          {
            codigo: 81002,
            nombre: 'ACCHA',
            ubigeo: '081002'
          },
          {
            codigo: 81003,
            nombre: 'CCAPI',
            ubigeo: '081003'
          },
          {
            codigo: 81004,
            nombre: 'COLCHA',
            ubigeo: '081004'
          },
          {
            codigo: 81005,
            nombre: 'HUANOQUITE',
            ubigeo: '081005'
          },
          {
            codigo: 81006,
            nombre: 'OMACHA',
            ubigeo: '081006'
          },
          {
            codigo: 81007,
            nombre: 'PACCARITAMBO',
            ubigeo: '081007'
          },
          {
            codigo: 81001,
            nombre: 'PARURO',
            ubigeo: '081001'
          },
          {
            codigo: 81008,
            nombre: 'PILLPINTO',
            ubigeo: '081008'
          },
          {
            codigo: 81009,
            nombre: 'YAURISQUE',
            ubigeo: '081009'
          }
        ]
      },
      {
        codigo: 811,
        nombre: 'PAUCARTAMBO',
        distritos: [
          {
            codigo: 81102,
            nombre: 'CAICAY',
            ubigeo: '081102'
          },
          {
            codigo: 81103,
            nombre: 'CHALLABAMBA',
            ubigeo: '081103'
          },
          {
            codigo: 81104,
            nombre: 'COLQUEPATA',
            ubigeo: '081104'
          },
          {
            codigo: 81105,
            nombre: 'HUANCARANI',
            ubigeo: '081105'
          },
          {
            codigo: 81106,
            nombre: 'KOSÑIPATA',
            ubigeo: '081106'
          },
          {
            codigo: 81101,
            nombre: 'PAUCARTAMBO',
            ubigeo: '081101'
          }
        ]
      },
      {
        codigo: 812,
        nombre: 'QUISPICANCHI',
        distritos: [
          {
            codigo: 81202,
            nombre: 'ANDAHUAYLILLAS',
            ubigeo: '081202'
          },
          {
            codigo: 81203,
            nombre: 'CAMANTI',
            ubigeo: '081203'
          },
          {
            codigo: 81204,
            nombre: 'CCARHUAYO',
            ubigeo: '081204'
          },
          {
            codigo: 81205,
            nombre: 'CCATCA',
            ubigeo: '081205'
          },
          {
            codigo: 81206,
            nombre: 'CUSIPATA',
            ubigeo: '081206'
          },
          {
            codigo: 81207,
            nombre: 'HUARO',
            ubigeo: '081207'
          },
          {
            codigo: 81208,
            nombre: 'LUCRE',
            ubigeo: '081208'
          },
          {
            codigo: 81209,
            nombre: 'MARCAPATA',
            ubigeo: '081209'
          },
          {
            codigo: 81210,
            nombre: 'OCONGATE',
            ubigeo: '081210'
          },
          {
            codigo: 81211,
            nombre: 'OROPESA',
            ubigeo: '081211'
          },
          {
            codigo: 81212,
            nombre: 'QUIQUIJANA',
            ubigeo: '081212'
          },
          {
            codigo: 81201,
            nombre: 'URCOS',
            ubigeo: '081201'
          }
        ]
      },
      {
        codigo: 813,
        nombre: 'URUBAMBA',
        distritos: [
          {
            codigo: 81302,
            nombre: 'CHINCHERO',
            ubigeo: '081302'
          },
          {
            codigo: 81303,
            nombre: 'HUAYLLABAMBA',
            ubigeo: '081303'
          },
          {
            codigo: 81304,
            nombre: 'MACHUPICCHU',
            ubigeo: '081304'
          },
          {
            codigo: 81305,
            nombre: 'MARAS',
            ubigeo: '081305'
          },
          {
            codigo: 81306,
            nombre: 'OLLANTAYTAMBO',
            ubigeo: '081306'
          },
          {
            codigo: 81301,
            nombre: 'URUBAMBA',
            ubigeo: '081301'
          },
          {
            codigo: 81307,
            nombre: 'YUCAY',
            ubigeo: '081307'
          }
        ]
      }
    ]
  },
  {
    codigo: 9,
    nombre: 'HUANCAVELICA',
    provincias: [
      {
        codigo: 902,
        nombre: 'ACOBAMBA',
        distritos: [
          {
            codigo: 90201,
            nombre: 'ACOBAMBA',
            ubigeo: '090201'
          },
          {
            codigo: 90202,
            nombre: 'ANDABAMBA',
            ubigeo: '090202'
          },
          {
            codigo: 90203,
            nombre: 'ANTA',
            ubigeo: '090203'
          },
          {
            codigo: 90204,
            nombre: 'CAJA',
            ubigeo: '090204'
          },
          {
            codigo: 90205,
            nombre: 'MARCAS',
            ubigeo: '090205'
          },
          {
            codigo: 90206,
            nombre: 'PAUCARA',
            ubigeo: '090206'
          },
          {
            codigo: 90207,
            nombre: 'POMACOCHA',
            ubigeo: '090207'
          },
          {
            codigo: 90208,
            nombre: 'ROSARIO',
            ubigeo: '090208'
          }
        ]
      },
      {
        codigo: 903,
        nombre: 'ANGARAES',
        distritos: [
          {
            codigo: 90302,
            nombre: 'ANCHONGA',
            ubigeo: '090302'
          },
          {
            codigo: 90303,
            nombre: 'CALLANMARCA',
            ubigeo: '090303'
          },
          {
            codigo: 90304,
            nombre: 'CCOCHACCASA',
            ubigeo: '090304'
          },
          {
            codigo: 90305,
            nombre: 'CHINCHO',
            ubigeo: '090305'
          },
          {
            codigo: 90306,
            nombre: 'CONGALLA',
            ubigeo: '090306'
          },
          {
            codigo: 90307,
            nombre: 'HUANCA-HUANCA',
            ubigeo: '090307'
          },
          {
            codigo: 90308,
            nombre: 'HUAYLLAY GRANDE',
            ubigeo: '090308'
          },
          {
            codigo: 90309,
            nombre: 'JULCAMARCA',
            ubigeo: '090309'
          },
          {
            codigo: 90301,
            nombre: 'LIRCAY',
            ubigeo: '090301'
          },
          {
            codigo: 90310,
            nombre: 'SAN ANTONIO DE',
            ubigeo: '090310'
          },
          {
            codigo: 90311,
            nombre: 'SANTO TOMAS DE',
            ubigeo: '090311'
          },
          {
            codigo: 90312,
            nombre: 'SECCLLA',
            ubigeo: '090312'
          }
        ]
      },
      {
        codigo: 904,
        nombre: 'CASTROVIRREYNA',
        distritos: [
          {
            codigo: 90402,
            nombre: 'ARMA',
            ubigeo: '090402'
          },
          {
            codigo: 90403,
            nombre: 'AURAHUA',
            ubigeo: '090403'
          },
          {
            codigo: 90404,
            nombre: 'CAPILLAS',
            ubigeo: '090404'
          },
          {
            codigo: 90401,
            nombre: 'CASTROVIRREYNA',
            ubigeo: '090401'
          },
          {
            codigo: 90405,
            nombre: 'CHUPAMARCA',
            ubigeo: '090405'
          },
          {
            codigo: 90406,
            nombre: 'COCAS',
            ubigeo: '090406'
          },
          {
            codigo: 90407,
            nombre: 'HUACHOS',
            ubigeo: '090407'
          },
          {
            codigo: 90408,
            nombre: 'HUAMATAMBO',
            ubigeo: '090408'
          },
          {
            codigo: 90409,
            nombre: 'MOLLEPAMPA',
            ubigeo: '090409'
          },
          {
            codigo: 90410,
            nombre: 'SAN JUAN',
            ubigeo: '090410'
          },
          {
            codigo: 90411,
            nombre: 'SANTA ANA',
            ubigeo: '090411'
          },
          {
            codigo: 90412,
            nombre: 'TANTARA',
            ubigeo: '090412'
          },
          {
            codigo: 90413,
            nombre: 'TICRAPO',
            ubigeo: '090413'
          }
        ]
      },
      {
        codigo: 905,
        nombre: 'CHURCAMPA',
        distritos: [
          {
            codigo: 90502,
            nombre: 'ANCO',
            ubigeo: '090502'
          },
          {
            codigo: 90503,
            nombre: 'CHINCHIHUASI',
            ubigeo: '090503'
          },
          {
            codigo: 90501,
            nombre: 'CHURCAMPA',
            ubigeo: '090501'
          },
          {
            codigo: 90504,
            nombre: 'EL CARMEN',
            ubigeo: '090504'
          },
          {
            codigo: 90505,
            nombre: 'LA MERCED',
            ubigeo: '090505'
          },
          {
            codigo: 90506,
            nombre: 'LOCROJA',
            ubigeo: '090506'
          },
          {
            codigo: 90510,
            nombre: 'PACHAMARCA',
            ubigeo: '090510'
          },
          {
            codigo: 90507,
            nombre: 'PAUCARBAMBA',
            ubigeo: '090507'
          },
          {
            codigo: 90508,
            nombre: 'SAN MIGUEL DE M',
            ubigeo: '090508'
          },
          {
            codigo: 90509,
            nombre: 'SAN PEDRO DE CO',
            ubigeo: '090509'
          }
        ]
      },
      {
        codigo: 901,
        nombre: 'HUANCAVELICA',
        distritos: [
          {
            codigo: 90102,
            nombre: 'ACOBAMBILLA',
            ubigeo: '090102'
          },
          {
            codigo: 90103,
            nombre: 'ACORIA',
            ubigeo: '090103'
          },
          {
            codigo: 90118,
            nombre: 'ASCENSION',
            ubigeo: '090118'
          },
          {
            codigo: 90104,
            nombre: 'CONAYCA',
            ubigeo: '090104'
          },
          {
            codigo: 90105,
            nombre: 'CUENCA',
            ubigeo: '090105'
          },
          {
            codigo: 90106,
            nombre: 'HUACHOCOLPA',
            ubigeo: '090106'
          },
          {
            codigo: 90101,
            nombre: 'HUANCAVELICA',
            ubigeo: '090101'
          },
          {
            codigo: 90107,
            nombre: 'HUAYLLAHUARA',
            ubigeo: '090107'
          },
          {
            codigo: 90108,
            nombre: 'IZCUCHACA',
            ubigeo: '090108'
          },
          {
            codigo: 90109,
            nombre: 'LARIA',
            ubigeo: '090109'
          },
          {
            codigo: 90110,
            nombre: 'MANTA',
            ubigeo: '090110'
          },
          {
            codigo: 90111,
            nombre: 'MARISCAL CACERE',
            ubigeo: '090111'
          },
          {
            codigo: 90112,
            nombre: 'MOYA',
            ubigeo: '090112'
          },
          {
            codigo: 90113,
            nombre: 'NUEVO OCCORO',
            ubigeo: '090113'
          },
          {
            codigo: 90114,
            nombre: 'PALCA',
            ubigeo: '090114'
          },
          {
            codigo: 90115,
            nombre: 'PILCHACA',
            ubigeo: '090115'
          },
          {
            codigo: 90116,
            nombre: 'VILCA',
            ubigeo: '090116'
          },
          {
            codigo: 90117,
            nombre: 'YAULI',
            ubigeo: '090117'
          }
        ]
      },
      {
        codigo: 906,
        nombre: 'HUAYTARA',
        distritos: [
          {
            codigo: 90602,
            nombre: 'AYAVI',
            ubigeo: '090602'
          },
          {
            codigo: 90603,
            nombre: 'CORDOVA',
            ubigeo: '090603'
          },
          {
            codigo: 90604,
            nombre: 'HUAYACUNDO ARMA',
            ubigeo: '090604'
          },
          {
            codigo: 90601,
            nombre: 'HUAYTARA',
            ubigeo: '090601'
          },
          {
            codigo: 90605,
            nombre: 'LARAMARCA',
            ubigeo: '090605'
          },
          {
            codigo: 90606,
            nombre: 'OCOYO',
            ubigeo: '090606'
          },
          {
            codigo: 90607,
            nombre: 'PILPICHACA',
            ubigeo: '090607'
          },
          {
            codigo: 90608,
            nombre: 'QUERCO',
            ubigeo: '090608'
          },
          {
            codigo: 90609,
            nombre: 'QUITO-ARMA',
            ubigeo: '090609'
          },
          {
            codigo: 90610,
            nombre: 'SAN ANTONIO DE',
            ubigeo: '090610'
          },
          {
            codigo: 90611,
            nombre: 'SAN FRANCISCO D',
            ubigeo: '090611'
          },
          {
            codigo: 90612,
            nombre: 'SAN ISIDRO',
            ubigeo: '090612'
          },
          {
            codigo: 90613,
            nombre: 'SANTIAGO DE CHO',
            ubigeo: '090613'
          },
          {
            codigo: 90614,
            nombre: 'SANTIAGO DE QUI',
            ubigeo: '090614'
          },
          {
            codigo: 90615,
            nombre: 'SANTO DOMINGO D',
            ubigeo: '090615'
          },
          {
            codigo: 90616,
            nombre: 'TAMBO',
            ubigeo: '090616'
          }
        ]
      },
      {
        codigo: 907,
        nombre: 'TAYACAJA',
        distritos: [
          {
            codigo: 90702,
            nombre: 'ACOSTAMBO',
            ubigeo: '090702'
          },
          {
            codigo: 90703,
            nombre: 'ACRAQUIA',
            ubigeo: '090703'
          },
          {
            codigo: 90704,
            nombre: 'AHUAYCHA',
            ubigeo: '090704'
          },
          {
            codigo: 90705,
            nombre: 'COLCABAMBA',
            ubigeo: '090705'
          },
          {
            codigo: 90706,
            nombre: 'DANIEL HERNANDE',
            ubigeo: '090706'
          },
          {
            codigo: 90707,
            nombre: 'HUACHOCOLPA',
            ubigeo: '090707'
          },
          {
            codigo: 90708,
            nombre: 'HUANDO',
            ubigeo: '090708'
          },
          {
            codigo: 90709,
            nombre: 'HUARIBAMBA',
            ubigeo: '090709'
          },
          {
            codigo: 90701,
            nombre: 'PAMPAS',
            ubigeo: '090701'
          },
          {
            codigo: 90711,
            nombre: 'PAZOS',
            ubigeo: '090711'
          },
          {
            codigo: 90713,
            nombre: 'QUISHUAR',
            ubigeo: '090713'
          },
          {
            codigo: 90714,
            nombre: 'SALCABAMBA',
            ubigeo: '090714'
          },
          {
            codigo: 90715,
            nombre: 'SALCAHUASI',
            ubigeo: '090715'
          },
          {
            codigo: 90716,
            nombre: 'SAN MARCOS DE R',
            ubigeo: '090716'
          },
          {
            codigo: 90717,
            nombre: 'SURCUBAMBA',
            ubigeo: '090717'
          },
          {
            codigo: 90718,
            nombre: 'TINTAY PUNCU',
            ubigeo: '090718'
          },
          {
            codigo: 90710,
            nombre: 'ÑAHUIMPUQUIO',
            ubigeo: '090710'
          }
        ]
      }
    ]
  },
  {
    codigo: 10,
    nombre: 'HUANUCO',
    provincias: [
      {
        codigo: 1002,
        nombre: 'AMBO',
        distritos: [
          {
            codigo: 100201,
            nombre: 'AMBO',
            ubigeo: 100201
          },
          {
            codigo: 100202,
            nombre: 'CAYNA',
            ubigeo: 100202
          },
          {
            codigo: 100203,
            nombre: 'COLPAS',
            ubigeo: 100203
          },
          {
            codigo: 100204,
            nombre: 'CONCHAMARCA',
            ubigeo: 100204
          },
          {
            codigo: 100205,
            nombre: 'HUACAR',
            ubigeo: 100205
          },
          {
            codigo: 100206,
            nombre: 'SAN FRANCISCO',
            ubigeo: 100206
          },
          {
            codigo: 100207,
            nombre: 'SAN RAFAEL',
            ubigeo: 100207
          },
          {
            codigo: 100208,
            nombre: 'TOMAY KICHWA',
            ubigeo: 100208
          }
        ]
      },
      {
        codigo: 1003,
        nombre: 'DOS DE MAYO',
        distritos: [
          {
            codigo: 100307,
            nombre: 'CHUQUIS',
            ubigeo: 100307
          },
          {
            codigo: 100301,
            nombre: 'LA UNION',
            ubigeo: 100301
          },
          {
            codigo: 100311,
            nombre: 'MARIAS',
            ubigeo: 100311
          },
          {
            codigo: 100313,
            nombre: 'PACHAS',
            ubigeo: 100313
          },
          {
            codigo: 100316,
            nombre: 'QUIVILLA',
            ubigeo: 100316
          },
          {
            codigo: 100317,
            nombre: 'RIPAN',
            ubigeo: 100317
          },
          {
            codigo: 100321,
            nombre: 'SHUNQUI',
            ubigeo: 100321
          },
          {
            codigo: 100322,
            nombre: 'SILLAPATA',
            ubigeo: 100322
          },
          {
            codigo: 100323,
            nombre: 'YANAS',
            ubigeo: 100323
          }
        ]
      },
      {
        codigo: 1004,
        nombre: 'HUACAYBAMBA',
        distritos: [
          {
            codigo: 100402,
            nombre: 'CANCHABAMBA',
            ubigeo: 100402
          },
          {
            codigo: 100403,
            nombre: 'COCHABAMBA',
            ubigeo: 100403
          },
          {
            codigo: 100401,
            nombre: 'HUACAYBAMBA',
            ubigeo: 100401
          },
          {
            codigo: 100404,
            nombre: 'PINRA',
            ubigeo: 100404
          }
        ]
      },
      {
        codigo: 1005,
        nombre: 'HUAMALIES',
        distritos: [
          {
            codigo: 100502,
            nombre: 'ARANCAY',
            ubigeo: 100502
          },
          {
            codigo: 100503,
            nombre: 'CHAVIN DE PARIA',
            ubigeo: 100503
          },
          {
            codigo: 100504,
            nombre: 'JACAS GRANDE',
            ubigeo: 100504
          },
          {
            codigo: 100505,
            nombre: 'JIRCAN',
            ubigeo: 100505
          },
          {
            codigo: 100501,
            nombre: 'LLATA',
            ubigeo: 100501
          },
          {
            codigo: 100506,
            nombre: 'MIRAFLORES',
            ubigeo: 100506
          },
          {
            codigo: 100507,
            nombre: 'MONZON',
            ubigeo: 100507
          },
          {
            codigo: 100508,
            nombre: 'PUNCHAO',
            ubigeo: 100508
          },
          {
            codigo: 100509,
            nombre: 'PUÑOS',
            ubigeo: 100509
          },
          {
            codigo: 100510,
            nombre: 'SINGA',
            ubigeo: 100510
          },
          {
            codigo: 100511,
            nombre: 'TANTAMAYO',
            ubigeo: 100511
          }
        ]
      },
      {
        codigo: 1001,
        nombre: 'HUANUCO',
        distritos: [
          {
            codigo: 100102,
            nombre: 'AMARILIS',
            ubigeo: 100102
          },
          {
            codigo: 100103,
            nombre: 'CHINCHAO',
            ubigeo: 100103
          },
          {
            codigo: 100104,
            nombre: 'CHURUBAMBA',
            ubigeo: 100104
          },
          {
            codigo: 100101,
            nombre: 'HUANUCO',
            ubigeo: 100101
          },
          {
            codigo: 100105,
            nombre: 'MARGOS',
            ubigeo: 100105
          },
          {
            codigo: 100111,
            nombre: 'PILLCO MARCA',
            ubigeo: 100111
          },
          {
            codigo: 100106,
            nombre: 'QUISQUI',
            ubigeo: 100106
          },
          {
            codigo: 100107,
            nombre: 'SAN FRANCISCO D',
            ubigeo: 100107
          },
          {
            codigo: 100108,
            nombre: 'SAN PEDRO DE CH',
            ubigeo: 100108
          },
          {
            codigo: 100109,
            nombre: 'SANTA MARIA DEL',
            ubigeo: 100109
          },
          {
            codigo: 100110,
            nombre: 'YARUMAYO',
            ubigeo: 100110
          }
        ]
      },
      {
        codigo: 1010,
        nombre: 'LAURICOCHA',
        distritos: [
          {
            codigo: 101002,
            nombre: 'BAÑOS',
            ubigeo: 101002
          },
          {
            codigo: 101001,
            nombre: 'JESUS',
            ubigeo: 101001
          },
          {
            codigo: 101003,
            nombre: 'JIVIA',
            ubigeo: 101003
          },
          {
            codigo: 101004,
            nombre: 'QUEROPALCA',
            ubigeo: 101004
          },
          {
            codigo: 101005,
            nombre: 'RONDOS',
            ubigeo: 101005
          },
          {
            codigo: 101006,
            nombre: 'SAN FRANCISCO D',
            ubigeo: 101006
          },
          {
            codigo: 101007,
            nombre: 'SAN MIGUEL DE C',
            ubigeo: 101007
          }
        ]
      },
      {
        codigo: 1006,
        nombre: 'LEONCIO PRADO',
        distritos: [
          {
            codigo: 100602,
            nombre: 'DANIEL ALOMIA R',
            ubigeo: 100602
          },
          {
            codigo: 100603,
            nombre: 'HERMILIO VALDIZ',
            ubigeo: 100603
          },
          {
            codigo: 100604,
            nombre: 'JOSE CRESPO Y C',
            ubigeo: 100604
          },
          {
            codigo: 100605,
            nombre: 'LUYANDO',
            ubigeo: 100605
          },
          {
            codigo: 100606,
            nombre: 'MARIANO DAMASO',
            ubigeo: 100606
          },
          {
            codigo: 100601,
            nombre: 'RUPA-RUPA',
            ubigeo: 100601
          }
        ]
      },
      {
        codigo: 1007,
        nombre: 'MARAÑON',
        distritos: [
          {
            codigo: 100702,
            nombre: 'CHOLON',
            ubigeo: 100702
          },
          {
            codigo: 100701,
            nombre: 'HUACRACHUCO',
            ubigeo: 100701
          },
          {
            codigo: 100703,
            nombre: 'SAN BUENAVENTUR',
            ubigeo: 100703
          }
        ]
      },
      {
        codigo: 1008,
        nombre: 'PACHITEA',
        distritos: [
          {
            codigo: 100802,
            nombre: 'CHAGLLA',
            ubigeo: 100802
          },
          {
            codigo: 100803,
            nombre: 'MOLINO',
            ubigeo: 100803
          },
          {
            codigo: 100801,
            nombre: 'PANAO',
            ubigeo: 100801
          },
          {
            codigo: 100804,
            nombre: 'UMARI  2/',
            ubigeo: 100804
          }
        ]
      },
      {
        codigo: 1009,
        nombre: 'PUERTO INCA',
        distritos: [
          {
            codigo: 100902,
            nombre: 'CODO DEL POZUZO',
            ubigeo: 100902
          },
          {
            codigo: 100903,
            nombre: 'HONORIA',
            ubigeo: 100903
          },
          {
            codigo: 100901,
            nombre: 'PUERTO INCA',
            ubigeo: 100901
          },
          {
            codigo: 100904,
            nombre: 'TOURNAVISTA',
            ubigeo: 100904
          },
          {
            codigo: 100905,
            nombre: 'YUYAPICHIS',
            ubigeo: 100905
          }
        ]
      },
      {
        codigo: 1011,
        nombre: 'YAROWILCA',
        distritos: [
          {
            codigo: 101104,
            nombre: 'APARICIO POMARE',
            ubigeo: 101104
          },
          {
            codigo: 101102,
            nombre: 'CAHUAC',
            ubigeo: 101102
          },
          {
            codigo: 101103,
            nombre: 'CHACABAMBA',
            ubigeo: 101103
          },
          {
            codigo: 101101,
            nombre: 'CHAVINILLO',
            ubigeo: 101101
          },
          {
            codigo: 101108,
            nombre: 'CHORAS',
            ubigeo: 101108
          },
          {
            codigo: 101105,
            nombre: 'JACAS CHICO',
            ubigeo: 101105
          },
          {
            codigo: 101106,
            nombre: 'OBAS',
            ubigeo: 101106
          },
          {
            codigo: 101107,
            nombre: 'PAMPAMARCA',
            ubigeo: 101107
          }
        ]
      }
    ]
  },
  {
    codigo: 11,
    nombre: 'ICA',
    provincias: [
      {
        codigo: 1102,
        nombre: 'CHINCHA',
        distritos: [
          {
            codigo: 110202,
            nombre: 'ALTO LARAN',
            ubigeo: 110202
          },
          {
            codigo: 110203,
            nombre: 'CHAVIN',
            ubigeo: 110203
          },
          {
            codigo: 110201,
            nombre: 'CHINCHA ALTA',
            ubigeo: 110201
          },
          {
            codigo: 110204,
            nombre: 'CHINCHA BAJA',
            ubigeo: 110204
          },
          {
            codigo: 110205,
            nombre: 'EL CARMEN',
            ubigeo: 110205
          },
          {
            codigo: 110206,
            nombre: 'GROCIO PRADO',
            ubigeo: 110206
          },
          {
            codigo: 110207,
            nombre: 'PUEBLO NUEVO',
            ubigeo: 110207
          },
          {
            codigo: 110208,
            nombre: 'SAN JUAN DE YAN',
            ubigeo: 110208
          },
          {
            codigo: 110209,
            nombre: 'SAN PEDRO DE HU',
            ubigeo: 110209
          },
          {
            codigo: 110210,
            nombre: 'SUNAMPE',
            ubigeo: 110210
          },
          {
            codigo: 110211,
            nombre: 'TAMBO DE MORA',
            ubigeo: 110211
          }
        ]
      },
      {
        codigo: 1101,
        nombre: 'ICA',
        distritos: [
          {
            codigo: 110101,
            nombre: 'ICA',
            ubigeo: 110101
          },
          {
            codigo: 110102,
            nombre: 'LA TINGUIÑA',
            ubigeo: 110102
          },
          {
            codigo: 110103,
            nombre: 'LOS AQUIJES',
            ubigeo: 110103
          },
          {
            codigo: 110104,
            nombre: 'OCUCAJE',
            ubigeo: 110104
          },
          {
            codigo: 110105,
            nombre: 'PACHACUTEC',
            ubigeo: 110105
          },
          {
            codigo: 110106,
            nombre: 'PARCONA',
            ubigeo: 110106
          },
          {
            codigo: 110107,
            nombre: 'PUEBLO NUEVO',
            ubigeo: 110107
          },
          {
            codigo: 110108,
            nombre: 'SALAS',
            ubigeo: 110108
          },
          {
            codigo: 110109,
            nombre: 'SAN JOSE DE LOS',
            ubigeo: 110109
          },
          {
            codigo: 110110,
            nombre: 'SAN JUAN BAUTIS',
            ubigeo: 110110
          },
          {
            codigo: 110111,
            nombre: 'SANTIAGO',
            ubigeo: 110111
          },
          {
            codigo: 110112,
            nombre: 'SUBTANJALLA',
            ubigeo: 110112
          },
          {
            codigo: 110113,
            nombre: 'TATE',
            ubigeo: 110113
          },
          {
            codigo: 110114,
            nombre: 'YAUCA DEL ROSAR',
            ubigeo: 110114
          }
        ]
      },
      {
        codigo: 1103,
        nombre: 'NAZCA',
        distritos: [
          {
            codigo: 110302,
            nombre: 'CHANGUILLO',
            ubigeo: 110302
          },
          {
            codigo: 110303,
            nombre: 'EL INGENIO',
            ubigeo: 110303
          },
          {
            codigo: 110304,
            nombre: 'MARCONA',
            ubigeo: 110304
          },
          {
            codigo: 110301,
            nombre: 'NAZCA',
            ubigeo: 110301
          },
          {
            codigo: 110305,
            nombre: 'VISTA ALEGRE',
            ubigeo: 110305
          }
        ]
      },
      {
        codigo: 1104,
        nombre: 'PALPA',
        distritos: [
          {
            codigo: 110402,
            nombre: 'LLIPATA',
            ubigeo: 110402
          },
          {
            codigo: 110401,
            nombre: 'PALPA',
            ubigeo: 110401
          },
          {
            codigo: 110403,
            nombre: 'RIO GRANDE',
            ubigeo: 110403
          },
          {
            codigo: 110404,
            nombre: 'SANTA CRUZ',
            ubigeo: 110404
          },
          {
            codigo: 110405,
            nombre: 'TIBILLO',
            ubigeo: 110405
          }
        ]
      },
      {
        codigo: 1105,
        nombre: 'PISCO',
        distritos: [
          {
            codigo: 110502,
            nombre: 'HUANCANO',
            ubigeo: 110502
          },
          {
            codigo: 110503,
            nombre: 'HUMAY',
            ubigeo: 110503
          },
          {
            codigo: 110504,
            nombre: 'INDEPENDENCIA',
            ubigeo: 110504
          },
          {
            codigo: 110505,
            nombre: 'PARACAS',
            ubigeo: 110505
          },
          {
            codigo: 110501,
            nombre: 'PISCO',
            ubigeo: 110501
          },
          {
            codigo: 110506,
            nombre: 'SAN ANDRES',
            ubigeo: 110506
          },
          {
            codigo: 110507,
            nombre: 'SAN CLEMENTE',
            ubigeo: 110507
          },
          {
            codigo: 110508,
            nombre: 'TUPAC AMARU INC',
            ubigeo: 110508
          }
        ]
      }
    ]
  },
  {
    codigo: 12,
    nombre: 'JUNIN',
    provincias: [
      {
        codigo: 1203,
        nombre: 'CHANCHAMAYO',
        distritos: [
          {
            codigo: 120301,
            nombre: 'CHANCHAMAYO',
            ubigeo: 120301
          },
          {
            codigo: 120302,
            nombre: 'PERENE',
            ubigeo: 120302
          },
          {
            codigo: 120303,
            nombre: 'PICHANAQUI',
            ubigeo: 120303
          },
          {
            codigo: 120304,
            nombre: 'SAN LUIS DE SHU',
            ubigeo: 120304
          },
          {
            codigo: 120305,
            nombre: 'SAN RAMON',
            ubigeo: 120305
          },
          {
            codigo: 120306,
            nombre: 'VITOC',
            ubigeo: 120306
          }
        ]
      },
      {
        codigo: 1209,
        nombre: 'CHUPACA',
        distritos: [
          {
            codigo: 120902,
            nombre: 'AHUAC',
            ubigeo: 120902
          },
          {
            codigo: 120903,
            nombre: 'CHONGOS BAJO',
            ubigeo: 120903
          },
          {
            codigo: 120901,
            nombre: 'CHUPACA',
            ubigeo: 120901
          },
          {
            codigo: 120904,
            nombre: 'HUACHAC',
            ubigeo: 120904
          },
          {
            codigo: 120905,
            nombre: 'HUAMANCACA CHIC',
            ubigeo: 120905
          },
          {
            codigo: 120906,
            nombre: 'SAN JUAN DE ISC',
            ubigeo: 120906
          },
          {
            codigo: 120907,
            nombre: 'SAN JUAN DE JAR',
            ubigeo: 120907
          },
          {
            codigo: 120908,
            nombre: 'TRES DE DICIEMB',
            ubigeo: 120908
          },
          {
            codigo: 120909,
            nombre: 'YANACANCHA',
            ubigeo: 120909
          }
        ]
      },
      {
        codigo: 1202,
        nombre: 'CONCEPCION',
        distritos: [
          {
            codigo: 120202,
            nombre: 'ACO',
            ubigeo: 120202
          },
          {
            codigo: 120203,
            nombre: 'ANDAMARCA',
            ubigeo: 120203
          },
          {
            codigo: 120204,
            nombre: 'CHAMBARA',
            ubigeo: 120204
          },
          {
            codigo: 120205,
            nombre: 'COCHAS',
            ubigeo: 120205
          },
          {
            codigo: 120206,
            nombre: 'COMAS',
            ubigeo: 120206
          },
          {
            codigo: 120201,
            nombre: 'CONCEPCION',
            ubigeo: 120201
          },
          {
            codigo: 120207,
            nombre: 'HEROINAS TOLEDO',
            ubigeo: 120207
          },
          {
            codigo: 120208,
            nombre: 'MANZANARES',
            ubigeo: 120208
          },
          {
            codigo: 120209,
            nombre: 'MARISCAL CASTIL',
            ubigeo: 120209
          },
          {
            codigo: 120210,
            nombre: 'MATAHUASI',
            ubigeo: 120210
          },
          {
            codigo: 120211,
            nombre: 'MITO',
            ubigeo: 120211
          },
          {
            codigo: 120212,
            nombre: 'NUEVE DE JULIO',
            ubigeo: 120212
          },
          {
            codigo: 120213,
            nombre: 'ORCOTUNA',
            ubigeo: 120213
          },
          {
            codigo: 120214,
            nombre: 'SAN JOSE DE QUE',
            ubigeo: 120214
          },
          {
            codigo: 120215,
            nombre: 'SANTA ROSA DE O',
            ubigeo: 120215
          }
        ]
      },
      {
        codigo: 1201,
        nombre: 'HUANCAYO',
        distritos: [
          {
            codigo: 120104,
            nombre: 'CARHUACALLANGA',
            ubigeo: 120104
          },
          {
            codigo: 120105,
            nombre: 'CHACAPAMPA',
            ubigeo: 120105
          },
          {
            codigo: 120106,
            nombre: 'CHICCHE',
            ubigeo: 120106
          },
          {
            codigo: 120107,
            nombre: 'CHILCA',
            ubigeo: 120107
          },
          {
            codigo: 120108,
            nombre: 'CHONGOS ALTO',
            ubigeo: 120108
          },
          {
            codigo: 120111,
            nombre: 'CHUPURO',
            ubigeo: 120111
          },
          {
            codigo: 120112,
            nombre: 'COLCA',
            ubigeo: 120112
          },
          {
            codigo: 120113,
            nombre: 'CULLHUAS',
            ubigeo: 120113
          },
          {
            codigo: 120114,
            nombre: 'EL TAMBO',
            ubigeo: 120114
          },
          {
            codigo: 120116,
            nombre: 'HUACRAPUQUIO',
            ubigeo: 120116
          },
          {
            codigo: 120117,
            nombre: 'HUALHUAS',
            ubigeo: 120117
          },
          {
            codigo: 120119,
            nombre: 'HUANCAN',
            ubigeo: 120119
          },
          {
            codigo: 120101,
            nombre: 'HUANCAYO',
            ubigeo: 120101
          },
          {
            codigo: 120120,
            nombre: 'HUASICANCHA',
            ubigeo: 120120
          },
          {
            codigo: 120121,
            nombre: 'HUAYUCACHI',
            ubigeo: 120121
          },
          {
            codigo: 120122,
            nombre: 'INGENIO',
            ubigeo: 120122
          },
          {
            codigo: 120124,
            nombre: 'PARIAHUANCA',
            ubigeo: 120124
          },
          {
            codigo: 120125,
            nombre: 'PILCOMAYO',
            ubigeo: 120125
          },
          {
            codigo: 120126,
            nombre: 'PUCARA',
            ubigeo: 120126
          },
          {
            codigo: 120127,
            nombre: 'QUICHUAY',
            ubigeo: 120127
          },
          {
            codigo: 120128,
            nombre: 'QUILCAS',
            ubigeo: 120128
          },
          {
            codigo: 120129,
            nombre: 'SAN AGUSTIN',
            ubigeo: 120129
          },
          {
            codigo: 120130,
            nombre: 'SAN JERONIMO DE',
            ubigeo: 120130
          },
          {
            codigo: 120135,
            nombre: 'SANTO DOMINGO D',
            ubigeo: 120135
          },
          {
            codigo: 120133,
            nombre: 'SAPALLANGA',
            ubigeo: 120133
          },
          {
            codigo: 120132,
            nombre: 'SAÑO',
            ubigeo: 120132
          },
          {
            codigo: 120134,
            nombre: 'SICAYA',
            ubigeo: 120134
          },
          {
            codigo: 120136,
            nombre: 'VIQUES',
            ubigeo: 120136
          }
        ]
      },
      {
        codigo: 1204,
        nombre: 'JAUJA',
        distritos: [
          {
            codigo: 120402,
            nombre: 'ACOLLA',
            ubigeo: 120402
          },
          {
            codigo: 120403,
            nombre: 'APATA',
            ubigeo: 120403
          },
          {
            codigo: 120404,
            nombre: 'ATAURA',
            ubigeo: 120404
          },
          {
            codigo: 120405,
            nombre: 'CANCHAYLLO',
            ubigeo: 120405
          },
          {
            codigo: 120406,
            nombre: 'CURICACA',
            ubigeo: 120406
          },
          {
            codigo: 120407,
            nombre: 'EL MANTARO',
            ubigeo: 120407
          },
          {
            codigo: 120408,
            nombre: 'HUAMALI',
            ubigeo: 120408
          },
          {
            codigo: 120409,
            nombre: 'HUARIPAMPA',
            ubigeo: 120409
          },
          {
            codigo: 120410,
            nombre: 'HUERTAS',
            ubigeo: 120410
          },
          {
            codigo: 120411,
            nombre: 'JANJAILLO',
            ubigeo: 120411
          },
          {
            codigo: 120401,
            nombre: 'JAUJA',
            ubigeo: 120401
          },
          {
            codigo: 120412,
            nombre: 'JULCAN',
            ubigeo: 120412
          },
          {
            codigo: 120413,
            nombre: 'LEONOR ORDOÑEZ',
            ubigeo: 120413
          },
          {
            codigo: 120414,
            nombre: 'LLOCLLAPAMPA',
            ubigeo: 120414
          },
          {
            codigo: 120415,
            nombre: 'MARCO',
            ubigeo: 120415
          },
          {
            codigo: 120416,
            nombre: 'MASMA',
            ubigeo: 120416
          },
          {
            codigo: 120417,
            nombre: 'MASMA CHICCHE',
            ubigeo: 120417
          },
          {
            codigo: 120418,
            nombre: 'MOLINOS',
            ubigeo: 120418
          },
          {
            codigo: 120419,
            nombre: 'MONOBAMBA',
            ubigeo: 120419
          },
          {
            codigo: 120420,
            nombre: 'MUQUI',
            ubigeo: 120420
          },
          {
            codigo: 120421,
            nombre: 'MUQUIYAUYO',
            ubigeo: 120421
          },
          {
            codigo: 120422,
            nombre: 'PACA',
            ubigeo: 120422
          },
          {
            codigo: 120423,
            nombre: 'PACCHA',
            ubigeo: 120423
          },
          {
            codigo: 120424,
            nombre: 'PANCAN',
            ubigeo: 120424
          },
          {
            codigo: 120425,
            nombre: 'PARCO',
            ubigeo: 120425
          },
          {
            codigo: 120426,
            nombre: 'POMACANCHA',
            ubigeo: 120426
          },
          {
            codigo: 120427,
            nombre: 'RICRAN',
            ubigeo: 120427
          },
          {
            codigo: 120428,
            nombre: 'SAN LORENZO',
            ubigeo: 120428
          },
          {
            codigo: 120429,
            nombre: 'SAN PEDRO DE CH',
            ubigeo: 120429
          },
          {
            codigo: 120430,
            nombre: 'SAUSA',
            ubigeo: 120430
          },
          {
            codigo: 120431,
            nombre: 'SINCOS',
            ubigeo: 120431
          },
          {
            codigo: 120432,
            nombre: 'TUNAN MARCA',
            ubigeo: 120432
          },
          {
            codigo: 120433,
            nombre: 'YAULI',
            ubigeo: 120433
          },
          {
            codigo: 120434,
            nombre: 'YAUYOS',
            ubigeo: 120434
          }
        ]
      },
      {
        codigo: 1205,
        nombre: 'JUNIN',
        distritos: [
          {
            codigo: 120502,
            nombre: 'CARHUAMAYO',
            ubigeo: 120502
          },
          {
            codigo: 120501,
            nombre: 'JUNIN',
            ubigeo: 120501
          },
          {
            codigo: 120503,
            nombre: 'ONDORES',
            ubigeo: 120503
          },
          {
            codigo: 120504,
            nombre: 'ULCUMAYO',
            ubigeo: 120504
          }
        ]
      },
      {
        codigo: 1206,
        nombre: 'SATIPO',
        distritos: [
          {
            codigo: 120602,
            nombre: 'COVIRIALI',
            ubigeo: 120602
          },
          {
            codigo: 120603,
            nombre: 'LLAYLLA',
            ubigeo: 120603
          },
          {
            codigo: 120604,
            nombre: 'MAZAMARI',
            ubigeo: 120604
          },
          {
            codigo: 120605,
            nombre: 'PAMPA HERMOSA',
            ubigeo: 120605
          },
          {
            codigo: 120606,
            nombre: 'PANGOA',
            ubigeo: 120606
          },
          {
            codigo: 120607,
            nombre: 'RIO NEGRO',
            ubigeo: 120607
          },
          {
            codigo: 120608,
            nombre: 'RIO TAMBO',
            ubigeo: 120608
          },
          {
            codigo: 120601,
            nombre: 'SATIPO',
            ubigeo: 120601
          }
        ]
      },
      {
        codigo: 1207,
        nombre: 'TARMA',
        distritos: [
          {
            codigo: 120702,
            nombre: 'ACOBAMBA',
            ubigeo: 120702
          },
          {
            codigo: 120703,
            nombre: 'HUARICOLCA',
            ubigeo: 120703
          },
          {
            codigo: 120704,
            nombre: 'HUASAHUASI',
            ubigeo: 120704
          },
          {
            codigo: 120705,
            nombre: 'LA UNION',
            ubigeo: 120705
          },
          {
            codigo: 120706,
            nombre: 'PALCA',
            ubigeo: 120706
          },
          {
            codigo: 120707,
            nombre: 'PALCAMAYO',
            ubigeo: 120707
          },
          {
            codigo: 120708,
            nombre: 'SAN PEDRO DE CA',
            ubigeo: 120708
          },
          {
            codigo: 120709,
            nombre: 'TAPO',
            ubigeo: 120709
          },
          {
            codigo: 120701,
            nombre: 'TARMA',
            ubigeo: 120701
          }
        ]
      },
      {
        codigo: 1208,
        nombre: 'YAULI',
        distritos: [
          {
            codigo: 120802,
            nombre: 'CHACAPALPA',
            ubigeo: 120802
          },
          {
            codigo: 120803,
            nombre: 'HUAY-HUAY',
            ubigeo: 120803
          },
          {
            codigo: 120801,
            nombre: 'LA OROYA',
            ubigeo: 120801
          },
          {
            codigo: 120804,
            nombre: 'MARCAPOMACOCHA',
            ubigeo: 120804
          },
          {
            codigo: 120805,
            nombre: 'MOROCOCHA',
            ubigeo: 120805
          },
          {
            codigo: 120806,
            nombre: 'PACCHA',
            ubigeo: 120806
          },
          {
            codigo: 120807,
            nombre: 'SANTA BARBARA D',
            ubigeo: 120807
          },
          {
            codigo: 120808,
            nombre: 'SANTA ROSA DE S',
            ubigeo: 120808
          },
          {
            codigo: 120809,
            nombre: 'SUITUCANCHA',
            ubigeo: 120809
          },
          {
            codigo: 120810,
            nombre: 'YAULI',
            ubigeo: 120810
          }
        ]
      }
    ]
  },
  {
    codigo: 13,
    nombre: 'LA LIBERTAD',
    provincias: [
      {
        codigo: 1302,
        nombre: 'ASCOPE',
        distritos: [
          {
            codigo: 130201,
            nombre: 'ASCOPE',
            ubigeo: 130201
          },
          {
            codigo: 130208,
            nombre: 'CASA GRANDE',
            ubigeo: 130208
          },
          {
            codigo: 130202,
            nombre: 'CHICAMA',
            ubigeo: 130202
          },
          {
            codigo: 130203,
            nombre: 'CHOCOPE',
            ubigeo: 130203
          },
          {
            codigo: 130204,
            nombre: 'MAGDALENA DE CAO',
            ubigeo: 130204
          },
          {
            codigo: 130205,
            nombre: 'PAIJAN',
            ubigeo: 130205
          },
          {
            codigo: 130206,
            nombre: 'RAZURI',
            ubigeo: 130206
          },
          {
            codigo: 130207,
            nombre: 'SANTIAGO DE CAO',
            ubigeo: 130207
          }
        ]
      },
      {
        codigo: 1303,
        nombre: 'BOLIVAR',
        distritos: [
          {
            codigo: 130302,
            nombre: 'BAMBAMARCA',
            ubigeo: 130302
          },
          {
            codigo: 130301,
            nombre: 'BOLIVAR',
            ubigeo: 130301
          },
          {
            codigo: 130303,
            nombre: 'CONDORMARCA',
            ubigeo: 130303
          },
          {
            codigo: 130304,
            nombre: 'LONGOTEA',
            ubigeo: 130304
          },
          {
            codigo: 130305,
            nombre: 'UCHUMARCA',
            ubigeo: 130305
          },
          {
            codigo: 130306,
            nombre: 'UCUNCHA',
            ubigeo: 130306
          }
        ]
      },
      {
        codigo: 1304,
        nombre: 'CHEPEN',
        distritos: [
          {
            codigo: 130401,
            nombre: 'CHEPEN',
            ubigeo: 130401
          },
          {
            codigo: 130402,
            nombre: 'PACANGA',
            ubigeo: 130402
          },
          {
            codigo: 130403,
            nombre: 'PUEBLO NUEVO',
            ubigeo: 130403
          }
        ]
      },
      {
        codigo: 1311,
        nombre: 'GRAN CHIMU',
        distritos: [
          {
            codigo: 131101,
            nombre: 'CASCAS',
            ubigeo: 131101
          },
          {
            codigo: 131102,
            nombre: 'LUCMA',
            ubigeo: 131102
          },
          {
            codigo: 131103,
            nombre: 'MARMOT',
            ubigeo: 131103
          },
          {
            codigo: 131104,
            nombre: 'SAYAPULLO',
            ubigeo: 131104
          }
        ]
      },
      {
        codigo: 1305,
        nombre: 'JULCAN',
        distritos: [
          {
            codigo: 130502,
            nombre: 'CALAMARCA',
            ubigeo: 130502
          },
          {
            codigo: 130503,
            nombre: 'CARABAMBA',
            ubigeo: 130503
          },
          {
            codigo: 130504,
            nombre: 'HUASO',
            ubigeo: 130504
          },
          {
            codigo: 130501,
            nombre: 'JULCAN',
            ubigeo: 130501
          }
        ]
      },
      {
        codigo: 1306,
        nombre: 'OTUZCO',
        distritos: [
          {
            codigo: 130602,
            nombre: 'AGALLPAMPA',
            ubigeo: 130602
          },
          {
            codigo: 130604,
            nombre: 'CHARAT',
            ubigeo: 130604
          },
          {
            codigo: 130605,
            nombre: 'HUARANCHAL',
            ubigeo: 130605
          },
          {
            codigo: 130606,
            nombre: 'LA CUESTA',
            ubigeo: 130606
          },
          {
            codigo: 130608,
            nombre: 'MACHE',
            ubigeo: 130608
          },
          {
            codigo: 130601,
            nombre: 'OTUZCO',
            ubigeo: 130601
          },
          {
            codigo: 130610,
            nombre: 'PARANDAY',
            ubigeo: 130610
          },
          {
            codigo: 130611,
            nombre: 'SALPO',
            ubigeo: 130611
          },
          {
            codigo: 130613,
            nombre: 'SINSICAP',
            ubigeo: 130613
          },
          {
            codigo: 130614,
            nombre: 'USQUIL',
            ubigeo: 130614
          }
        ]
      },
      {
        codigo: 1307,
        nombre: 'PACASMAYO',
        distritos: [
          {
            codigo: 130702,
            nombre: 'GUADALUPE',
            ubigeo: 130702
          },
          {
            codigo: 130703,
            nombre: 'JEQUETEPEQUE',
            ubigeo: 130703
          },
          {
            codigo: 130704,
            nombre: 'PACASMAYO',
            ubigeo: 130704
          },
          {
            codigo: 130705,
            nombre: 'SAN JOSE',
            ubigeo: 130705
          },
          {
            codigo: 130701,
            nombre: 'SAN PEDRO DE LLOC',
            ubigeo: 130701
          }
        ]
      },
      {
        codigo: 1308,
        nombre: 'PATAZ',
        distritos: [
          {
            codigo: 130802,
            nombre: 'BULDIBUYO',
            ubigeo: 130802
          },
          {
            codigo: 130803,
            nombre: 'CHILLIA',
            ubigeo: 130803
          },
          {
            codigo: 130804,
            nombre: 'HUANCASPATA',
            ubigeo: 130804
          },
          {
            codigo: 130805,
            nombre: 'HUAYLILLAS',
            ubigeo: 130805
          },
          {
            codigo: 130806,
            nombre: 'HUAYO',
            ubigeo: 130806
          },
          {
            codigo: 130807,
            nombre: 'ONGON',
            ubigeo: 130807
          },
          {
            codigo: 130808,
            nombre: 'PARCOY',
            ubigeo: 130808
          },
          {
            codigo: 130809,
            nombre: 'PATAZ',
            ubigeo: 130809
          },
          {
            codigo: 130810,
            nombre: 'PIAS',
            ubigeo: 130810
          },
          {
            codigo: 130811,
            nombre: 'SANTIAG.D/CHALLAS',
            ubigeo: 130811
          },
          {
            codigo: 130812,
            nombre: 'TAURIJA',
            ubigeo: 130812
          },
          {
            codigo: 130801,
            nombre: 'TAYABAMBA',
            ubigeo: 130801
          },
          {
            codigo: 130813,
            nombre: 'URPAY',
            ubigeo: 130813
          }
        ]
      },
      {
        codigo: 1309,
        nombre: 'SANCHEZ CARRION',
        distritos: [
          {
            codigo: 130902,
            nombre: 'CHUGAY',
            ubigeo: 130902
          },
          {
            codigo: 130903,
            nombre: 'COCHORCO',
            ubigeo: 130903
          },
          {
            codigo: 130904,
            nombre: 'CURGOS',
            ubigeo: 130904
          },
          {
            codigo: 130901,
            nombre: 'HUAMACHUCO',
            ubigeo: 130901
          },
          {
            codigo: 130905,
            nombre: 'MARCABAL',
            ubigeo: 130905
          },
          {
            codigo: 130906,
            nombre: 'SANAGORAN',
            ubigeo: 130906
          },
          {
            codigo: 130907,
            nombre: 'SARIN',
            ubigeo: 130907
          },
          {
            codigo: 130908,
            nombre: 'SARTIMBAMBA',
            ubigeo: 130908
          }
        ]
      },
      {
        codigo: 1310,
        nombre: 'SANTIAGO DE CHU',
        distritos: [
          {
            codigo: 131002,
            nombre: 'ANGASMARCA',
            ubigeo: 131002
          },
          {
            codigo: 131003,
            nombre: 'CACHICADAN',
            ubigeo: 131003
          },
          {
            codigo: 131004,
            nombre: 'MOLLEBAMBA',
            ubigeo: 131004
          },
          {
            codigo: 131005,
            nombre: 'MOLLEPATA',
            ubigeo: 131005
          },
          {
            codigo: 131006,
            nombre: 'QUIRUVILCA',
            ubigeo: 131006
          },
          {
            codigo: 131008,
            nombre: 'SITABAMBA',
            ubigeo: 131008
          },
          {
            codigo: 131007,
            nombre: 'STA.CRUZ DE CHUCA',
            ubigeo: 131007
          },
          {
            codigo: 131001,
            nombre: 'STGO. DE CHUCO',
            ubigeo: 131001
          }
        ]
      },
      {
        codigo: 1301,
        nombre: 'TRUJILLO',
        distritos: [
          {
            codigo: 130102,
            nombre: 'EL PORVENIR',
            ubigeo: 130102
          },
          {
            codigo: 130103,
            nombre: 'FLORENCIA DE MORA',
            ubigeo: 130103
          },
          {
            codigo: 130104,
            nombre: 'HUANCHACO',
            ubigeo: 130104
          },
          {
            codigo: 130105,
            nombre: 'LA ESPERANZA',
            ubigeo: 130105
          },
          {
            codigo: 130106,
            nombre: 'LAREDO',
            ubigeo: 130106
          },
          {
            codigo: 130107,
            nombre: 'MOCHE',
            ubigeo: 130107
          },
          {
            codigo: 130108,
            nombre: 'POROTO',
            ubigeo: 130108
          },
          {
            codigo: 130109,
            nombre: 'SALAVERRY',
            ubigeo: 130109
          },
          {
            codigo: 130110,
            nombre: 'SIMBAL',
            ubigeo: 130110
          },
          {
            codigo: 130101,
            nombre: 'TRUJILLO',
            ubigeo: 130101
          },
          {
            codigo: 130111,
            nombre: 'VICT.LARCO HERRE.',
            ubigeo: 130111
          }
        ]
      },
      {
        codigo: 1312,
        nombre: 'VIRU',
        distritos: [
          {
            codigo: 131202,
            nombre: 'CHAO',
            ubigeo: 131202
          },
          {
            codigo: 131203,
            nombre: 'GUADALUPITO',
            ubigeo: 131203
          },
          {
            codigo: 131201,
            nombre: 'VIRU',
            ubigeo: 131201
          }
        ]
      }
    ]
  },
  {
    codigo: 14,
    nombre: 'LAMBAYEQUE',
    provincias: [
      {
        codigo: 1401,
        nombre: 'CHICLAYO',
        distritos: [
          {
            codigo: 140116,
            nombre: 'CAYALTI',
            ubigeo: 140116
          },
          {
            codigo: 140101,
            nombre: 'CHICLAYO',
            ubigeo: 140101
          },
          {
            codigo: 140102,
            nombre: 'CHONCOYAPE',
            ubigeo: 140102
          },
          {
            codigo: 140103,
            nombre: 'ETEN',
            ubigeo: 140103
          },
          {
            codigo: 140104,
            nombre: 'ETEN PUERTO',
            ubigeo: 140104
          },
          {
            codigo: 140105,
            nombre: 'JOSE L. ORTIZ',
            ubigeo: 140105
          },
          {
            codigo: 140106,
            nombre: 'LA VICTORIA',
            ubigeo: 140106
          },
          {
            codigo: 140107,
            nombre: 'LAGUNAS',
            ubigeo: 140107
          },
          {
            codigo: 140108,
            nombre: 'MONSEFU',
            ubigeo: 140108
          },
          {
            codigo: 140109,
            nombre: 'NUEVA ARICA',
            ubigeo: 140109
          },
          {
            codigo: 140110,
            nombre: 'OYOTUN',
            ubigeo: 140110
          },
          {
            codigo: 140117,
            nombre: 'PATAPO',
            ubigeo: 140117
          },
          {
            codigo: 140111,
            nombre: 'PICSI',
            ubigeo: 140111
          },
          {
            codigo: 140112,
            nombre: 'PIMENTEL',
            ubigeo: 140112
          },
          {
            codigo: 140118,
            nombre: 'POMALCA',
            ubigeo: 140118
          },
          {
            codigo: 140119,
            nombre: 'PUCALA',
            ubigeo: 140119
          },
          {
            codigo: 140113,
            nombre: 'REQUE',
            ubigeo: 140113
          },
          {
            codigo: 140114,
            nombre: 'SANTA ROSA',
            ubigeo: 140114
          },
          {
            codigo: 140115,
            nombre: 'SAÑA',
            ubigeo: 140115
          },
          {
            codigo: 140120,
            nombre: 'TUMAN',
            ubigeo: 140120
          }
        ]
      },
      {
        codigo: 1402,
        nombre: 'FERREÑAFE',
        distritos: [
          {
            codigo: 140202,
            nombre: 'CAÑARIS',
            ubigeo: 140202
          },
          {
            codigo: 140201,
            nombre: 'FERREÑAFE',
            ubigeo: 140201
          },
          {
            codigo: 140203,
            nombre: 'INCAHUASI',
            ubigeo: 140203
          },
          {
            codigo: 140204,
            nombre: 'MESONES MURO',
            ubigeo: 140204
          },
          {
            codigo: 140205,
            nombre: 'PITIPO',
            ubigeo: 140205
          },
          {
            codigo: 140206,
            nombre: 'PUEBLO NUEVO',
            ubigeo: 140206
          }
        ]
      },
      {
        codigo: 1403,
        nombre: 'LAMBAYEQUE',
        distritos: [
          {
            codigo: 140302,
            nombre: 'CHOCHOPE',
            ubigeo: 140302
          },
          {
            codigo: 140303,
            nombre: 'ILLIMO',
            ubigeo: 140303
          },
          {
            codigo: 140304,
            nombre: 'JAYANCA',
            ubigeo: 140304
          },
          {
            codigo: 140301,
            nombre: 'LAMBAYEQUE',
            ubigeo: 140301
          },
          {
            codigo: 140305,
            nombre: 'MOCHUMI',
            ubigeo: 140305
          },
          {
            codigo: 140306,
            nombre: 'MORROPE',
            ubigeo: 140306
          },
          {
            codigo: 140307,
            nombre: 'MOTUPE',
            ubigeo: 140307
          },
          {
            codigo: 140308,
            nombre: 'OLMOS',
            ubigeo: 140308
          },
          {
            codigo: 140309,
            nombre: 'PACORA',
            ubigeo: 140309
          },
          {
            codigo: 140310,
            nombre: 'SALAS',
            ubigeo: 140310
          },
          {
            codigo: 140311,
            nombre: 'SAN JOSE',
            ubigeo: 140311
          },
          {
            codigo: 140312,
            nombre: 'TUCUME',
            ubigeo: 140312
          }
        ]
      }
    ]
  },
  {
    codigo: 16,
    nombre: 'LORETO',
    provincias: [
      {
        codigo: 1602,
        nombre: 'ALTO AMAZONAS',
        distritos: [
          {
            codigo: 160202,
            nombre: 'BALSAPUERTO',
            ubigeo: 160202
          },
          {
            codigo: 160203,
            nombre: 'BARRANCA',
            ubigeo: 160203
          },
          {
            codigo: 160204,
            nombre: 'CAHUAPANAS',
            ubigeo: 160204
          },
          {
            codigo: 160205,
            nombre: 'JEBEROS',
            ubigeo: 160205
          },
          {
            codigo: 160206,
            nombre: 'LAGUNAS',
            ubigeo: 160206
          },
          {
            codigo: 160207,
            nombre: 'MANSERICHE',
            ubigeo: 160207
          },
          {
            codigo: 160208,
            nombre: 'MORONA',
            ubigeo: 160208
          },
          {
            codigo: 160209,
            nombre: 'PASTAZA',
            ubigeo: 160209
          },
          {
            codigo: 160210,
            nombre: 'SANTA CRUZ',
            ubigeo: 160210
          },
          {
            codigo: 160211,
            nombre: 'TENIENTE CESAR',
            ubigeo: 160211
          },
          {
            codigo: 160201,
            nombre: 'YURIMAGUAS',
            ubigeo: 160201
          }
        ]
      },
      {
        codigo: 1603,
        nombre: 'LORETO',
        distritos: [
          {
            codigo: 160301,
            nombre: 'NAUTA',
            ubigeo: 160301
          },
          {
            codigo: 160302,
            nombre: 'PARINARI',
            ubigeo: 160302
          },
          {
            codigo: 160303,
            nombre: 'TIGRE',
            ubigeo: 160303
          },
          {
            codigo: 160304,
            nombre: 'TROMPETEROS',
            ubigeo: 160304
          },
          {
            codigo: 160305,
            nombre: 'URARINAS',
            ubigeo: 160305
          }
        ]
      },
      {
        codigo: 1604,
        nombre: 'MARISCAL RAMON',
        distritos: [
          {
            codigo: 160402,
            nombre: 'PEBAS',
            ubigeo: 160402
          },
          {
            codigo: 160401,
            nombre: 'RAMON CASTILLA',
            ubigeo: 160401
          },
          {
            codigo: 160404,
            nombre: 'SAN PABLO',
            ubigeo: 160404
          },
          {
            codigo: 160403,
            nombre: 'YAVARI',
            ubigeo: 160403
          }
        ]
      },
      {
        codigo: 1601,
        nombre: 'MAYNAS',
        distritos: [
          {
            codigo: 160102,
            nombre: 'ALTO NANAY',
            ubigeo: 160102
          },
          {
            codigo: 160112,
            nombre: 'BELEN',
            ubigeo: 160112
          },
          {
            codigo: 160103,
            nombre: 'FERNANDO LORES',
            ubigeo: 160103
          },
          {
            codigo: 160104,
            nombre: 'INDIANA',
            ubigeo: 160104
          },
          {
            codigo: 160101,
            nombre: 'IQUITOS',
            ubigeo: 160101
          },
          {
            codigo: 160105,
            nombre: 'LAS AMAZONAS',
            ubigeo: 160105
          },
          {
            codigo: 160106,
            nombre: 'MAZAN',
            ubigeo: 160106
          },
          {
            codigo: 160107,
            nombre: 'NAPO',
            ubigeo: 160107
          },
          {
            codigo: 160108,
            nombre: 'PUNCHANA',
            ubigeo: 160108
          },
          {
            codigo: 160109,
            nombre: 'PUTUMAYO',
            ubigeo: 160109
          },
          {
            codigo: 160113,
            nombre: 'SAN JUAN BAUTIS',
            ubigeo: 160113
          },
          {
            codigo: 160110,
            nombre: 'TORRES CAUSANA',
            ubigeo: 160110
          }
        ]
      },
      {
        codigo: 1605,
        nombre: 'REQUENA',
        distritos: [
          {
            codigo: 160502,
            nombre: 'ALTO TAPICHE',
            ubigeo: 160502
          },
          {
            codigo: 160503,
            nombre: 'CAPELO',
            ubigeo: 160503
          },
          {
            codigo: 160504,
            nombre: 'EMILIO SAN MART',
            ubigeo: 160504
          },
          {
            codigo: 160510,
            nombre: 'JENARO HERRERA',
            ubigeo: 160510
          },
          {
            codigo: 160505,
            nombre: 'MAQUIA',
            ubigeo: 160505
          },
          {
            codigo: 160506,
            nombre: 'PUINAHUA',
            ubigeo: 160506
          },
          {
            codigo: 160501,
            nombre: 'REQUENA',
            ubigeo: 160501
          },
          {
            codigo: 160507,
            nombre: 'SAQUENA',
            ubigeo: 160507
          },
          {
            codigo: 160508,
            nombre: 'SOPLIN',
            ubigeo: 160508
          },
          {
            codigo: 160509,
            nombre: 'TAPICHE',
            ubigeo: 160509
          },
          {
            codigo: 160511,
            nombre: 'YAQUERANA',
            ubigeo: 160511
          }
        ]
      },
      {
        codigo: 1606,
        nombre: 'UCAYALI',
        distritos: [
          {
            codigo: 160601,
            nombre: 'CONTAMANA',
            ubigeo: 160601
          },
          {
            codigo: 160602,
            nombre: 'INAHUAYA',
            ubigeo: 160602
          },
          {
            codigo: 160603,
            nombre: 'PADRE MARQUEZ',
            ubigeo: 160603
          },
          {
            codigo: 160604,
            nombre: 'PAMPA HERMOSA',
            ubigeo: 160604
          },
          {
            codigo: 160605,
            nombre: 'SARAYACU',
            ubigeo: 160605
          },
          {
            codigo: 160606,
            nombre: 'VARGAS GUERRA',
            ubigeo: 160606
          }
        ]
      }
    ]
  },
  {
    codigo: 17,
    nombre: 'MADRE DE DIOS',
    provincias: [
      {
        codigo: 1702,
        nombre: 'MANU',
        distritos: [
          {
            codigo: 170202,
            nombre: 'FITZCARRALD',
            ubigeo: 170202
          },
          {
            codigo: 170204,
            nombre: 'HUEPETUHE',
            ubigeo: 170204
          },
          {
            codigo: 170203,
            nombre: 'MADRE DE DIOS',
            ubigeo: 170203
          },
          {
            codigo: 170201,
            nombre: 'MANU',
            ubigeo: 170201
          }
        ]
      },
      {
        codigo: 1703,
        nombre: 'TAHUAMANU',
        distritos: [
          {
            codigo: 170302,
            nombre: 'IBERIA',
            ubigeo: 170302
          },
          {
            codigo: 170301,
            nombre: 'IÑAPARI',
            ubigeo: 170301
          },
          {
            codigo: 170303,
            nombre: 'TAHUAMANU',
            ubigeo: 170303
          }
        ]
      },
      {
        codigo: 1701,
        nombre: 'TAMBOPATA',
        distritos: [
          {
            codigo: 170102,
            nombre: 'INAMBARI',
            ubigeo: 170102
          },
          {
            codigo: 170104,
            nombre: 'LABERINTO',
            ubigeo: 170104
          },
          {
            codigo: 170103,
            nombre: 'LAS PIEDRAS',
            ubigeo: 170103
          },
          {
            codigo: 170101,
            nombre: 'TAMBOPATA',
            ubigeo: 170101
          }
        ]
      }
    ]
  },
  {
    codigo: 18,
    nombre: 'MOQUEGUA',
    provincias: [
      {
        codigo: 1802,
        nombre: 'GENERAL SANCHEZ',
        distritos: [
          {
            codigo: 180202,
            nombre: 'CHOJATA',
            ubigeo: 180202
          },
          {
            codigo: 180203,
            nombre: 'COALAQUE',
            ubigeo: 180203
          },
          {
            codigo: 180204,
            nombre: 'ICHUÑA',
            ubigeo: 180204
          },
          {
            codigo: 180205,
            nombre: 'LA CAPILLA',
            ubigeo: 180205
          },
          {
            codigo: 180206,
            nombre: 'LLOQUE',
            ubigeo: 180206
          },
          {
            codigo: 180207,
            nombre: 'MATALAQUE',
            ubigeo: 180207
          },
          {
            codigo: 180201,
            nombre: 'OMATE',
            ubigeo: 180201
          },
          {
            codigo: 180208,
            nombre: 'PUQUINA',
            ubigeo: 180208
          },
          {
            codigo: 180209,
            nombre: 'QUINISTAQUILLAS',
            ubigeo: 180209
          },
          {
            codigo: 180210,
            nombre: 'UBINAS',
            ubigeo: 180210
          },
          {
            codigo: 180211,
            nombre: 'YUNGA',
            ubigeo: 180211
          }
        ]
      },
      {
        codigo: 1803,
        nombre: 'ILO',
        distritos: [
          {
            codigo: 180302,
            nombre: 'EL ALGARROBAL',
            ubigeo: 180302
          },
          {
            codigo: 180301,
            nombre: 'ILO',
            ubigeo: 180301
          },
          {
            codigo: 180303,
            nombre: 'PACOCHA',
            ubigeo: 180303
          }
        ]
      },
      {
        codigo: 1801,
        nombre: 'MARISCAL NIETO',
        distritos: [
          {
            codigo: 180102,
            nombre: 'CARUMAS',
            ubigeo: 180102
          },
          {
            codigo: 180103,
            nombre: 'CUCHUMBAYA',
            ubigeo: 180103
          },
          {
            codigo: 180101,
            nombre: 'MOQUEGUA',
            ubigeo: 180101
          },
          {
            codigo: 180104,
            nombre: 'SAMEGUA',
            ubigeo: 180104
          },
          {
            codigo: 180105,
            nombre: 'SAN CRISTOBAL',
            ubigeo: 180105
          },
          {
            codigo: 180106,
            nombre: 'TORATA',
            ubigeo: 180106
          }
        ]
      }
    ]
  },
  {
    codigo: 19,
    nombre: 'PASCO',
    provincias: [
      {
        codigo: 1902,
        nombre: 'DANIEL ALCIDES',
        distritos: [
          {
            codigo: 190202,
            nombre: 'CHACAYAN',
            ubigeo: 190202
          },
          {
            codigo: 190203,
            nombre: 'GOYLLARISQUIZGA',
            ubigeo: 190203
          },
          {
            codigo: 190204,
            nombre: 'PAUCAR',
            ubigeo: 190204
          },
          {
            codigo: 190205,
            nombre: 'SAN PEDRO DE PI',
            ubigeo: 190205
          },
          {
            codigo: 190206,
            nombre: 'SANTA ANA DE TU',
            ubigeo: 190206
          },
          {
            codigo: 190207,
            nombre: 'TAPUC',
            ubigeo: 190207
          },
          {
            codigo: 190208,
            nombre: 'VILCABAMBA',
            ubigeo: 190208
          },
          {
            codigo: 190201,
            nombre: 'YANAHUANCA',
            ubigeo: 190201
          }
        ]
      },
      {
        codigo: 1903,
        nombre: 'OXAPAMPA',
        distritos: [
          {
            codigo: 190302,
            nombre: 'CHONTABAMBA',
            ubigeo: 190302
          },
          {
            codigo: 190303,
            nombre: 'HUANCABAMBA',
            ubigeo: 190303
          },
          {
            codigo: 190301,
            nombre: 'OXAPAMPA',
            ubigeo: 190301
          },
          {
            codigo: 190304,
            nombre: 'PALCAZU',
            ubigeo: 190304
          },
          {
            codigo: 190305,
            nombre: 'POZUZO',
            ubigeo: 190305
          },
          {
            codigo: 190306,
            nombre: 'PUERTO BERMUDEZ',
            ubigeo: 190306
          },
          {
            codigo: 190307,
            nombre: 'VILLA RICA',
            ubigeo: 190307
          }
        ]
      },
      {
        codigo: 1901,
        nombre: 'PASCO',
        distritos: [
          {
            codigo: 190101,
            nombre: 'CHAUPIMARCA',
            ubigeo: 190101
          },
          {
            codigo: 190102,
            nombre: 'HUACHON',
            ubigeo: 190102
          },
          {
            codigo: 190103,
            nombre: 'HUARIACA',
            ubigeo: 190103
          },
          {
            codigo: 190104,
            nombre: 'HUAYLLAY',
            ubigeo: 190104
          },
          {
            codigo: 190105,
            nombre: 'NINACACA',
            ubigeo: 190105
          },
          {
            codigo: 190106,
            nombre: 'PALLANCHACRA',
            ubigeo: 190106
          },
          {
            codigo: 190107,
            nombre: 'PAUCARTAMBO',
            ubigeo: 190107
          },
          {
            codigo: 190108,
            nombre: 'SAN FCO.DE ASIS',
            ubigeo: 190108
          },
          {
            codigo: 190109,
            nombre: 'SIMON BOLIVAR',
            ubigeo: 190109
          },
          {
            codigo: 190110,
            nombre: 'TICLACAYAN',
            ubigeo: 190110
          },
          {
            codigo: 190111,
            nombre: 'TINYAHUARCO',
            ubigeo: 190111
          },
          {
            codigo: 190112,
            nombre: 'VICCO',
            ubigeo: 190112
          },
          {
            codigo: 190113,
            nombre: 'YANACANCHA',
            ubigeo: 190113
          }
        ]
      }
    ]
  },
  {
    codigo: 20,
    nombre: 'PIURA',
    provincias: [
      {
        codigo: 2002,
        nombre: 'AYABACA',
        distritos: [
          {
            codigo: 200201,
            nombre: 'AYABACA',
            ubigeo: 200201
          },
          {
            codigo: 200202,
            nombre: 'FRIAS',
            ubigeo: 200202
          },
          {
            codigo: 200203,
            nombre: 'JILILI',
            ubigeo: 200203
          },
          {
            codigo: 200204,
            nombre: 'LAGUNAS',
            ubigeo: 200204
          },
          {
            codigo: 200205,
            nombre: 'MONTERO',
            ubigeo: 200205
          },
          {
            codigo: 200206,
            nombre: 'PACAIPAMPA',
            ubigeo: 200206
          },
          {
            codigo: 200207,
            nombre: 'PAIMAS',
            ubigeo: 200207
          },
          {
            codigo: 200208,
            nombre: 'SAPILLICA',
            ubigeo: 200208
          },
          {
            codigo: 200209,
            nombre: 'SICCHEZ',
            ubigeo: 200209
          },
          {
            codigo: 200210,
            nombre: 'SUYO',
            ubigeo: 200210
          }
        ]
      },
      {
        codigo: 2003,
        nombre: 'HUANCABAMBA',
        distritos: [
          {
            codigo: 200302,
            nombre: 'CANCHAQUE',
            ubigeo: 200302
          },
          {
            codigo: 200303,
            nombre: 'EL CARMEN/FRONTER',
            ubigeo: 200303
          },
          {
            codigo: 200301,
            nombre: 'HUANCABAMBA',
            ubigeo: 200301
          },
          {
            codigo: 200304,
            nombre: 'HUARMACA',
            ubigeo: 200304
          },
          {
            codigo: 200305,
            nombre: 'LALAQUIZ',
            ubigeo: 200305
          },
          {
            codigo: 200306,
            nombre: 'SAN MIGUEL/FAIQUE',
            ubigeo: 200306
          },
          {
            codigo: 200307,
            nombre: 'SONDOR',
            ubigeo: 200307
          },
          {
            codigo: 200308,
            nombre: 'SONDORILLO',
            ubigeo: 200308
          }
        ]
      },
      {
        codigo: 2004,
        nombre: 'MORROPON',
        distritos: [
          {
            codigo: 200402,
            nombre: 'BUENOS AIRES',
            ubigeo: 200402
          },
          {
            codigo: 200403,
            nombre: 'CHALACO',
            ubigeo: 200403
          },
          {
            codigo: 200401,
            nombre: 'CHULUCANAS',
            ubigeo: 200401
          },
          {
            codigo: 200404,
            nombre: 'LA MATANZA',
            ubigeo: 200404
          },
          {
            codigo: 200405,
            nombre: 'MORROPON',
            ubigeo: 200405
          },
          {
            codigo: 200406,
            nombre: 'SALITRAL',
            ubigeo: 200406
          },
          {
            codigo: 200407,
            nombre: 'SAN JUAN /BIGOTE',
            ubigeo: 200407
          },
          {
            codigo: 200409,
            nombre: 'SANTO DOMINGO',
            ubigeo: 200409
          },
          {
            codigo: 200408,
            nombre: 'STA.CATALINA/MOSS',
            ubigeo: 200408
          },
          {
            codigo: 200410,
            nombre: 'YAMANGO',
            ubigeo: 200410
          }
        ]
      },
      {
        codigo: 2005,
        nombre: 'PAITA',
        distritos: [
          {
            codigo: 200502,
            nombre: 'AMOTAPE',
            ubigeo: 200502
          },
          {
            codigo: 200503,
            nombre: 'ARENAL',
            ubigeo: 200503
          },
          {
            codigo: 200504,
            nombre: 'COLAN',
            ubigeo: 200504
          },
          {
            codigo: 200505,
            nombre: 'LA HUACA',
            ubigeo: 200505
          },
          {
            codigo: 200501,
            nombre: 'PAITA',
            ubigeo: 200501
          },
          {
            codigo: 200506,
            nombre: 'TAMARINDO',
            ubigeo: 200506
          },
          {
            codigo: 200507,
            nombre: 'VICHAYAL',
            ubigeo: 200507
          }
        ]
      },
      {
        codigo: 2001,
        nombre: 'PIURA',
        distritos: [
          {
            codigo: 200104,
            nombre: 'CASTILLA',
            ubigeo: 200104
          },
          {
            codigo: 200105,
            nombre: 'CATACAOS',
            ubigeo: 200105
          },
          {
            codigo: 200107,
            nombre: 'CURA MORI',
            ubigeo: 200107
          },
          {
            codigo: 200108,
            nombre: 'EL TALLAN',
            ubigeo: 200108
          },
          {
            codigo: 200109,
            nombre: 'LA ARENA',
            ubigeo: 200109
          },
          {
            codigo: 200110,
            nombre: 'LA UNION',
            ubigeo: 200110
          },
          {
            codigo: 200111,
            nombre: 'LAS LOMAS',
            ubigeo: 200111
          },
          {
            codigo: 200101,
            nombre: 'PIURA',
            ubigeo: 200101
          },
          {
            codigo: 200114,
            nombre: 'TAMBO GRANDE',
            ubigeo: 200114
          },
          {
            codigo: 200115,
            nombre: 'VEINTISEIS DE OCTUBRE',
            ubigeo: 200115
          }
        ]
      },
      {
        codigo: 2008,
        nombre: 'SECHURA',
        distritos: [
          {
            codigo: 200802,
            nombre: 'BELLAVISTA /UNION',
            ubigeo: 200802
          },
          {
            codigo: 200803,
            nombre: 'BERNAL',
            ubigeo: 200803
          },
          {
            codigo: 200804,
            nombre: 'CRISTO NOS VALGA',
            ubigeo: 200804
          },
          {
            codigo: 200806,
            nombre: 'RINCONADA LLICUAR',
            ubigeo: 200806
          },
          {
            codigo: 200801,
            nombre: 'SECHURA',
            ubigeo: 200801
          },
          {
            codigo: 200805,
            nombre: 'VICE',
            ubigeo: 200805
          }
        ]
      },
      {
        codigo: 2006,
        nombre: 'SULLANA',
        distritos: [
          {
            codigo: 200602,
            nombre: 'BELLAVISTA',
            ubigeo: 200602
          },
          {
            codigo: 200603,
            nombre: 'IGNACIO ESCUDERO',
            ubigeo: 200603
          },
          {
            codigo: 200604,
            nombre: 'LANCONES',
            ubigeo: 200604
          },
          {
            codigo: 200605,
            nombre: 'MARCAVELICA',
            ubigeo: 200605
          },
          {
            codigo: 200606,
            nombre: 'MIGUEL CHECA',
            ubigeo: 200606
          },
          {
            codigo: 200607,
            nombre: 'QUERECOTILLO',
            ubigeo: 200607
          },
          {
            codigo: 200608,
            nombre: 'SALITRAL',
            ubigeo: 200608
          },
          {
            codigo: 200601,
            nombre: 'SULLANA',
            ubigeo: 200601
          }
        ]
      },
      {
        codigo: 2007,
        nombre: 'TALARA',
        distritos: [
          {
            codigo: 200702,
            nombre: 'EL ALTO',
            ubigeo: 200702
          },
          {
            codigo: 200703,
            nombre: 'LA BREA',
            ubigeo: 200703
          },
          {
            codigo: 200704,
            nombre: 'LOBITOS',
            ubigeo: 200704
          },
          {
            codigo: 200705,
            nombre: 'LOS ORGANOS',
            ubigeo: 200705
          },
          {
            codigo: 200706,
            nombre: 'MANCORA',
            ubigeo: 200706
          },
          {
            codigo: 200701,
            nombre: 'PARIÑAS',
            ubigeo: 200701
          }
        ]
      }
    ]
  },
  {
    codigo: 21,
    nombre: 'PUNO',
    provincias: [
      {
        codigo: 2102,
        nombre: 'AZANGARO',
        distritos: [
          {
            codigo: 210202,
            nombre: 'ACHAYA',
            ubigeo: 210202
          },
          {
            codigo: 210203,
            nombre: 'ARAPA',
            ubigeo: 210203
          },
          {
            codigo: 210204,
            nombre: 'ASILLO',
            ubigeo: 210204
          },
          {
            codigo: 210201,
            nombre: 'AZANGARO',
            ubigeo: 210201
          },
          {
            codigo: 210205,
            nombre: 'CAMINACA',
            ubigeo: 210205
          },
          {
            codigo: 210206,
            nombre: 'CHUPA',
            ubigeo: 210206
          },
          {
            codigo: 210207,
            nombre: 'JOSE DOMINGO CH',
            ubigeo: 210207
          },
          {
            codigo: 210208,
            nombre: 'MUÑANI',
            ubigeo: 210208
          },
          {
            codigo: 210209,
            nombre: 'POTONI',
            ubigeo: 210209
          },
          {
            codigo: 210210,
            nombre: 'SAMAN',
            ubigeo: 210210
          },
          {
            codigo: 210211,
            nombre: 'SAN ANTON',
            ubigeo: 210211
          },
          {
            codigo: 210212,
            nombre: 'SAN JOSE',
            ubigeo: 210212
          },
          {
            codigo: 210213,
            nombre: 'SAN JUAN DE SAL',
            ubigeo: 210213
          },
          {
            codigo: 210214,
            nombre: 'SANTIAGO DE PUP',
            ubigeo: 210214
          },
          {
            codigo: 210215,
            nombre: 'TIRAPATA',
            ubigeo: 210215
          }
        ]
      },
      {
        codigo: 2103,
        nombre: 'CARABAYA',
        distritos: [
          {
            codigo: 210302,
            nombre: 'AJOYANI',
            ubigeo: 210302
          },
          {
            codigo: 210303,
            nombre: 'AYAPATA',
            ubigeo: 210303
          },
          {
            codigo: 210304,
            nombre: 'COASA',
            ubigeo: 210304
          },
          {
            codigo: 210305,
            nombre: 'CORANI',
            ubigeo: 210305
          },
          {
            codigo: 210306,
            nombre: 'CRUCERO',
            ubigeo: 210306
          },
          {
            codigo: 210307,
            nombre: 'ITUATA',
            ubigeo: 210307
          },
          {
            codigo: 210301,
            nombre: 'MACUSANI',
            ubigeo: 210301
          },
          {
            codigo: 210308,
            nombre: 'OLLACHEA',
            ubigeo: 210308
          },
          {
            codigo: 210309,
            nombre: 'SAN GABAN',
            ubigeo: 210309
          },
          {
            codigo: 210310,
            nombre: 'USICAYOS',
            ubigeo: 210310
          }
        ]
      },
      {
        codigo: 2104,
        nombre: 'CHUCUITO',
        distritos: [
          {
            codigo: 210402,
            nombre: 'DESAGUADERO',
            ubigeo: 210402
          },
          {
            codigo: 210403,
            nombre: 'HUACULLANI',
            ubigeo: 210403
          },
          {
            codigo: 210401,
            nombre: 'JULI',
            ubigeo: 210401
          },
          {
            codigo: 210404,
            nombre: 'KELLUYO',
            ubigeo: 210404
          },
          {
            codigo: 210405,
            nombre: 'PISACOMA',
            ubigeo: 210405
          },
          {
            codigo: 210406,
            nombre: 'POMATA',
            ubigeo: 210406
          },
          {
            codigo: 210407,
            nombre: 'ZEPITA',
            ubigeo: 210407
          }
        ]
      },
      {
        codigo: 2105,
        nombre: 'EL COLLAO',
        distritos: [
          {
            codigo: 210502,
            nombre: 'CAPAZO',
            ubigeo: 210502
          },
          {
            codigo: 210505,
            nombre: 'CONDURIRI',
            ubigeo: 210505
          },
          {
            codigo: 210501,
            nombre: 'ILAVE',
            ubigeo: 210501
          },
          {
            codigo: 210503,
            nombre: 'PILCUYO',
            ubigeo: 210503
          },
          {
            codigo: 210504,
            nombre: 'SANTA ROSA',
            ubigeo: 210504
          }
        ]
      },
      {
        codigo: 2106,
        nombre: 'HUANCANE',
        distritos: [
          {
            codigo: 210602,
            nombre: 'COJATA',
            ubigeo: 210602
          },
          {
            codigo: 210601,
            nombre: 'HUANCANE',
            ubigeo: 210601
          },
          {
            codigo: 210603,
            nombre: 'HUATASANI',
            ubigeo: 210603
          },
          {
            codigo: 210604,
            nombre: 'INCHUPALLA',
            ubigeo: 210604
          },
          {
            codigo: 210605,
            nombre: 'PUSI',
            ubigeo: 210605
          },
          {
            codigo: 210606,
            nombre: 'ROSASPATA',
            ubigeo: 210606
          },
          {
            codigo: 210607,
            nombre: 'TARACO',
            ubigeo: 210607
          },
          {
            codigo: 210608,
            nombre: 'VILQUE CHICO',
            ubigeo: 210608
          }
        ]
      },
      {
        codigo: 2107,
        nombre: 'LAMPA',
        distritos: [
          {
            codigo: 210702,
            nombre: 'CABANILLA',
            ubigeo: 210702
          },
          {
            codigo: 210703,
            nombre: 'CALAPUJA',
            ubigeo: 210703
          },
          {
            codigo: 210701,
            nombre: 'LAMPA',
            ubigeo: 210701
          },
          {
            codigo: 210704,
            nombre: 'NICASIO',
            ubigeo: 210704
          },
          {
            codigo: 210705,
            nombre: 'OCUVIRI',
            ubigeo: 210705
          },
          {
            codigo: 210706,
            nombre: 'PALCA',
            ubigeo: 210706
          },
          {
            codigo: 210707,
            nombre: 'PARATIA',
            ubigeo: 210707
          },
          {
            codigo: 210708,
            nombre: 'PUCARA',
            ubigeo: 210708
          },
          {
            codigo: 210709,
            nombre: 'SANTA LUCIA',
            ubigeo: 210709
          },
          {
            codigo: 210710,
            nombre: 'VILAVILA',
            ubigeo: 210710
          }
        ]
      },
      {
        codigo: 2108,
        nombre: 'MELGAR',
        distritos: [
          {
            codigo: 210802,
            nombre: 'ANTAUTA',
            ubigeo: 210802
          },
          {
            codigo: 210801,
            nombre: 'AYAVIRI',
            ubigeo: 210801
          },
          {
            codigo: 210803,
            nombre: 'CUPI',
            ubigeo: 210803
          },
          {
            codigo: 210804,
            nombre: 'LLALLI',
            ubigeo: 210804
          },
          {
            codigo: 210805,
            nombre: 'MACARI',
            ubigeo: 210805
          },
          {
            codigo: 210806,
            nombre: 'NUÑOA',
            ubigeo: 210806
          },
          {
            codigo: 210807,
            nombre: 'ORURILLO',
            ubigeo: 210807
          },
          {
            codigo: 210808,
            nombre: 'SANTA ROSA',
            ubigeo: 210808
          },
          {
            codigo: 210809,
            nombre: 'UMACHIRI',
            ubigeo: 210809
          }
        ]
      },
      {
        codigo: 2109,
        nombre: 'MOHO',
        distritos: [
          {
            codigo: 210902,
            nombre: 'CONIMA',
            ubigeo: 210902
          },
          {
            codigo: 210903,
            nombre: 'HUAYRAPATA',
            ubigeo: 210903
          },
          {
            codigo: 210901,
            nombre: 'MOHO',
            ubigeo: 210901
          },
          {
            codigo: 210904,
            nombre: 'TILALI',
            ubigeo: 210904
          }
        ]
      },
      {
        codigo: 2101,
        nombre: 'PUNO',
        distritos: [
          {
            codigo: 210102,
            nombre: 'ACORA',
            ubigeo: 210102
          },
          {
            codigo: 210103,
            nombre: 'AMANTANI',
            ubigeo: 210103
          },
          {
            codigo: 210104,
            nombre: 'ATUNCOLLA',
            ubigeo: 210104
          },
          {
            codigo: 210105,
            nombre: 'CAPACHICA',
            ubigeo: 210105
          },
          {
            codigo: 210106,
            nombre: 'CHUCUITO',
            ubigeo: 210106
          },
          {
            codigo: 210107,
            nombre: 'COATA',
            ubigeo: 210107
          },
          {
            codigo: 210108,
            nombre: 'HUATA',
            ubigeo: 210108
          },
          {
            codigo: 210109,
            nombre: 'MAÑAZO',
            ubigeo: 210109
          },
          {
            codigo: 210110,
            nombre: 'PAUCARCOLLA',
            ubigeo: 210110
          },
          {
            codigo: 210111,
            nombre: 'PICHACANI',
            ubigeo: 210111
          },
          {
            codigo: 210112,
            nombre: 'PLATERIA',
            ubigeo: 210112
          },
          {
            codigo: 210101,
            nombre: 'PUNO',
            ubigeo: 210101
          },
          {
            codigo: 210113,
            nombre: 'SAN ANTONIO',
            ubigeo: 210113
          },
          {
            codigo: 210114,
            nombre: 'TIQUILLACA',
            ubigeo: 210114
          },
          {
            codigo: 210115,
            nombre: 'VILQUE',
            ubigeo: 210115
          }
        ]
      },
      {
        codigo: 2110,
        nombre: 'SAN ANTONIO DE',
        distritos: [
          {
            codigo: 211002,
            nombre: 'ANANEA',
            ubigeo: 211002
          },
          {
            codigo: 211003,
            nombre: 'PEDRO VILCA APA',
            ubigeo: 211003
          },
          {
            codigo: 211001,
            nombre: 'PUTINA',
            ubigeo: 211001
          },
          {
            codigo: 211004,
            nombre: 'QUILCAPUNCU',
            ubigeo: 211004
          },
          {
            codigo: 211005,
            nombre: 'SINA',
            ubigeo: 211005
          }
        ]
      },
      {
        codigo: 2111,
        nombre: 'SAN ROMAN',
        distritos: [
          {
            codigo: 211102,
            nombre: 'CABANA',
            ubigeo: 211102
          },
          {
            codigo: 211103,
            nombre: 'CABANILLAS',
            ubigeo: 211103
          },
          {
            codigo: 211104,
            nombre: 'CARACOTO',
            ubigeo: 211104
          },
          {
            codigo: 211101,
            nombre: 'JULIACA',
            ubigeo: 211101
          }
        ]
      },
      {
        codigo: 2112,
        nombre: 'SANDIA',
        distritos: [
          {
            codigo: 211209,
            nombre: 'ALTO INAMBARI',
            ubigeo: 211209
          },
          {
            codigo: 211202,
            nombre: 'CUYOCUYO',
            ubigeo: 211202
          },
          {
            codigo: 211203,
            nombre: 'LIMBANI',
            ubigeo: 211203
          },
          {
            codigo: 211204,
            nombre: 'PATAMBUCO',
            ubigeo: 211204
          },
          {
            codigo: 211205,
            nombre: 'PHARA',
            ubigeo: 211205
          },
          {
            codigo: 211206,
            nombre: 'QUIACA',
            ubigeo: 211206
          },
          {
            codigo: 211207,
            nombre: 'SAN JUAN DEL OR',
            ubigeo: 211207
          },
          {
            codigo: 211201,
            nombre: 'SANDIA',
            ubigeo: 211201
          },
          {
            codigo: 211208,
            nombre: 'YANAHUAYA',
            ubigeo: 211208
          }
        ]
      },
      {
        codigo: 2113,
        nombre: 'YUNGUYO',
        distritos: [
          {
            codigo: 211302,
            nombre: 'ANAPIA',
            ubigeo: 211302
          },
          {
            codigo: 211303,
            nombre: 'COPANI',
            ubigeo: 211303
          },
          {
            codigo: 211304,
            nombre: 'CUTURAPI',
            ubigeo: 211304
          },
          {
            codigo: 211305,
            nombre: 'OLLARAYA',
            ubigeo: 211305
          },
          {
            codigo: 211306,
            nombre: 'TINICACHI',
            ubigeo: 211306
          },
          {
            codigo: 211307,
            nombre: 'UNICACHI',
            ubigeo: 211307
          },
          {
            codigo: 211301,
            nombre: 'YUNGUYO',
            ubigeo: 211301
          }
        ]
      }
    ]
  },
  {
    codigo: 22,
    nombre: 'SAN MARTIN',
    provincias: [
      {
        codigo: 2202,
        nombre: 'BELLAVISTA',
        distritos: [
          {
            codigo: 220202,
            nombre: 'ALTO BIAVO',
            ubigeo: 220202
          },
          {
            codigo: 220203,
            nombre: 'BAJO BIAVO',
            ubigeo: 220203
          },
          {
            codigo: 220201,
            nombre: 'BELLAVISTA',
            ubigeo: 220201
          },
          {
            codigo: 220204,
            nombre: 'HUALLAGA',
            ubigeo: 220204
          },
          {
            codigo: 220205,
            nombre: 'SAN PABLO',
            ubigeo: 220205
          },
          {
            codigo: 220206,
            nombre: 'SAN RAFAEL',
            ubigeo: 220206
          }
        ]
      },
      {
        codigo: 2203,
        nombre: 'EL DORADO',
        distritos: [
          {
            codigo: 220302,
            nombre: 'AGUA BLANCA',
            ubigeo: 220302
          },
          {
            codigo: 220301,
            nombre: 'SAN JOSE DE SIS',
            ubigeo: 220301
          },
          {
            codigo: 220303,
            nombre: 'SAN MARTIN',
            ubigeo: 220303
          },
          {
            codigo: 220304,
            nombre: 'SANTA ROSA',
            ubigeo: 220304
          },
          {
            codigo: 220305,
            nombre: 'SHATOJA',
            ubigeo: 220305
          }
        ]
      },
      {
        codigo: 2204,
        nombre: 'HUALLAGA',
        distritos: [
          {
            codigo: 220402,
            nombre: 'ALTO SAPOSOA',
            ubigeo: 220402
          },
          {
            codigo: 220403,
            nombre: 'EL ESLABON',
            ubigeo: 220403
          },
          {
            codigo: 220404,
            nombre: 'PISCOYACU',
            ubigeo: 220404
          },
          {
            codigo: 220405,
            nombre: 'SACANCHE',
            ubigeo: 220405
          },
          {
            codigo: 220401,
            nombre: 'SAPOSOA',
            ubigeo: 220401
          },
          {
            codigo: 220406,
            nombre: 'TINGO DE SAPOSO',
            ubigeo: 220406
          }
        ]
      },
      {
        codigo: 2205,
        nombre: 'LAMAS',
        distritos: [
          {
            codigo: 220502,
            nombre: 'ALONSO DE ALVAR',
            ubigeo: 220502
          },
          {
            codigo: 220503,
            nombre: 'BARRANQUITA',
            ubigeo: 220503
          },
          {
            codigo: 220504,
            nombre: 'CAYNARACHI',
            ubigeo: 220504
          },
          {
            codigo: 220505,
            nombre: 'CUÑUMBUQUI',
            ubigeo: 220505
          },
          {
            codigo: 220501,
            nombre: 'LAMAS',
            ubigeo: 220501
          },
          {
            codigo: 220506,
            nombre: 'PINTO RECODO',
            ubigeo: 220506
          },
          {
            codigo: 220507,
            nombre: 'RUMISAPA',
            ubigeo: 220507
          },
          {
            codigo: 220508,
            nombre: 'SAN ROQUE DE CU',
            ubigeo: 220508
          },
          {
            codigo: 220509,
            nombre: 'SHANAO',
            ubigeo: 220509
          },
          {
            codigo: 220510,
            nombre: 'TABALOSOS',
            ubigeo: 220510
          },
          {
            codigo: 220511,
            nombre: 'ZAPATERO',
            ubigeo: 220511
          }
        ]
      },
      {
        codigo: 2206,
        nombre: 'MARISCAL CACERE',
        distritos: [
          {
            codigo: 220602,
            nombre: 'CAMPANILLA',
            ubigeo: 220602
          },
          {
            codigo: 220603,
            nombre: 'HUICUNGO',
            ubigeo: 220603
          },
          {
            codigo: 220601,
            nombre: 'JUANJUI',
            ubigeo: 220601
          },
          {
            codigo: 220604,
            nombre: 'PACHIZA',
            ubigeo: 220604
          },
          {
            codigo: 220605,
            nombre: 'PAJARILLO',
            ubigeo: 220605
          }
        ]
      },
      {
        codigo: 2201,
        nombre: 'MOYOBAMBA',
        distritos: [
          {
            codigo: 220102,
            nombre: 'CALZADA',
            ubigeo: 220102
          },
          {
            codigo: 220103,
            nombre: 'HABANA',
            ubigeo: 220103
          },
          {
            codigo: 220104,
            nombre: 'JEPELACIO',
            ubigeo: 220104
          },
          {
            codigo: 220101,
            nombre: 'MOYOBAMBA',
            ubigeo: 220101
          },
          {
            codigo: 220105,
            nombre: 'SORITOR',
            ubigeo: 220105
          },
          {
            codigo: 220106,
            nombre: 'YANTALO',
            ubigeo: 220106
          }
        ]
      },
      {
        codigo: 2207,
        nombre: 'PICOTA',
        distritos: [
          {
            codigo: 220702,
            nombre: 'BUENOS AIRES',
            ubigeo: 220702
          },
          {
            codigo: 220703,
            nombre: 'CASPISAPA',
            ubigeo: 220703
          },
          {
            codigo: 220701,
            nombre: 'PICOTA',
            ubigeo: 220701
          },
          {
            codigo: 220704,
            nombre: 'PILLUANA',
            ubigeo: 220704
          },
          {
            codigo: 220705,
            nombre: 'PUCACACA',
            ubigeo: 220705
          },
          {
            codigo: 220706,
            nombre: 'SAN CRISTOBAL',
            ubigeo: 220706
          },
          {
            codigo: 220707,
            nombre: 'SAN HILARION',
            ubigeo: 220707
          },
          {
            codigo: 220708,
            nombre: 'SHAMBOYACU',
            ubigeo: 220708
          },
          {
            codigo: 220709,
            nombre: 'TINGO DE PONASA',
            ubigeo: 220709
          },
          {
            codigo: 220710,
            nombre: 'TRES UNIDOS',
            ubigeo: 220710
          }
        ]
      },
      {
        codigo: 2208,
        nombre: 'RIOJA',
        distritos: [
          {
            codigo: 220802,
            nombre: 'AWAJUN',
            ubigeo: 220802
          },
          {
            codigo: 220803,
            nombre: 'ELIAS SOPLIN VA',
            ubigeo: 220803
          },
          {
            codigo: 220804,
            nombre: 'NUEVA CAJAMARCA',
            ubigeo: 220804
          },
          {
            codigo: 220805,
            nombre: 'PARDO MIGUEL',
            ubigeo: 220805
          },
          {
            codigo: 220806,
            nombre: 'POSIC',
            ubigeo: 220806
          },
          {
            codigo: 220801,
            nombre: 'RIOJA',
            ubigeo: 220801
          },
          {
            codigo: 220807,
            nombre: 'SAN FERNANDO',
            ubigeo: 220807
          },
          {
            codigo: 220808,
            nombre: 'YORONGOS',
            ubigeo: 220808
          },
          {
            codigo: 220809,
            nombre: 'YURACYACU',
            ubigeo: 220809
          }
        ]
      },
      {
        codigo: 2209,
        nombre: 'SAN MARTIN',
        distritos: [
          {
            codigo: 220902,
            nombre: 'ALBERTO LEVEAU',
            ubigeo: 220902
          },
          {
            codigo: 220903,
            nombre: 'CACATACHI',
            ubigeo: 220903
          },
          {
            codigo: 220904,
            nombre: 'CHAZUTA',
            ubigeo: 220904
          },
          {
            codigo: 220905,
            nombre: 'CHIPURANA',
            ubigeo: 220905
          },
          {
            codigo: 220906,
            nombre: 'EL PORVENIR',
            ubigeo: 220906
          },
          {
            codigo: 220907,
            nombre: 'HUIMBAYOC',
            ubigeo: 220907
          },
          {
            codigo: 220908,
            nombre: 'JUAN GUERRA',
            ubigeo: 220908
          },
          {
            codigo: 220909,
            nombre: 'LA BANDA DE SHI',
            ubigeo: 220909
          },
          {
            codigo: 220910,
            nombre: 'MORALES',
            ubigeo: 220910
          },
          {
            codigo: 220911,
            nombre: 'PAPAPLAYA',
            ubigeo: 220911
          },
          {
            codigo: 220912,
            nombre: 'SAN ANTONIO',
            ubigeo: 220912
          },
          {
            codigo: 220913,
            nombre: 'SAUCE',
            ubigeo: 220913
          },
          {
            codigo: 220914,
            nombre: 'SHAPAJA',
            ubigeo: 220914
          },
          {
            codigo: 220901,
            nombre: 'TARAPOTO',
            ubigeo: 220901
          }
        ]
      },
      {
        codigo: 2210,
        nombre: 'TOCACHE',
        distritos: [
          {
            codigo: 221002,
            nombre: 'NUEVO PROGRESO',
            ubigeo: 221002
          },
          {
            codigo: 221003,
            nombre: 'POLVORA',
            ubigeo: 221003
          },
          {
            codigo: 221004,
            nombre: 'SHUNTE',
            ubigeo: 221004
          },
          {
            codigo: 221001,
            nombre: 'TOCACHE',
            ubigeo: 221001
          },
          {
            codigo: 221005,
            nombre: 'UCHIZA',
            ubigeo: 221005
          }
        ]
      }
    ]
  },
  {
    codigo: 23,
    nombre: 'TACNA',
    provincias: [
      {
        codigo: 2302,
        nombre: 'CANDARAVE',
        distritos: [
          {
            codigo: 230202,
            nombre: 'CAIRANI',
            ubigeo: 230202
          },
          {
            codigo: 230203,
            nombre: 'CAMILACA',
            ubigeo: 230203
          },
          {
            codigo: 230201,
            nombre: 'CANDARAVE',
            ubigeo: 230201
          },
          {
            codigo: 230204,
            nombre: 'CURIBAYA',
            ubigeo: 230204
          },
          {
            codigo: 230205,
            nombre: 'HUANUARA',
            ubigeo: 230205
          },
          {
            codigo: 230206,
            nombre: 'QUILAHUANI',
            ubigeo: 230206
          }
        ]
      },
      {
        codigo: 2303,
        nombre: 'JORGE BASADRE',
        distritos: [
          {
            codigo: 230302,
            nombre: 'ILABAYA',
            ubigeo: 230302
          },
          {
            codigo: 230303,
            nombre: 'ITE',
            ubigeo: 230303
          },
          {
            codigo: 230301,
            nombre: 'LOCUMBA',
            ubigeo: 230301
          }
        ]
      },
      {
        codigo: 2301,
        nombre: 'TACNA',
        distritos: [
          {
            codigo: 230102,
            nombre: 'ALTO DE LA ALIA',
            ubigeo: 230102
          },
          {
            codigo: 230103,
            nombre: 'CALANA',
            ubigeo: 230103
          },
          {
            codigo: 230104,
            nombre: 'CIUDAD NUEVA',
            ubigeo: 230104
          },
          {
            codigo: 230110,
            nombre: 'CORONEL GREGORI',
            ubigeo: 230110
          },
          {
            codigo: 230105,
            nombre: 'INCLAN',
            ubigeo: 230105
          },
          {
            codigo: 230106,
            nombre: 'PACHIA',
            ubigeo: 230106
          },
          {
            codigo: 230107,
            nombre: 'PALCA',
            ubigeo: 230107
          },
          {
            codigo: 230108,
            nombre: 'POCOLLAY',
            ubigeo: 230108
          },
          {
            codigo: 230109,
            nombre: 'SAMA',
            ubigeo: 230109
          },
          {
            codigo: 230101,
            nombre: 'TACNA',
            ubigeo: 230101
          }
        ]
      },
      {
        codigo: 2304,
        nombre: 'TARATA',
        distritos: [
          {
            codigo: 230402,
            nombre: 'CHUCATAMANI',
            ubigeo: 230402
          },
          {
            codigo: 230403,
            nombre: 'ESTIQUE',
            ubigeo: 230403
          },
          {
            codigo: 230404,
            nombre: 'ESTIQUE-PAMPA',
            ubigeo: 230404
          },
          {
            codigo: 230405,
            nombre: 'SITAJARA',
            ubigeo: 230405
          },
          {
            codigo: 230406,
            nombre: 'SUSAPAYA',
            ubigeo: 230406
          },
          {
            codigo: 230401,
            nombre: 'TARATA',
            ubigeo: 230401
          },
          {
            codigo: 230407,
            nombre: 'TARUCACHI',
            ubigeo: 230407
          },
          {
            codigo: 230408,
            nombre: 'TICACO',
            ubigeo: 230408
          }
        ]
      }
    ]
  },
  {
    codigo: 24,
    nombre: 'TUMBES',
    provincias: [
      {
        codigo: 2402,
        nombre: 'CONTRALMIRANTE',
        distritos: [
          {
            codigo: 240202,
            nombre: 'CASITAS',
            ubigeo: 240202
          },
          {
            codigo: 240201,
            nombre: 'ZORRITOS',
            ubigeo: 240201
          }
        ]
      },
      {
        codigo: 2401,
        nombre: 'TUMBES',
        distritos: [
          {
            codigo: 240102,
            nombre: 'CORRALES',
            ubigeo: 240102
          },
          {
            codigo: 240103,
            nombre: 'LA CRUZ',
            ubigeo: 240103
          },
          {
            codigo: 240104,
            nombre: 'PAMPAS DE HOSPI',
            ubigeo: 240104
          },
          {
            codigo: 240105,
            nombre: 'SAN JACINTO',
            ubigeo: 240105
          },
          {
            codigo: 240106,
            nombre: 'SAN JUAN DE LA',
            ubigeo: 240106
          },
          {
            codigo: 240101,
            nombre: 'TUMBES',
            ubigeo: 240101
          }
        ]
      },
      {
        codigo: 2403,
        nombre: 'ZARUMILLA',
        distritos: [
          {
            codigo: 240302,
            nombre: 'AGUAS VERDES',
            ubigeo: 240302
          },
          {
            codigo: 240303,
            nombre: 'MATAPALO',
            ubigeo: 240303
          },
          {
            codigo: 240304,
            nombre: 'PAPAYAL',
            ubigeo: 240304
          },
          {
            codigo: 240301,
            nombre: 'ZARUMILLA',
            ubigeo: 240301
          }
        ]
      }
    ]
  },
  {
    codigo: 25,
    nombre: 'UCAYALI',
    provincias: [
      {
        codigo: 2502,
        nombre: 'ATALAYA',
        distritos: [
          {
            codigo: 250201,
            nombre: 'RAYMONDI',
            ubigeo: 250201
          },
          {
            codigo: 250202,
            nombre: 'SEPAHUA',
            ubigeo: 250202
          },
          {
            codigo: 250203,
            nombre: 'TAHUANIA',
            ubigeo: 250203
          },
          {
            codigo: 250204,
            nombre: 'YURUA',
            ubigeo: 250204
          }
        ]
      },
      {
        codigo: 2501,
        nombre: 'CROL PORTILL',
        distritos: [
          {
            codigo: 250101,
            nombre: 'CALLERIA',
            ubigeo: 250101
          },
          {
            codigo: 250102,
            nombre: 'CAMPOVERDE',
            ubigeo: 250102
          },
          {
            codigo: 250103,
            nombre: 'IPARIA',
            ubigeo: 250103
          },
          {
            codigo: 250107,
            nombre: 'MANANTAY',
            ubigeo: 250107
          },
          {
            codigo: 250104,
            nombre: 'MASISEA',
            ubigeo: 250104
          },
          {
            codigo: 250106,
            nombre: 'NUEVA REQUENA',
            ubigeo: 250106
          },
          {
            codigo: 250105,
            nombre: 'YARINACOCHA',
            ubigeo: 250105
          }
        ]
      },
      {
        codigo: 2503,
        nombre: 'PADRE ABAD',
        distritos: [
          {
            codigo: 250303,
            nombre: 'CURIMANA',
            ubigeo: 250303
          },
          {
            codigo: 250302,
            nombre: 'IRAZOLA',
            ubigeo: 250302
          },
          {
            codigo: 250301,
            nombre: 'PADRE ABAD',
            ubigeo: 250301
          }
        ]
      },
      {
        codigo: 2504,
        nombre: 'PURUS',
        distritos: [
          {
            codigo: 250401,
            nombre: 'PURUS',
            ubigeo: 250401
          }
        ]
      }
    ]
  }
];
